import * as n from "react";
import { Component as er, useState as S, useRef as q, useEffect as G, useLayoutEffect as je, isValidElement as on, cloneElement as na, forwardRef as Fr, useContext as xn, createContext as Dn, useMemo as we, useCallback as le, Fragment as Wr, Children as Kn, createRef as Hr } from "react";
import { createPortal as Kr } from "react-dom";
const Ur = "_page_1f94v_5", Yr = "_inner_1f94v_18", da = {
  page: Ur,
  inner: Yr
};
function wE({
  gnbHeight: e = 64,
  minWidth: t = 1024,
  className: a = "",
  style: r,
  children: o
}) {
  return /* @__PURE__ */ n.createElement(
    "main",
    {
      className: [da.page, "axe-page", a].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...r }
    },
    /* @__PURE__ */ n.createElement("div", { className: da.inner, style: { minWidth: t } }, o)
  );
}
const Gr = "_orbitPortalRoot_177qv_2", Vr = {
  orbitPortalRoot: Gr
};
class Kt extends er {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const t = this.props.portalClassName || Vr.orbitPortalRoot, a = Array.from(document.body.childNodes).find((r) => r.className === t);
      if (!a) {
        const r = document.createElement("div");
        return r.className = t, document.body.appendChild(r), r;
      }
      return a;
    };
  }
  render() {
    return Kr(this.props.children, this.getPortalRoot());
  }
}
const Jr = "_anchor_7h2m7_2", Qr = "_tip_7h2m7_5", _a = {
  anchor: Jr,
  tip: Qr
};
let Zr = 0;
function Bt({
  content: e,
  children: t,
  placement: a = "bottom",
  delay: r = 250,
  focusable: o,
  describe: s = !0,
  className: l = "",
  keepWrapper: c
}) {
  const [i, m] = S(!1), [u, d] = S({ top: 0, left: 0 }), p = q(null), f = q(null), y = q(null), _ = q("");
  _.current || (_.current = `axe-tip-${++Zr}`);
  const b = () => {
    y.current && (clearTimeout(y.current), y.current = null);
  }, $ = (E) => {
    b(), E <= 0 ? m(!0) : y.current = setTimeout(() => m(!0), E);
  }, k = () => {
    b(), m(!1);
  };
  G(() => b, []), je(() => {
    if (!i) return;
    const E = () => {
      const g = p.current, h = f.current;
      if (!g || !h) return;
      const N = g.getBoundingClientRect(), D = h.offsetHeight, j = h.offsetWidth;
      let B = a === "top" ? N.top - D - 6 : N.bottom + 6;
      a === "bottom" && B + D > window.innerHeight - 4 && N.top - D - 6 > 4 && (B = N.top - D - 6), a === "top" && B < 4 && N.bottom + 6 + D < window.innerHeight - 4 && (B = N.bottom + 6);
      const I = Math.max(4, Math.min(N.left + N.width / 2 - j / 2, window.innerWidth - j - 4));
      d((T) => T.top === B && T.left === I ? T : { top: B, left: I });
    };
    return E(), window.addEventListener("resize", E), window.addEventListener("scroll", E, !0), () => {
      window.removeEventListener("resize", E), window.removeEventListener("scroll", E, !0);
    };
  }, [i, a, e]), G(() => {
    if (!i) return;
    const E = (g) => {
      g.key !== "Escape" || g.isComposing || (g.preventDefault(), g.stopPropagation(), k());
    };
    return document.addEventListener("keydown", E, !0), () => document.removeEventListener("keydown", E, !0);
  }, [i]);
  const w = e != null && e !== !1 && e !== "";
  if (!w && !c) return t;
  const x = w && on(t) ? na(t, i && s ? { "aria-describedby": _.current } : {}) : t;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      ref: p,
      className: [_a.anchor, l].filter(Boolean).join(" "),
      tabIndex: o ? 0 : void 0,
      onMouseEnter: () => {
        w && $(r);
      },
      onMouseLeave: k,
      onFocus: () => {
        w && $(0);
      },
      onBlur: k
    },
    x,
    w && i && /* @__PURE__ */ n.createElement(Kt, null, /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: f,
        id: _.current,
        role: "tooltip",
        className: _a.tip,
        style: { top: u.top, left: u.left },
        onMouseEnter: b,
        onMouseLeave: k
      },
      e
    ))
  );
}
const eo = "_bar_bhn0l_1", to = "_menu_bhn0l_9", no = "_title_bhn0l_19", ao = "_info_bhn0l_21", ro = "_badge_bhn0l_29", oo = "_badge_muted_bhn0l_30", so = "_badge_ok_bhn0l_31", lo = "_badge_warn_bhn0l_32", co = "_meta_bhn0l_34", io = "_actions_bhn0l_18", uo = "_notice_bhn0l_51", mo = "_notice_info_bhn0l_57", _o = "_notice_ok_bhn0l_58", fo = "_notice_err_bhn0l_59", Ge = {
  bar: eo,
  menu: to,
  title: no,
  info: ao,
  badge: ro,
  badge_muted: oo,
  badge_ok: so,
  badge_warn: lo,
  meta: co,
  actions: io,
  notice: uo,
  notice_info: mo,
  notice_ok: _o,
  notice_err: fo
};
function NE({
  title: e,
  onMenu: t,
  info: a,
  badge: r,
  meta: o,
  notice: s,
  children: l
}) {
  var c;
  return /* @__PURE__ */ n.createElement("header", { className: Ge.bar }, t && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ge.menu, "aria-label": "메뉴", onClick: t }, "☰"), /* @__PURE__ */ n.createElement("h1", { className: Ge.title }, e), a && /* @__PURE__ */ n.createElement(Bt, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: Ge.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(r) ? r : [r]).filter(Boolean).map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("span", { key: m, className: [Ge.badge, Ge[`badge_${(u = i.tone) != null ? u : "muted"}`]].join(" ") }, i.label);
  }), o && /* @__PURE__ */ n.createElement("span", { className: Ge.meta }, o), /* @__PURE__ */ n.createElement("span", { className: Ge.actions }, s && s.text && /* @__PURE__ */ n.createElement("span", { className: [Ge.notice, Ge[`notice_${(c = s.tone) != null ? c : "info"}`]].join(" "), role: s.tone === "err" ? "alert" : "status" }, s.text), l));
}
const po = "_btn_a0orf_1", yo = "_sm_a0orf_18", bo = "_primary_a0orf_21", ho = "_dark_a0orf_23", go = "_danger_a0orf_25", Eo = "_soon_a0orf_29", vo = "_soonTag_a0orf_30", ko = "_blocked_a0orf_39", wo = "_kbd_a0orf_51", No = "_iconBtn_a0orf_54", $o = "_link_a0orf_70", ut = {
  btn: po,
  sm: yo,
  primary: bo,
  dark: ho,
  danger: go,
  soon: Eo,
  soonTag: vo,
  blocked: ko,
  kbd: wo,
  iconBtn: No,
  link: $o
}, Ft = Fr(function(t, a) {
  const {
    variant: r = "default",
    size: o = "md",
    kbd: s,
    soon: l,
    blockedReason: c,
    children: i,
    className: m = "",
    type: u = "button",
    onClick: d,
    title: p,
    disabled: f,
    ...y
  } = t, _ = l || c || "", b = _ !== "", $ = "blockedReason" in t, k = /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: a,
      type: u,
      className: [ut.btn, ut[r], o === "sm" ? ut.sm : "", l ? ut.soon : b ? ut.blocked : "", m].filter(Boolean).join(" "),
      "aria-disabled": b ? !0 : void 0,
      disabled: b ? void 0 : f,
      title: b ? void 0 : p,
      onClick: b ? (w) => w.preventDefault() : d,
      ...y
    },
    i,
    s && /* @__PURE__ */ n.createElement("kbd", { className: ut.kbd }, s),
    l && /* @__PURE__ */ n.createElement("em", { className: ut.soonTag }, "준비 중")
  );
  return b || $ ? /* @__PURE__ */ n.createElement(Bt, { content: _, keepWrapper: $ }, k) : k;
});
function Un({ label: e, children: t, className: a = "", type: r = "button", ...o }) {
  return /* @__PURE__ */ n.createElement(Bt, { content: e, describe: !1 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: r,
      className: [ut.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...o
    },
    t
  ));
}
function aa({ children: e, className: t = "", type: a = "button", ...r }) {
  return /* @__PURE__ */ n.createElement("button", { type: a, className: [ut.link, t].filter(Boolean).join(" "), ...r }, e);
}
const xo = "_wrap_10shm_1", Do = "_btn_10shm_2", Co = "_on_10shm_6", Ao = "_caret_10shm_8", So = "_pop_10shm_9", Mo = "_sec_10shm_14", To = "_item_10shm_17", Bo = "_danger_10shm_24", ft = {
  wrap: xo,
  btn: Do,
  on: Co,
  caret: Ao,
  pop: So,
  sec: Mo,
  item: To,
  danger: Bo
}, jo = (e, t, a, r = {}) => ({ kind: "item", key: e, label: t, onClick: a, ...r }), $E = (e, t, a) => ({ kind: "section", key: e, label: t, note: a });
function Lo({ label: e, entries: t, disabled: a, title: r }) {
  const [o, s] = S(!1), l = q(null), c = q(null), i = q(null), m = () => {
    var d, p;
    return Array.from((p = (d = i.current) == null ? void 0 : d.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? p : []);
  };
  G(() => {
    var d;
    o && ((d = m()[0]) == null || d.focus());
  }, [o]), G(() => {
    if (!o) return;
    const d = (f) => {
      l.current && !l.current.contains(f.target) && s(!1);
    }, p = (f) => {
      var y;
      f.key !== "Escape" || f.isComposing || (f.preventDefault(), f.stopPropagation(), s(!1), (y = c.current) == null || y.focus());
    };
    return document.addEventListener("mousedown", d), document.addEventListener("keydown", p, !0), () => {
      document.removeEventListener("mousedown", d), document.removeEventListener("keydown", p, !0);
    };
  }, [o]);
  const u = (d) => {
    const p = m();
    if (p.length === 0) return;
    const f = p.indexOf(document.activeElement);
    let y = -1;
    if (d.key === "ArrowDown") y = (f + 1) % p.length;
    else if (d.key === "ArrowUp") y = (f <= 0 ? p.length : f) - 1;
    else if (d.key === "Home") y = 0;
    else if (d.key === "End") y = p.length - 1;
    else if (d.key === "Tab") {
      s(!1);
      return;
    } else return;
    d.preventDefault(), p[y].focus();
  };
  return /* @__PURE__ */ n.createElement("span", { className: ft.wrap, ref: l }, /* @__PURE__ */ n.createElement(Bt, { content: o ? void 0 : r, keepWrapper: !0 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: [ft.btn, o ? ft.on : ""].join(" "),
      disabled: a,
      "aria-haspopup": "menu",
      "aria-expanded": o,
      onClick: () => s((d) => !d),
      onKeyDown: (d) => {
        d.key === "ArrowDown" && !o && (d.preventDefault(), s(!0));
      }
    },
    e,
    /* @__PURE__ */ n.createElement("span", { className: ft.caret, "aria-hidden": "true" }, "▾")
  )), o && /* @__PURE__ */ n.createElement("div", { ref: i, className: ft.pop, role: "menu", onKeyDown: u }, t.map((d) => d.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: d.key, className: ft.sec }, d.label, d.note && /* @__PURE__ */ n.createElement("small", null, d.note)) : /* @__PURE__ */ n.createElement(
    "button",
    {
      key: d.key,
      type: "button",
      role: "menuitem",
      disabled: d.disabled,
      className: [ft.item, d.danger ? ft.danger : ""].join(" "),
      onClick: () => {
        var p;
        s(!1), (p = c.current) == null || p.focus(), d.onClick();
      }
    },
    /* @__PURE__ */ n.createElement("span", null, d.label),
    d.disabled && d.reason && /* @__PURE__ */ n.createElement("small", null, d.reason)
  ))));
}
function xE(e, t, a = !0) {
  const r = q(t);
  r.current = t, G(() => {
    if (!a) return;
    const o = (s) => {
      if (s.key !== "Enter" || !(s.ctrlKey || s.metaKey) || s.isComposing || s.repeat || s.defaultPrevented) return;
      const l = e.current, c = document.activeElement;
      !l || !c || !l.contains(c) || (s.preventDefault(), r.current());
    };
    return document.addEventListener("keydown", o), () => document.removeEventListener("keydown", o);
  }, [e, a]);
}
function qo() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const Io = "_bar_1g564_2", Ro = "_sticky_1g564_12", Oo = "_start_1g564_19", Po = "_end_1g564_20", Xo = "_status_1g564_22", zo = "_dirty_1g564_23", Fo = "_kbd_1g564_25", vt = {
  bar: Io,
  sticky: Ro,
  start: Oo,
  end: Po,
  status: Xo,
  dirty: zo,
  kbd: Fo
};
function DE({ start: e, children: t, status: a, dirty: r, inline: o, shortcutHint: s, className: l = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-save-bar", vt.bar, o ? "" : vt.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ n.createElement("span", { className: vt.start }, e), /* @__PURE__ */ n.createElement("span", { className: vt.end }, a && /* @__PURE__ */ n.createElement("span", { className: [vt.status, r ? vt.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), t, s && /* @__PURE__ */ n.createElement("kbd", { className: vt.kbd }, qo())));
}
const Wo = {
  print: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ n.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ n.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ n.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ n.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ n.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ n.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ n.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ n.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ n.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ n.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ n.createElement("path", { d: "M10 11v6M14 11v6" }))
}, Ho = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function Ko({ name: e, className: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: t, "aria-hidden": "true" }, Ho[e]);
}
function bn({ name: e, size: t = 15, className: a }) {
  return /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: a,
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    Wo[e]
  );
}
const Uo = "_root_j67qt_2", Yo = "_closed_j67qt_3", Go = "_tab_j67qt_6", Vo = "_collapse_j67qt_7", Jo = "_body_j67qt_16", Qo = "_card_j67qt_32", Zo = "_head_j67qt_37", es = "_cardOpen_j67qt_44", ts = "_headBtn_j67qt_47", ns = "_icon_j67qt_56", as = "_badge_j67qt_57", rs = "_trailing_j67qt_58", os = "_chev_j67qt_59", ss = "_panelWrap_j67qt_63", ls = "_panelOpen_j67qt_67", cs = "_panelBody_j67qt_68", is = "_panelInner_j67qt_69", us = "_panelSettled_j67qt_70", ve = {
  root: Uo,
  closed: Yo,
  tab: Go,
  collapse: Vo,
  body: Jo,
  card: Qo,
  head: Zo,
  cardOpen: es,
  headBtn: ts,
  icon: ns,
  badge: as,
  trailing: rs,
  chev: os,
  panelWrap: ss,
  panelOpen: ls,
  panelBody: cs,
  panelInner: is,
  panelSettled: us
}, ms = 1280, ds = 8, tr = "axe-side-bar:";
function _s(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(tr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function fs(e, t) {
  if (e)
    try {
      window.localStorage.setItem(tr + e, t ? "1" : "0");
    } catch {
    }
}
function CE({
  enabled: e = !0,
  defaultOpen: t = !0,
  width: a = 260,
  collapseBelow: r = ms,
  storageKey: o,
  className: s = "",
  children: l
}) {
  var p;
  const c = q(_s(o)), [i, m] = S((p = c.current) != null ? p : t), u = q(c.current !== null);
  if (G(() => {
    if (!e || !r || typeof window.matchMedia != "function") return;
    const f = window.matchMedia(`(max-width: ${r - 1}px)`), y = () => {
      u.current || m(!f.matches && t);
    };
    return y(), f.addEventListener ? f.addEventListener("change", y) : f.addListener(y), () => {
      f.removeEventListener ? f.removeEventListener("change", y) : f.removeListener(y);
    };
  }, [e, r, t]), !e) return null;
  const d = () => {
    u.current = !0, fs(o, !i), m(!i);
  };
  return /* @__PURE__ */ n.createElement(
    "aside",
    {
      className: ["axe-side-bar", ve.root, i ? "" : ve.closed, s].filter(Boolean).join(" "),
      style: { width: i ? a : ds }
    },
    /* @__PURE__ */ n.createElement("div", { className: ve.tab }, /* @__PURE__ */ n.createElement(Bt, { content: i ? "정보 패널 접기" : "정보 패널 펼치기", describe: !1 }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: ve.collapse,
        onClick: d,
        "aria-label": i ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": i
      },
      /* @__PURE__ */ n.createElement(Ko, { name: i ? "collapse" : "expand" })
    ))),
    /* @__PURE__ */ n.createElement("div", { className: ve.body }, l)
  );
}
const nr = Dn(null);
function AE({ children: e, defaultOpenId: t = null, exclusive: a = !0 }) {
  const [r, o] = S(t);
  return a ? /* @__PURE__ */ n.createElement(nr.Provider, { value: { openId: r, setOpenId: o } }, e) : /* @__PURE__ */ n.createElement(n.Fragment, null, e);
}
const ar = "axe-side-panel:";
function ps(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(ar + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function ys(e, t) {
  if (e)
    try {
      window.localStorage.setItem(ar + e, t ? "1" : "0");
    } catch {
    }
}
function SE({
  title: e,
  enabled: t = !0,
  defaultOpen: a = !0,
  icon: r,
  badge: o,
  trailing: s,
  storageKey: l,
  panelId: c,
  className: i = "",
  children: m
}) {
  var E;
  const u = xn(nr), d = !!u && c != null, p = q(ps(l)), [f, y] = S((E = p.current) != null ? E : a), _ = d ? u.openId === c : f, [b, $] = S(_), [k, w] = S(_);
  if (!t) return null;
  _ && !b && $(!0);
  const x = () => {
    const g = !_;
    ys(l, g), $(!0), w(!1), d ? u.setOpenId(g ? c : null) : y(g);
  };
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-side-card", ve.card, _ ? ve.cardOpen : "", i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("header", { className: ve.head, onClick: x }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ve.headBtn, "aria-expanded": _ }, r && /* @__PURE__ */ n.createElement("span", { className: ve.icon, "aria-hidden": "true" }, r), /* @__PURE__ */ n.createElement("strong", null, e)), o && /* @__PURE__ */ n.createElement("span", { className: ve.badge }, o), s && /* @__PURE__ */ n.createElement("span", { className: ve.trailing, onClick: (g) => g.stopPropagation() }, s), /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: ve.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ n.createElement("path", { d: "M6 9l6 6 6-6" })
  )), b && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ve.panelWrap, _ ? ve.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (g) => {
        g.target === g.currentTarget && g.propertyName === "grid-template-rows" && w(!0);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: [ve.panelBody, _ && k ? ve.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ve.panelInner }, m))
  ));
}
const bs = "_guide_qnh7l_1", hs = "_title_qnh7l_5", gs = "_desc_qnh7l_6", Es = "_act_qnh7l_7", vs = "_why_qnh7l_13", ks = "_steps_qnh7l_14", ws = "_no_qnh7l_20", Ns = "_cur_qnh7l_24", $s = "_link_qnh7l_26", rt = {
  guide: bs,
  title: hs,
  desc: gs,
  act: Es,
  why: vs,
  steps: ks,
  no: ws,
  cur: Ns,
  link: $s
};
function ME({ title: e, desc: t, action: a, steps: r }) {
  return /* @__PURE__ */ n.createElement("section", { className: rt.guide, "aria-label": e }, /* @__PURE__ */ n.createElement("h2", { className: rt.title }, e), t && /* @__PURE__ */ n.createElement("p", { className: rt.desc }, t), a && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ n.createElement("p", { className: rt.why }, a.reason)), r && r.length > 0 && /* @__PURE__ */ n.createElement("ol", { className: rt.steps }, r.map((o, s) => /* @__PURE__ */ n.createElement("li", { key: o.label, className: o.current ? rt.cur : void 0 }, /* @__PURE__ */ n.createElement("span", { className: rt.no }, s + 1), o.onClick && !o.current ? /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.link, onClick: o.onClick }, o.label) : /* @__PURE__ */ n.createElement("span", null, o.label), o.hint && /* @__PURE__ */ n.createElement("small", null, o.hint)))));
}
const xs = "_list_1w2rs_1", Ds = "_row_1w2rs_2", Cs = "_label_1w2rs_6", As = "_value_1w2rs_7", Ss = "_emphasis_1w2rs_8", Ms = "_changed_1w2rs_10", qt = {
  list: xs,
  row: Ds,
  label: Cs,
  value: As,
  emphasis: Ss,
  changed: Ms
};
function TE({ items: e, className: t }) {
  return /* @__PURE__ */ n.createElement("dl", { className: [qt.list, t != null ? t : ""].join(" ") }, e.map((a, r) => /* @__PURE__ */ n.createElement("div", { key: r, className: [qt.row, a.emphasis ? qt.emphasis : ""].join(" ") }, /* @__PURE__ */ n.createElement("dt", { className: qt.label }, a.label), /* @__PURE__ */ n.createElement("dd", { className: [qt.value, a.changed ? qt.changed : ""].join(" ") }, a.value))));
}
const Ts = "_underline_xl221_2", Bs = "_active_xl221_24", js = "_segmented_xl221_33", Ln = {
  underline: Ts,
  active: Bs,
  segmented: js
};
function rr({
  items: e,
  value: t,
  onChange: a,
  variant: r = "underline",
  className: o = "",
  "aria-label": s
}) {
  return /* @__PURE__ */ n.createElement(
    "nav",
    {
      className: [r === "segmented" ? Ln.segmented : Ln.underline, o].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": s
    },
    e.map((l) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === t,
        className: l.key === t ? Ln.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const Ls = "_bar_1e999_1", qs = "_actions_1e999_17", Is = "_field_1e999_24", Rs = "_fieldLabel_1e999_25", Os = "_readout_1e999_33", Ps = "_search_1e999_44", Xs = "_detail_1e999_58", zs = "_pill_1e999_70", Fs = "_hint_1e999_81", mt = {
  bar: Ls,
  actions: qs,
  field: Is,
  fieldLabel: Rs,
  readout: Os,
  search: Ps,
  detail: Xs,
  pill: zs,
  hint: Fs
}, Ws = /* @__PURE__ */ new Set(["text", "search", "number", "tel", "email", "url", "password", ""]);
function Hs(e) {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return !1;
  const t = e.target;
  return !(!(t instanceof HTMLInputElement) || !e.currentTarget.contains(t) || !Ws.has(t.type) || t.readOnly || t.disabled || t.getAttribute("role") === "combobox" || t.getAttribute("aria-expanded") === "true");
}
function BE({
  children: e,
  onSearch: t,
  searchLabel: a = "조회",
  searchDisabled: r,
  searchTitle: o,
  detailSearch: s = !1,
  onDetailSearch: l,
  detailLabel: c = "상세검색",
  trailing: i,
  enterSearch: m = !0
}) {
  const u = (d) => {
    !m || !t || r || !Hs(d) || (d.preventDefault(), t());
  };
  return /* @__PURE__ */ n.createElement("section", { className: mt.bar, onKeyDown: u }, e, /* @__PURE__ */ n.createElement("span", { className: mt.actions }, i, s && /* @__PURE__ */ n.createElement("button", { type: "button", className: mt.detail, onClick: l }, "⌕ ", c), t && /* @__PURE__ */ n.createElement(Bt, { content: o, keepWrapper: !0 }, /* @__PURE__ */ n.createElement("button", { type: "button", className: mt.search, onClick: t, disabled: r }, "⌕ ", a))));
}
function Ks({ label: e, children: t }) {
  return /* @__PURE__ */ n.createElement("label", { className: mt.field }, /* @__PURE__ */ n.createElement("span", { className: mt.fieldLabel }, e), t);
}
function jE({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: mt.readout }, e);
}
function LE({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: mt.pill, role: "status" }, e);
}
function qE({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: mt.hint }, e);
}
function Us(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function IE({ rows: e, value: t, onChange: a, disabled: r, label: o = "기수" }) {
  return /* @__PURE__ */ n.createElement(Ks, { label: o }, /* @__PURE__ */ n.createElement(
    "select",
    {
      value: t != null ? t : "",
      "aria-label": o,
      disabled: r,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (s) => a(Number(s.target.value))
    },
    e.map((s) => /* @__PURE__ */ n.createElement("option", { key: s.gisu, value: s.gisu }, Us(s)))
  ));
}
class or {
  constructor(t, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((r) => {
        try {
          for (const o of r) {
            const s = o.borderBoxSize[0];
            this._callback({ width: s.inlineSize, height: s.blockSize }, o);
          }
        } catch (o) {
          console.error(o);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = t, this._callback = a, this.initializeResizeObserver();
  }
}
function sr(e, t) {
  return !e || e.key !== t ? { key: t, dir: "asc" } : e.dir === "asc" ? { key: t, dir: "desc" } : null;
}
function lr(e, t) {
  return !e || e.key !== t ? "none" : e.dir === "asc" ? "ascending" : "descending";
}
function cr(e, t) {
  return e ? `${t(e.key)} ${e.dir === "asc" ? "오름차순" : "내림차순"} 정렬` : "정렬을 해제했습니다";
}
function Ys(e) {
  const t = e.replace(/\s+/g, " ").trim();
  if (!t || t === "-") return null;
  const a = /^([-+]?)\(?[₩$]?\s*([\d,]*\.?\d+)\)?\s*(%|원|개|건)?$/.exec(t);
  if (a && /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d*\.?\d+$/.test(a[2])) {
    const r = parseFloat(a[2].replace(/,/g, ""));
    return a[1] === "-" || /^[-+]?\(/.test(t) ? -r : r;
  }
  return t;
}
function ir(e, t, a) {
  if (e === null || t === null) return e === t ? 0 : e === null ? 1 : -1;
  let r;
  return typeof e == "number" && typeof t == "number" ? r = e - t : typeof e == "number" ? r = -1 : typeof t == "number" ? r = 1 : r = e.localeCompare(t, "ko", { numeric: !0, sensitivity: "base" }), a === "asc" ? r : -r;
}
function Gs(e, t) {
  const a = [], r = (l) => {
    l.sort((c, i) => ir(e[c.i].value, e[i.i].value, t) || c.i - i.i), l.forEach((c) => {
      a.push(c.i), r(c.kids);
    });
  };
  let o = [], s = [];
  return e.forEach((l, c) => {
    if (l.level === null) {
      r(o), o = [], s = [], a.push(c);
      return;
    }
    for (; s.length && s[s.length - 1].level >= l.level; ) s.pop();
    const i = { i: c, kids: [] };
    (s.length ? s[s.length - 1].node.kids : o).push(i), s.push({ level: l.level, node: i });
  }), r(o), a;
}
function Vs(e, t) {
  const a = new Set(t), r = e.filter((s) => a.has(s)), o = new Set(r);
  for (let s = t.length - 1; s >= 0; s -= 1) {
    const l = t[s];
    if (o.has(l)) continue;
    const c = s + 1 < t.length ? r.indexOf(t[s + 1]) : -1;
    c < 0 ? r.push(l) : r.splice(c, 0, l), o.add(l);
  }
  return r;
}
function Js(e, t) {
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, i) => a.set(c, i));
  const r = e.map((c) => {
    var i;
    return (i = a.get(c)) != null ? i : -1;
  }), o = [], s = new Array(r.length).fill(-1);
  r.forEach((c, i) => {
    if (c < 0) return;
    let m = 0, u = o.length;
    for (; m < u; ) {
      const d = m + u >> 1;
      r[o[d]] < c ? m = d + 1 : u = d;
    }
    m > 0 && (s[i] = o[m - 1]), o[m] = i;
  });
  const l = /* @__PURE__ */ new Set();
  for (let c = o.length ? o[o.length - 1] : -1; c >= 0; c = s[c]) l.add(e[c]);
  return l;
}
const Qs = 'input, select, textarea, button, a[href], [role="checkbox"], [role="button"]', Zs = ".axe-group-row, .axe-input-row, .axe-total-row, [data-sort-fixed]";
function el(e) {
  const t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  for (const r of e) {
    a.forEach((s, l) => {
      s <= 1 ? a.delete(l) : a.set(l, s - 1);
    });
    let o = 0;
    for (const s of Array.from(r.cells)) {
      for (; a.has(o); ) o += 1;
      const l = s.colSpan || 1;
      if (t.set(s, o), s.rowSpan > 1) for (let c = o; c < o + l; c += 1) a.set(c, s.rowSpan);
      o += l;
    }
  }
  return t;
}
function tl(e) {
  const t = e.tHead;
  if (!t) return [];
  const a = el(Array.from(t.rows)), r = [];
  return a.forEach((o, s) => {
    var c, i;
    if (s.tagName !== "TH" || (s.colSpan || 1) !== 1 || s.dataset.sortable === "false" || s.hasAttribute("aria-sort") && s.dataset.axeSort === void 0 || s.querySelector(Qs)) return;
    const l = ((c = s.textContent) != null ? c : "").replace(/\s+/g, " ").trim();
    l && r.push({ th: s, col: o, key: (i = s.dataset.sortKey) != null ? i : String(o), label: l });
  }), r;
}
function fa(e, t) {
  var r;
  let a = 0;
  for (const o of Array.from(e.cells)) {
    const s = o.colSpan || 1;
    if (t < a + s) {
      const l = o.dataset.sortValue;
      if (l !== void 0) {
        const i = Number(l);
        return l === "" ? null : Number.isFinite(i) ? i : l;
      }
      const c = o.querySelector('input:not([type="checkbox"]):not([type="radio"]), select');
      return Ys(c ? c.value : (r = o.textContent) != null ? r : "");
    }
    a += s;
  }
  return null;
}
function nl(e) {
  if (e.matches(Zs) || e.cells.length === 1 && (e.cells[0].colSpan || 1) > 1) return null;
  const t = Number(e.getAttribute("aria-level"));
  return Number.isFinite(t) && t >= 1 ? t : 1;
}
function al() {
  return { parent: null, base: [], shown: [], sig: "" };
}
function rl(e) {
  const t = Array.from(e.tBodies);
  if (t.length > 1) return { parent: e, items: t, bodies: !0 };
  const a = t[0];
  if (!a) return null;
  const r = Array.from(a.rows);
  return r.some((o) => Array.from(o.cells).some((s) => s.rowSpan > 1)) ? null : { parent: a, items: r, bodies: !1 };
}
const ur = (e, t) => e.length === t.length && e.every((a, r) => a === t[r]);
function ol(e, t, a) {
  if (ur(t, a)) return;
  const r = Js(t, a);
  let o = a.length ? a[a.length - 1].nextElementSibling : null;
  for (let s = t.length - 1; s >= 0; s -= 1) {
    const l = t[s];
    r.has(l) || e.insertBefore(l, o), o = l;
  }
}
function sl(e, t, a, r) {
  if (t) {
    const l = e.map((c, i) => ({ b: c, i, v: c.rows[0] ? fa(c.rows[0], a) : null }));
    return l.sort((c, i) => ir(c.v, i.v, r) || c.i - i.i), l.map((c) => c.b);
  }
  const o = e, s = o.map((l) => {
    const c = nl(l);
    return { level: c, value: c === null ? null : fa(l, a) };
  });
  return Gs(s, r).map((l) => o[l]);
}
function ll(e, t, a) {
  const r = rl(e);
  if ((!r || r.parent !== a.parent) && (a.parent = r ? r.parent : null, a.base = r ? r.items : [], a.shown = a.base, a.sig = "", !r))
    return;
  const o = r.items, s = t ? `${t.col}:${t.dir}` : "";
  if (s === a.sig && ur(o, a.shown)) return;
  a.base = a.sig ? Vs(a.base, o) : o;
  let l = t ? sl(a.base, r.bodies, t.col, t.dir) : a.base;
  if (t && s === a.sig) {
    const c = new Set(a.shown), i = a.shown.filter((u) => u.parentElement === r.parent);
    let m = 0;
    l = l.map((u) => c.has(u) ? i[m++] : u);
  }
  ol(r.parent, l, o), a.shown = l, a.sig = s;
}
const mr = Dn(null), cl = "_card_1s3rx_2", il = "_grow_1s3rx_19", ul = "_head_1s3rx_21", ml = "_title_1s3rx_30", dl = "_trailing_1s3rx_31", _l = "_scroll_1s3rx_9", fl = "_foot_1s3rx_49", pl = "_strip_1s3rx_51", yl = "_pager_1s3rx_53", bl = "_spacer_1s3rx_55", hl = "_table_1s3rx_57", gl = "_fixed_1s3rx_58", El = "_fz_1s3rx_76", vl = "_fzEdge_1s3rx_88", kl = "_frozen_1s3rx_95", wl = "_sr_1s3rx_150", Nl = "_statusCell_1s3rx_38", $l = "_status_1s3rx_38", xl = "_st_error_1s3rx_232", Dl = "_stIcon_1s3rx_233", Cl = "_spin_1s3rx_239", Al = "_axeSpin_1s3rx_1", Sl = "_busy_1s3rx_249", Ml = "_statusRow_1s3rx_251", Tl = "_busyBar_1s3rx_252", Bl = "_axeBusy_1s3rx_1", ie = {
  card: cl,
  grow: il,
  head: ul,
  title: ml,
  trailing: dl,
  scroll: _l,
  foot: fl,
  strip: pl,
  pager: yl,
  spacer: bl,
  table: hl,
  fixed: gl,
  fz: El,
  fzEdge: vl,
  frozen: kl,
  sr: wl,
  statusCell: Nl,
  status: $l,
  st_error: xl,
  stIcon: Dl,
  spin: Cl,
  axeSpin: Al,
  busy: Sl,
  statusRow: Ml,
  busyBar: Tl,
  axeBusy: Bl
}, jl = 120;
function Ll(e) {
  if (!e || !e.length) return;
  let t = 0, a = 0;
  for (const r of e)
    if (r == null) a += 1;
    else if (typeof r == "number") t += r;
    else if (/^\d+(\.\d+)?px$/.test(r)) t += parseFloat(r);
    else return;
  return a > 0 ? t + a * jl : void 0;
}
function pa({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ n.createElement("colgroup", null, e.map((t, a) => /* @__PURE__ */ n.createElement("col", { key: a, style: t == null ? void 0 : { width: t } })));
}
const hn = /* @__PURE__ */ new Set();
function ql(e) {
  var r;
  if (typeof process == "undefined" || ((r = process.env) == null ? void 0 : r.NODE_ENV) === "production" || !e || e.getAttribute("aria-label") || e.getAttribute("aria-labelledby")) return;
  const t = Array.from(e.querySelectorAll("thead th")).slice(0, 4).map((o) => {
    var s;
    return (s = o.textContent) == null ? void 0 : s.trim();
  }).filter(Boolean), a = `unnamed|${t.join("|")}`;
  hn.has(a) || (hn.add(a), console.warn(`[AXErpGrid] 표 이름이 없습니다 — aria-label(예 「전표 목록」)을 주세요. 머리글: ${t.join(" · ")}`));
}
function Il(e) {
  var r;
  if (typeof process == "undefined" || ((r = process.env) == null ? void 0 : r.NODE_ENV) === "production") return;
  const t = [];
  if (e.querySelectorAll("td.axe-money").forEach((o) => {
    var s, l;
    o.scrollWidth > o.clientWidth + 1 && t.push((l = (s = o.textContent) == null ? void 0 : s.trim()) != null ? l : "");
  }), !t.length) return;
  const a = t.slice(0, 5).join("|");
  hn.has(a) || (hn.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${t.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    t.slice(0, 5)
  ));
}
function ya(e, t, a) {
  if (!e) return;
  const r = /* @__PURE__ */ new Map();
  for (const o of Array.from(e.rows)) {
    r.forEach((l, c) => {
      l <= 1 ? r.delete(c) : r.set(c, l - 1);
    });
    let s = 0;
    for (const l of Array.from(o.cells)) {
      for (; r.has(s); ) s += 1;
      const c = l.colSpan || 1, i = t > 0 && s + c <= t;
      if (l.classList.toggle(ie.fz, i), l.classList.toggle(ie.fzEdge, i && s + c === t), l.style.left = i ? `${a[s]}px` : "", l.rowSpan > 1) for (let m = s; m < s + c; m += 1) r.set(m, l.rowSpan);
      s += c;
    }
  }
}
function RE({
  cols: e,
  footer: t,
  pagination: a,
  title: r,
  trailing: o,
  grow: s,
  fixed: l,
  stickyCols: c = 0,
  busy: i,
  tableRole: m,
  "aria-label": u,
  sortable: d = !0,
  sort: p,
  onSort: f,
  manualSort: y,
  className: _ = "",
  children: b
}) {
  const $ = l || e !== void 0 && e.length > 0, k = $ ? Ll(e) : void 0, { stick: w, offsets: x } = we(() => {
    const X = Math.max(Math.trunc(c), 0), z = [];
    if (X === 0 || !e) return { stick: 0, offsets: z };
    let O = 0, K = 0;
    for (let Q = 0; Q < X; Q += 1) {
      const Ne = e[Q];
      if (typeof Ne != "number") break;
      z.push(O), O += Ne, K += 1;
    }
    return { stick: K, offsets: z };
  }, [e, c]), E = [ie.table, $ ? ie.fixed : "", w > 0 ? ie.frozen : ""].filter(Boolean).join(" "), g = q(null), h = q(null), N = q(null), D = q(null), j = q(0), B = q(0), I = we(() => ({
    scrollRef: g,
    colCount: e == null ? void 0 : e.length,
    registerVirtual: () => (B.current += 1, () => {
      B.current -= 1;
    })
  }), [e == null ? void 0 : e.length]), [T, P] = S(null), ee = p !== void 0 ? p : T, [F, L] = S(""), ae = q(al()), te = () => {
    const X = g.current, z = N.current, O = D.current;
    if (!X || !z || !O) return;
    const K = X.scrollWidth;
    O.style.width = K + "px", z.style.display = K > X.clientWidth + 1 ? "" : "none";
    const Q = X.offsetWidth - X.clientWidth;
    z.style.paddingRight = Q + "px", h.current && (h.current.style.paddingRight = Q + "px"), Il(X);
  };
  G(() => {
    const X = g.current;
    if (!X) return;
    const z = new or(X, te);
    return ql(X.querySelector("table")), () => z.detach();
  }, []), je(() => {
    var X, z, O, K, Q;
    (w > 0 || j.current > 0) && (ya((z = (X = g.current) == null ? void 0 : X.querySelector("table")) != null ? z : null, w, x), ya((K = (O = h.current) == null ? void 0 : O.querySelector("table")) != null ? K : null, w, x)), j.current = w, (Q = g.current) == null || Q.querySelectorAll("thead th:not([scope])").forEach((Ne) => Ne.setAttribute("scope", "col")), v(), te();
  });
  function v() {
    var K;
    const X = (K = g.current) == null ? void 0 : K.querySelector("table");
    if (!X) return;
    const z = d ? tl(X) : [];
    X.querySelectorAll("thead th[data-axe-sort]").forEach((Q) => {
      z.some((Ne) => Ne.th === Q) || (Q.removeAttribute("data-axe-sort"), Q.removeAttribute("aria-sort"), Q.removeAttribute("tabindex"));
    }), z.forEach(({ th: Q, key: Ne }) => {
      Q.dataset.axeSort !== Ne && (Q.dataset.axeSort = Ne);
      const He = lr(ee, Ne);
      Q.getAttribute("aria-sort") !== He && Q.setAttribute("aria-sort", He), Q.hasAttribute("tabindex") || Q.setAttribute("tabindex", "0");
    });
    const O = ee && z.find((Q) => Q.key === ee.key);
    ll(X, ee && O && !y && B.current === 0 ? { col: O.col, dir: ee.dir } : null, ae.current);
  }
  const R = (X) => {
    var Q;
    const z = X.dataset.axeSort;
    if (z === void 0) return;
    const O = sr(ee, z), K = ((Q = X.textContent) != null ? Q : "").replace(/\s+/g, " ").trim();
    L(cr(O, () => K)), p === void 0 && P(O), f == null || f(O);
  }, Y = (X) => {
    var K, Q;
    const z = X, O = (K = z.closest) == null ? void 0 : K.call(z, "thead th[data-axe-sort]");
    return !O || !((Q = g.current) != null && Q.contains(O)) || z !== O && z.closest('input, select, textarea, button, a[href], [role="button"]') ? null : O;
  }, Z = (X) => {
    const z = Y(X.target);
    z && R(z);
  }, C = (X) => {
    if (X.key !== "Enter" && X.key !== " ") return;
    const z = Y(X.target);
    !z || X.target !== z || (X.preventDefault(), R(z));
  }, V = (X) => {
    const z = X.target.scrollLeft;
    g.current && (g.current.scrollLeft = z), h.current && (h.current.scrollLeft = z);
  }, J = (X) => {
    const z = X.target.scrollLeft;
    h.current && (h.current.scrollLeft = z), N.current && (N.current.scrollLeft = z);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ie.card, s ? ie.grow : "", i ? ie.busy : "", _].filter(Boolean).join(" ") }, i && /* @__PURE__ */ n.createElement("div", { className: ie.busyBar, "aria-hidden": "true" }), (r !== void 0 || o !== void 0) && /* @__PURE__ */ n.createElement("header", { className: ie.head }, /* @__PURE__ */ n.createElement("span", { className: ie.title }, r), o && /* @__PURE__ */ n.createElement("span", { className: ie.trailing }, o)), /* @__PURE__ */ n.createElement("div", { className: ie.scroll, ref: g, onScroll: J }, /* @__PURE__ */ n.createElement(
    "table",
    {
      className: E,
      role: m && m !== "table" ? m : void 0,
      "aria-busy": i || void 0,
      "aria-label": u != null ? u : typeof r == "string" && r ? r : void 0,
      style: k ? { minWidth: k } : void 0,
      onClick: d ? Z : void 0,
      onKeyDown: d ? C : void 0
    },
    /* @__PURE__ */ n.createElement(pa, { cols: e }),
    /* @__PURE__ */ n.createElement(mr.Provider, { value: I }, b)
  )), t && /* @__PURE__ */ n.createElement("div", { className: ie.foot, ref: h }, /* @__PURE__ */ n.createElement("table", { className: E, style: k ? { minWidth: k } : void 0 }, /* @__PURE__ */ n.createElement(pa, { cols: e }), /* @__PURE__ */ n.createElement("tbody", null, t))), /* @__PURE__ */ n.createElement("div", { className: ie.strip, ref: N, onScroll: V }, /* @__PURE__ */ n.createElement("div", { ref: D, className: ie.spacer })), a && /* @__PURE__ */ n.createElement("div", { className: ie.pager }, a), d && /* @__PURE__ */ n.createElement("span", { className: ie.sr, role: "status", "aria-live": "polite" }, F));
}
const Rl = 600;
function ba(e) {
  const { count: t, rowHeight: a, scrollTop: r, bodyTop: o } = e;
  if (!(t > 0) || !(a > 0)) return { start: 0, end: 0 };
  const s = e.viewport > 0 ? e.viewport : Rl, l = Math.max(0, Math.trunc(e.overscan)), c = Math.min(t - 1, Math.max(0, Math.floor((r - o) / a))), i = Math.ceil(s / a) + 1;
  return {
    start: Math.max(0, c - l),
    end: Math.min(t, c + i + l)
  };
}
function Ol(e, t, a) {
  return {
    top: a.start * t,
    bottom: Math.max(0, e - a.end) * t
  };
}
function Pl(e, t) {
  return e.start === t.start && e.end === t.end;
}
const ha = /* @__PURE__ */ new Set();
function ga({ height: e, colSpan: t }) {
  return e <= 0 ? null : /* @__PURE__ */ n.createElement("tr", { "aria-hidden": "true", "data-sort-fixed": "", "data-virtual-spacer": "", style: { height: e } }, /* @__PURE__ */ n.createElement("td", { colSpan: t, style: { height: e, padding: 0, border: 0 } }));
}
function OE({
  rows: e,
  rowHeight: t,
  renderRow: a,
  getKey: r,
  overscan: o = 6,
  colSpan: s,
  headerRows: l = 1,
  className: c
}) {
  var E;
  const i = xn(mr), m = q(null), [u, d] = S(() => ba({
    count: e.length,
    rowHeight: t,
    scrollTop: 0,
    viewport: 0,
    bodyTop: 0,
    overscan: o
  })), p = e.length, [f, y] = S(null), _ = f && f.of === t ? f.px : t;
  je(() => i ? i.registerVirtual() : void 0, [i]), je(() => {
    var h;
    const g = (h = m.current) == null ? void 0 : h.closest("table");
    if (g)
      return g.setAttribute("aria-rowcount", String(p + l)), () => g.removeAttribute("aria-rowcount");
  }, [p, l]), G(() => {
    const g = i == null ? void 0 : i.scrollRef.current, h = m.current;
    if (!g || !h) return;
    const N = () => {
      const j = h.getBoundingClientRect().top - g.getBoundingClientRect().top + g.scrollTop, B = ba({ count: p, rowHeight: _, scrollTop: g.scrollTop, viewport: g.clientHeight, bodyTop: j, overscan: o });
      d((I) => Pl(I, B) ? I : B);
    };
    N(), g.addEventListener("scroll", N, { passive: !0 });
    const D = typeof ResizeObserver == "function" ? new ResizeObserver(N) : null;
    return D ? D.observe(g) : window.addEventListener("resize", N), () => {
      g.removeEventListener("scroll", N), D ? D.disconnect() : window.removeEventListener("resize", N);
    };
  }, [i, p, _, o]), je(() => {
    var N, D, j;
    const g = (N = m.current) == null ? void 0 : N.querySelector("tr:not([data-virtual-spacer])"), h = (D = g == null ? void 0 : g.getBoundingClientRect().height) != null ? D : 0;
    !(h > 0) || Math.abs(h - _) <= 0.25 || (y({ of: t, px: h }), typeof process != "undefined" && ((j = process.env) == null ? void 0 : j.NODE_ENV) !== "production" && Math.abs(h - t) > 2 && !ha.has(t) && (ha.add(t), console.warn(`[AXErpVirtualBody] 실제 행 높이(${Math.round(h)}px)가 rowHeight(${t}px)와 많이 다릅니다 — 행마다 높이가 다르면 스크롤 위치가 어긋납니다. 셀 CSS 로 높이를 고정하세요.`)));
  }, [_, t, p]);
  const b = Math.min(u.end, p), $ = Math.min(u.start, b), k = Ol(p, _, { start: $, end: b }), w = (E = s != null ? s : i == null ? void 0 : i.colCount) != null ? E : 1, x = [];
  for (let g = $; g < b; g += 1) {
    const h = a(e[g], g), N = r ? r(e[g], g) : g;
    x.push(on(h) ? na(h, { key: N, "aria-rowindex": g + 1 + l }) : h);
  }
  return /* @__PURE__ */ n.createElement("tbody", { ref: m, className: c, "data-virtual": "" }, /* @__PURE__ */ n.createElement(ga, { height: k.top, colSpan: w }), x, /* @__PURE__ */ n.createElement(ga, { height: k.bottom, colSpan: w }));
}
const Xl = 7.09, zl = 3.88, Fl = 4.46, Wl = 16, Hl = 2;
function Kl(e, t = {}) {
  var s;
  const a = Math.max(1, e), r = Math.floor((a - 1) / 3), o = a * Xl + r * zl + (t.negative ? Fl : 0) + Wl + Hl;
  return Math.max(Math.ceil(o), (s = t.min) != null ? s : 0);
}
function PE(e, t = {}) {
  var o, s;
  let a = 0, r = (o = t.negative) != null ? o : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const c = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (r = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((s = t.min) != null ? s : 96, 96) : Kl(a, { ...t, negative: r });
}
function XE(e) {
  const t = document.createElement("span");
  t.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(t);
  const a = (l) => (t.textContent = l, t.getBoundingClientRect().width), r = a("000000000000"), o = a("000,000,000,000"), s = a("-000,000,000,000");
  return t.remove(), { digit: r / 12, comma: (o - r) / 3, minus: s - o };
}
const kt = 12, Ul = 1.06, Yl = 16, Gl = 4;
function Vl(e) {
  var a;
  const t = (a = e.codePointAt(0)) != null ? a : 0;
  return t >= 4352 && (t <= 4607 || t >= 11904 && t <= 55295 || t >= 63744 && t <= 64255 || t >= 65280 && t <= 65519) ? kt : e === " " ? kt * 0.3 : /[0-9]/.test(e) ? kt * 0.56 : /[A-Z]/.test(e) ? kt * 0.68 : /[a-z]/.test(e) ? kt * 0.56 : /[.,:;'|!]/.test(e) ? kt * 0.3 : kt * 0.6;
}
function Jl(e, t = !1) {
  let a = 0;
  for (const r of e) a += Vl(r);
  return t ? a * Ul : a;
}
function zE(e, t = {}) {
  var s, l, c;
  let a = 0;
  for (const i of e) {
    if (!i) continue;
    const m = Jl(i, t.bold);
    m > a && (a = m);
  }
  const r = (s = t.min) != null ? s : 64;
  if (a === 0) return r;
  const o = Math.ceil(a + Yl + ((l = t.extra) != null ? l : 0) + Gl);
  return Math.min(Math.max(o, r), (c = t.max) != null ? c : 1 / 0);
}
function FE({
  colSpan: e,
  loading: t,
  error: a,
  count: r,
  empty: o = "조회 결과가 없습니다",
  idle: s = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", m = r == null || r === 0, u = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let d;
  if (i) d = "error";
  else if (t && m) d = "loading";
  else if (r == null) {
    if (s === null) return null;
    d = "idle";
  } else if (r === 0) d = "empty";
  else return null;
  const p = /* @__PURE__ */ n.createElement(n.Fragment, null, d === "loading" && /* @__PURE__ */ n.createElement("span", { className: ie.spin, "aria-hidden": "true" }), d === "error" && /* @__PURE__ */ n.createElement("span", { className: ie.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ n.createElement("span", null, d === "error" ? u : d === "loading" ? l : d === "idle" ? s : o)), f = /* @__PURE__ */ n.createElement("div", { className: [ie.status, ie[`st_${d}`]].join(" "), role: "status" }, p);
  return e === void 0 ? /* @__PURE__ */ n.createElement("div", { className: c || void 0, "data-state": d }, f) : /* @__PURE__ */ n.createElement("tr", { className: [ie.statusRow, c].filter(Boolean).join(" "), "data-state": d }, /* @__PURE__ */ n.createElement("td", { colSpan: e, className: ie.statusCell }, f));
}
function WE(e, t) {
  return {
    tabIndex: 0,
    "aria-current": t ? "true" : void 0,
    onKeyDown: (a) => {
      a.target === a.currentTarget && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), e());
    }
  };
}
const Ql = "_cell_n9rrj_1", Zl = "_toggle_n9rrj_2", ec = "_spacer_n9rrj_8", tc = "_label_n9rrj_9", nc = "_dim_n9rrj_10", Gt = {
  cell: Ql,
  toggle: Zl,
  spacer: ec,
  label: tc,
  dim: nc
};
function HE(e, { id: t, parentId: a, defaultOpen: r = !0 }) {
  const [o, s] = S(() => /* @__PURE__ */ new Set()), [l, c] = S(() => /* @__PURE__ */ new Set()), { parents: i, kids: m } = we(() => {
    const f = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Set(), _ = new Set(e.map((b) => String(t(b))));
    for (const b of e) {
      const $ = a(b), k = $ == null || !_.has(String($)) ? null : String($);
      f.set(String(t(b)), k), k && y.add(k);
    }
    return { parents: f, kids: y };
  }, [e, t, a]), u = le((f) => r ? !o.has(f) : l.has(f), [r, o, l]), d = we(() => e.filter((f) => {
    var b, $;
    let y = (b = i.get(String(t(f)))) != null ? b : null;
    const _ = /* @__PURE__ */ new Set();
    for (; y && !_.has(y); ) {
      if (!u(y)) return !1;
      _.add(y), y = ($ = i.get(y)) != null ? $ : null;
    }
    return !0;
  }), [e, i, t, u]), p = le((f, y) => {
    const _ = (b, $) => {
      const k = new Set(b);
      return $ ? k.add(f) : k.delete(f), k;
    };
    r ? s((b) => _(b, !y)) : c((b) => _(b, y));
  }, [r]);
  return {
    visible: d,
    hasChildren: (f) => m.has(String(t(f))),
    isOpen: (f) => u(String(t(f))),
    toggle: (f) => {
      const y = String(t(f));
      p(y, !u(y));
    },
    expandAll: () => {
      s(/* @__PURE__ */ new Set()), c(new Set(m));
    },
    collapseAll: () => {
      s(new Set(m)), c(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const f = o, y = l;
      return s(/* @__PURE__ */ new Set()), c(new Set(m)), () => {
        s(f), c(y);
      };
    },
    reveal: (f) => {
      var b, $;
      let y = (b = i.get(String(f))) != null ? b : null;
      const _ = /* @__PURE__ */ new Set();
      for (; y && !_.has(y); )
        p(y, !0), _.add(y), y = ($ = i.get(y)) != null ? $ : null;
    }
  };
}
function KE({ depth: e, hasChildren: t, open: a, onToggle: r, dim: o, toggleOutOfTabOrder: s, title: l, csvPath: c, children: i }) {
  const m = (d) => {
    d.stopPropagation(), r();
  }, u = l != null ? l : typeof i == "string" ? i : void 0;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Gt.cell, o ? Gt.dim : ""].filter(Boolean).join(" "),
      style: { paddingLeft: e * 16 },
      "data-tree-depth": e,
      "data-csv-path": c
    },
    t ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Gt.toggle,
        "aria-expanded": a,
        "aria-label": `${u ? `${u} ` : ""}${a ? "하위 접기" : "하위 펼치기"}`,
        onClick: m,
        tabIndex: s ? -1 : void 0,
        "data-csv-skip": ""
      },
      a ? "▾" : "▸"
    ) : /* @__PURE__ */ n.createElement("span", { className: Gt.spacer, "aria-hidden": "true" }),
    /* @__PURE__ */ n.createElement("span", { className: Gt.label, title: u }, i)
  );
}
function ac(e, t, a, r = !1) {
  const o = e[t.r];
  if (!o || t.i < 0 || t.i >= o.length) return null;
  const s = o[t.i], l = e.findIndex((i) => i.length > 0);
  let c = -1;
  for (let i = e.length - 1; i >= 0; i--) if (e[i].length > 0) {
    c = i;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return t.i > 0 ? { r: t.r, i: t.i - 1 } : null;
    case "ArrowRight":
      return t.i < o.length - 1 ? { r: t.r, i: t.i + 1 } : null;
    case "Home":
      return r ? { r: l, i: 0 } : { r: t.r, i: 0 };
    case "End":
      return r ? { r: c, i: e[c].length - 1 } : { r: t.r, i: o.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const i = a === "ArrowUp" ? -1 : 1;
      for (let m = t.r + i; m >= 0 && m < e.length; m += i)
        if (e[m].length > 0) return { r: m, i: rc(e[m], s) };
      return null;
    }
    default:
      return null;
  }
}
function rc(e, t) {
  let a = 0;
  for (let r = 1; r < e.length; r++)
    Math.abs(e[r] - t) < Math.abs(e[a] - t) && (a = r);
  return a;
}
function UE(e, t = {}) {
  var c;
  const a = (c = t.cellSelector) != null ? c : "[data-roving]", r = t.initialSelector, o = q(null), [s, l] = S(null);
  G(() => {
    e.current !== s && l(e.current);
  }), G(() => {
    if (!s) return;
    const i = () => Array.from(s.querySelectorAll(a)), m = () => {
      const y = i();
      if (!y.length) {
        o.current = null;
        return;
      }
      (!o.current || !y.includes(o.current)) && (o.current = r && y.find((_) => _.matches(r)) || y[0]), y.forEach((_) => {
        const b = _ === o.current ? "0" : "-1";
        _.getAttribute("tabindex") !== b && _.setAttribute("tabindex", b);
      });
    }, u = () => {
      const y = i(), _ = [], b = [], $ = /* @__PURE__ */ new Map(), k = [];
      return y.forEach((w) => {
        var j;
        const x = w.tagName === "TR", E = x ? null : w.closest("td, th"), g = E && s.contains(E) ? E.parentElement : null, h = x ? w : (j = g != null ? g : w.parentElement) != null ? j : s;
        let N = _.indexOf(h);
        N < 0 && (N = _.length, _.push(h), b.push([]), k.push([]));
        let D;
        if (x)
          D = 0;
        else if (E && g) {
          D = 0;
          for (const B of Array.from(g.cells)) {
            if (B === E) break;
            D += Math.max(1, B.colSpan || 1);
          }
        } else
          D = b[N].length;
        $.set(w, { r: N, i: b[N].length }), b[N].push(D), k[N].push(w);
      }), { rows: b, where: $, byPos: k };
    }, d = (y) => {
      var g;
      const _ = y.target;
      if (!_ || !_.matches(a) || !s.contains(_) || y.altKey || y.metaKey || _.tagName === "TR" && (y.key === "ArrowLeft" || y.key === "ArrowRight")) return;
      const { rows: b, where: $, byPos: k } = u(), w = $.get(_);
      if (!w) return;
      const x = ac(b, w, y.key, y.ctrlKey);
      if (x === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(y.key) && y.preventDefault();
        return;
      }
      y.preventDefault();
      const E = (g = k[x.r]) == null ? void 0 : g[x.i];
      E && (o.current = E, m(), E.focus());
    }, p = (y) => {
      const _ = y.target;
      !_ || !_.matches(a) || _ === o.current || (o.current = _, m());
    };
    m(), s.addEventListener("keydown", d), s.addEventListener("focusin", p);
    const f = typeof MutationObserver != "undefined" ? new MutationObserver(m) : null;
    return f == null || f.observe(s, { childList: !0, subtree: !0 }), () => {
      s.removeEventListener("keydown", d), s.removeEventListener("focusin", p), f == null || f.disconnect();
    };
  }, [s, a, r]);
}
const oc = "_btn_r1trx_1", sc = "_mark_r1trx_7", lc = "_sr_r1trx_9", Yn = {
  btn: oc,
  mark: sc,
  sr: lc
};
function YE({ sortKey: e, sort: t, onSort: a, children: r, className: o = "", colSpan: s, style: l, title: c }) {
  const i = lr(t, e);
  return /* @__PURE__ */ n.createElement("th", { scope: "col", "aria-sort": i, colSpan: s, style: l, title: c, className: o }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Yn.btn, onClick: () => a(sr(t, e)) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: Yn.mark, "aria-hidden": "true" }, i === "ascending" ? "▲" : i === "descending" ? "▼" : "↕")));
}
function GE({ sort: e, labelOf: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: Yn.sr, role: "status", "aria-live": "polite" }, cr(e, t));
}
const cc = "_card_14vt3_1", ic = "_accent_14vt3_8", uc = "_grow_14vt3_9", mc = "_head_14vt3_11", dc = "_body_14vt3_20", _c = "_title_14vt3_28", fc = "_trailing_14vt3_29", pc = "_summary_14vt3_32", yc = "_sumHead_14vt3_33", bc = "_sumTotal_14vt3_42", hc = "_tone_warn_14vt3_43", gc = "_tone_ok_14vt3_44", Ec = "_sumList_14vt3_46", vc = "_sumEm_14vt3_55", kc = "_sumFoot_14vt3_57", wc = "_sumNote_14vt3_66", xe = {
  card: cc,
  accent: ic,
  grow: uc,
  head: mc,
  body: dc,
  title: _c,
  trailing: fc,
  summary: pc,
  sumHead: yc,
  sumTotal: bc,
  tone_warn: hc,
  tone_ok: gc,
  sumList: Ec,
  sumEm: vc,
  sumFoot: kc,
  sumNote: wc
};
function dr({
  title: e,
  trailing: t,
  accent: a,
  grow: r,
  flush: o,
  className: s = "",
  children: l
}) {
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: [xe.card, a ? xe.accent : "", r ? xe.grow : "", s].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ n.createElement("header", { className: xe.head }, /* @__PURE__ */ n.createElement("span", { className: xe.title, role: "heading", "aria-level": 2 }, e), t && /* @__PURE__ */ n.createElement("span", { className: xe.trailing }, t)),
    o ? l : /* @__PURE__ */ n.createElement("div", { className: ["axe-card-body", xe.body].join(" ") }, l)
  );
}
function VE({
  title: e,
  total: t,
  items: a,
  footerLabel: r,
  footerValue: o,
  note: s,
  tone: l = "default",
  children: c
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [xe.card, xe.accent, xe.summary, xe[`tone_${l}`]].join(" ") }, /* @__PURE__ */ n.createElement("header", { className: xe.sumHead }, /* @__PURE__ */ n.createElement("span", null, e), t !== void 0 && /* @__PURE__ */ n.createElement("strong", { className: xe.sumTotal }, t)), /* @__PURE__ */ n.createElement("ul", { className: xe.sumList }, a.map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("li", { key: (u = i.key) != null ? u : m, className: i.em ? xe.sumEm : "" }, /* @__PURE__ */ n.createElement("span", null, i.label), /* @__PURE__ */ n.createElement("strong", null, i.value));
  })), c, r !== void 0 && /* @__PURE__ */ n.createElement("footer", { className: xe.sumFoot }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("strong", null, o)), s && /* @__PURE__ */ n.createElement("div", { className: xe.sumNote }, s));
}
let Nc = 0;
function Ut(e = "axe") {
  const t = q(null);
  return t.current || (t.current = `${e}-${++Nc}`), t.current;
}
const $c = "_sr_1y2mv_2", xc = "_skip_1y2mv_8", Dc = "_crit_1y2mv_16", Cc = "_c_danger_1y2mv_21", Ac = "_c_warn_1y2mv_22", Sc = "_critI_1y2mv_23", Mc = "_critBody_1y2mv_24", Tc = "_critX_1y2mv_25", Bc = "_ch_1y2mv_32", jc = "_chBtn_1y2mv_33", Lc = "_chBox_1y2mv_43", Ze = {
  sr: $c,
  skip: xc,
  crit: Dc,
  c_danger: Cc,
  c_warn: Ac,
  critI: Sc,
  critBody: Mc,
  critX: Tc,
  ch: Bc,
  chBtn: jc,
  chBox: Lc
};
function _r({ as: e = "span", children: t, id: a }) {
  return /* @__PURE__ */ n.createElement(e, { className: Ze.sr, id: a }, t);
}
function JE({ targets: e = [{ label: "본문 바로가기", targetId: "axe-main" }], className: t = "" }) {
  const a = (r, o) => {
    const s = document.getElementById(o);
    s && (r.preventDefault(), s.hasAttribute("tabindex") || s.setAttribute("tabindex", "-1"), s.focus(), s.scrollIntoView({ block: "start" }));
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [Ze.skip, t].filter(Boolean).join(" "), "aria-label": "건너뛰기" }, e.slice(0, 3).map((r) => /* @__PURE__ */ n.createElement("a", { key: r.targetId, href: `#${r.targetId}`, onClick: (o) => a(o, r.targetId) }, r.label)));
}
function QE({ title: e, children: t, tone: a = "danger", onClose: r, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Ze.crit, Ze[`c_${a}`], o].filter(Boolean).join(" "), role: "alert" }, /* @__PURE__ */ n.createElement("span", { className: Ze.critI, "aria-hidden": "true" }, "▲"), /* @__PURE__ */ n.createElement("div", { className: Ze.critBody }, /* @__PURE__ */ n.createElement("b", null, e), t ? /* @__PURE__ */ n.createElement("span", null, " ", t) : null), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ze.critX, onClick: r, "aria-label": "공지 닫기" }, "✕"));
}
function ZE({ label: e, children: t, className: a = "" }) {
  const [r, o] = S(!1), s = Ut("axe-ch"), l = q(null), c = q(null);
  return G(() => {
    if (!r) return;
    const i = (u) => {
      l.current && !l.current.contains(u.target) && o(!1);
    }, m = (u) => {
      var d;
      u.key !== "Escape" || u.isComposing || (u.preventDefault(), u.stopPropagation(), o(!1), (d = c.current) == null || d.focus());
    };
    return document.addEventListener("mousedown", i), document.addEventListener("keydown", m, !0), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("keydown", m, !0);
    };
  }, [r]), /* @__PURE__ */ n.createElement("span", { className: [Ze.ch, a].filter(Boolean).join(" "), ref: l }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: Ze.chBtn,
      "aria-label": e,
      "aria-expanded": r,
      "aria-controls": s,
      onClick: () => o((i) => !i)
    },
    "?"
  ), r && /* @__PURE__ */ n.createElement("span", { id: s, role: "region", "aria-label": e, className: Ze.chBox }, t));
}
function Gn(e, t, a = "codeName") {
  const r = (e != null ? e : "").trim();
  if (!r) return "";
  const o = (t != null ? t : "").trim();
  return !o || a === "code" ? r : a === "name" ? o : `${r}. ${o}`;
}
function qc(e, t = "전체", a = "codeName") {
  if (e.length === 0) return t;
  const r = Gn(e[0].cd, e[0].nm, a);
  return e.length === 1 ? r : `${r} 외 ${e.length - 1}건`;
}
function Ic(e, t, a, r) {
  const o = (e != null ? e : "").trim();
  if (!o) return null;
  if (t && t.name && t.code === o) return t.name;
  if (a && a.code === o && a.name) return a.name;
  const s = r == null ? void 0 : r.find((l) => l.code === o);
  return s && s.name ? s.name : null;
}
const Rc = "_root_umk7w_1", Oc = "_rootNone_umk7w_5", Pc = "_field_umk7w_12", Xc = "_codeInput_umk7w_13", zc = "_pickBtn_umk7w_17", Fc = "_suggest_umk7w_34", Wc = "_suggestList_umk7w_40", Hc = "_suggestRow_umk7w_41", Kc = "_suggestOn_umk7w_42", Uc = "_suggestEmpty_umk7w_47", Yc = "_suggestMore_umk7w_47", Gc = "_popup_umk7w_51", Vc = "_popupHead_umk7w_65", Jc = "_searchRow_umk7w_75", Qc = "_list_umk7w_79", Zc = "_current_umk7w_88", ei = "_empty_umk7w_92", ti = "_summaryBtn_umk7w_100", ni = "_ov_umk7w_121", ai = "_modal_umk7w_132", ri = "_modalWide_umk7w_132", oi = "_head_umk7w_144", si = "_sub_umk7w_152", li = "_x_umk7w_154", ci = "_body_umk7w_171", ii = "_chips_umk7w_179", ui = "_chip_umk7w_179", mi = "_chipOn_umk7w_193", di = "_search_umk7w_75", _i = "_tbl_umk7w_212", fi = "_row_umk7w_242", pi = "_rowCursor_umk7w_244", yi = "_rowPicked_umk7w_245", bi = "_rowCurrent_umk7w_246", hi = "_curTag_umk7w_247", gi = "_busy_umk7w_248", Ei = "_count_umk7w_249", vi = "_chk_umk7w_251", ki = "_tdLeft_umk7w_252", wi = "_tdCenter_umk7w_253", Ni = "_emptyCell_umk7w_255", $i = "_stop_umk7w_257", xi = "_more_umk7w_268", Di = "_pager_umk7w_280", Ci = "_note_umk7w_293", Ai = "_foot_umk7w_296", Si = "_ghost_umk7w_305", Mi = "_primary_umk7w_317", U = {
  root: Rc,
  rootNone: Oc,
  field: Pc,
  codeInput: Xc,
  pickBtn: zc,
  suggest: Fc,
  suggestList: Wc,
  suggestRow: Hc,
  suggestOn: Kc,
  suggestEmpty: Uc,
  suggestMore: Yc,
  popup: Gc,
  popupHead: Vc,
  searchRow: Jc,
  list: Qc,
  current: Zc,
  empty: ei,
  summaryBtn: ti,
  ov: ni,
  modal: ai,
  modalWide: ri,
  head: oi,
  sub: si,
  x: li,
  body: ci,
  chips: ii,
  chip: ui,
  chipOn: mi,
  search: di,
  tbl: _i,
  row: fi,
  rowCursor: pi,
  rowPicked: yi,
  rowCurrent: bi,
  curTag: hi,
  busy: gi,
  count: Ei,
  chk: vi,
  tdLeft: ki,
  tdCenter: wi,
  emptyCell: Ni,
  stop: $i,
  more: xi,
  pager: Di,
  note: Ci,
  foot: Ai,
  ghost: Si,
  primary: Mi
};
function Ti({
  items: e,
  value: t,
  title: a,
  popupRef: r,
  anchorRef: o,
  pos: s,
  onPick: l,
  onClose: c
}) {
  const [i, m] = S(""), u = we(() => {
    const d = i.trim().toLowerCase();
    return d ? e.filter(
      (p) => {
        var f;
        return p.code.toLowerCase().includes(d) || p.name.toLowerCase().includes(d) || ((f = p.sub) != null ? f : "").toLowerCase().includes(d);
      }
    ) : e;
  }, [e, i]);
  return G(() => {
    const d = (f) => {
      const y = f.target;
      r.current && !r.current.contains(y) && o.current && !o.current.contains(y) && c();
    }, p = (f) => {
      f.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", d), document.addEventListener("keydown", p), () => {
      document.removeEventListener("mousedown", d), document.removeEventListener("keydown", p);
    };
  }, [r, o, c]), /* @__PURE__ */ n.createElement(Kt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: r,
      className: U.popup,
      style: { left: s.left, top: s.top },
      role: "dialog",
      "aria-label": "코드도움"
    },
    /* @__PURE__ */ n.createElement("header", { className: U.popupHead }, /* @__PURE__ */ n.createElement("strong", null, a), /* @__PURE__ */ n.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: U.searchRow }, /* @__PURE__ */ n.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        "aria-label": "코드·명칭 검색",
        placeholder: "코드·명칭 검색",
        onChange: (d) => m(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && u.length && l(u[0]), d.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ n.createElement("ul", { className: U.list }, u.map((d) => /* @__PURE__ */ n.createElement("li", { key: d.code }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(d), className: d.code === t ? U.current : "" }, /* @__PURE__ */ n.createElement("code", null, d.code), /* @__PURE__ */ n.createElement("span", null, d.name), d.sub && /* @__PURE__ */ n.createElement("small", null, d.sub)))), u.length === 0 && /* @__PURE__ */ n.createElement("li", { className: U.empty }, "검색 결과가 없습니다"))
  ));
}
const fr = 250, mn = 7;
function Ea(e, t) {
  const a = t.trim().toLowerCase();
  if (!a) return e;
  const r = e.toLowerCase().indexOf(a);
  return r < 0 ? e : /* @__PURE__ */ n.createElement(n.Fragment, null, e.slice(0, r), /* @__PURE__ */ n.createElement("b", null, e.slice(r, r + a.length)), e.slice(r + a.length));
}
function Bi(e, t) {
  const a = e.map((r) => ({ cd: r.code, nm: r.name, sub: r.sub }));
  return {
    key: "static",
    title: typeof t == "string" ? t : "코드도움",
    nameLabel: "명칭",
    fetch: ({ q: r }) => {
      const o = r.trim().toLowerCase();
      return o ? Promise.resolve({
        rows: a.filter(
          (s) => {
            var l;
            return s.cd.toLowerCase().includes(o) || s.nm.toLowerCase().includes(o) || String((l = s.sub) != null ? l : "").toLowerCase().includes(o);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function ji({
  source: e,
  items: t,
  title: a,
  multiple: r,
  selected: o,
  current: s,
  searchRef: l,
  onConfirm: c,
  onClose: i
}) {
  const m = we(() => Bi(t != null ? t : [], a), [t, a]), u = e != null ? e : m, [d, p] = S(""), [f, y] = S(null), [_, b] = S(0), [$, k] = S([]), [w, x] = S(!1), [E, g] = S(!1), [h, N] = S(null), [D, j] = S(0), [B, I] = S(/* @__PURE__ */ new Map()), T = q(u);
  T.current = u, G(() => {
    p(""), y(null), b(0), j(0), N(null), I(new Map((o != null ? o : []).map((V) => [V.cd, V])));
    const C = window.setTimeout(() => {
      l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(C);
  }, [u.key]), G(() => {
    let C = !0;
    g(!0);
    const V = () => {
      T.current.fetch({ q: d.trim(), ty: f, page: _ }).then((X) => {
        var O, K;
        if (!C) return;
        k((O = X.rows) != null ? O : []), x(!!X.hasMore), N(null);
        const z = s ? ((K = X.rows) != null ? K : []).findIndex((Q) => Q.cd === s) : -1;
        j(z > 0 ? z : 0);
      }).catch((X) => {
        C && (k([]), x(!1), N(X instanceof Error ? X.message : "코드도움 조회에 실패했습니다"));
      }).finally(() => {
        C && g(!1);
      });
    }, J = window.setTimeout(V, d.trim() ? fr : 0);
    return () => {
      C = !1, window.clearTimeout(J);
    };
  }, [u.key, d, f, _]);
  const P = q(null);
  G(() => {
    const C = P.current && P.current.children[D];
    C && "scrollIntoView" in C && C.scrollIntoView({ block: "nearest" });
  }, [D, $]);
  const ee = we(() => {
    var V, J;
    const C = [
      { key: "cd", label: "코드", width: (V = u.codeWidth) != null ? V : "96px", align: "center" },
      {
        key: "nm",
        label: u.nameLabel,
        align: "left",
        render: (X) => /* @__PURE__ */ n.createElement(n.Fragment, null, X.nm, X.useYn === !1 && /* @__PURE__ */ n.createElement("span", { className: U.stop }, "중단"))
      }
    ];
    return u.typeLabel && C.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (X) => u.typeLabel ? u.typeLabel(X) : ""
    }), C.concat((J = u.extraColumns) != null ? J : []);
  }, [u]), F = le((C) => {
    I((V) => {
      const J = new Map(V);
      return J.has(C.cd) ? J.delete(C.cd) : J.set(C.cd, C), J;
    });
  }, []), L = le((C) => c([C]), [c]), ae = le(() => c(Array.from(B.values())), [B, c]), te = $.length > 0 && $.every((C) => B.has(C.cd)), v = () => {
    I((C) => {
      const V = new Map(C);
      return te ? $.forEach((J) => V.delete(J.cd)) : $.forEach((J) => V.set(J.cd, J)), V;
    });
  }, R = q(null);
  G(() => {
    const C = document.activeElement;
    return () => {
      window.setTimeout(() => {
        C && C.isConnected && typeof C.focus == "function" && (!document.activeElement || document.activeElement === document.body) && C.focus();
      }, 0);
    };
  }, []);
  const Y = q(i);
  Y.current = i, G(() => {
    const C = (V) => {
      V.key !== "Escape" || V.isComposing || (V.stopPropagation(), V.preventDefault(), Y.current());
    };
    return document.addEventListener("keydown", C, !0), () => document.removeEventListener("keydown", C, !0);
  }, []);
  const Z = (C) => {
    var X;
    if (C.nativeEvent.isComposing || C.keyCode === 229) return;
    if (C.key === "Tab" && R.current) {
      const z = Array.from(R.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
      if (z.length) {
        const O = z[0], K = z[z.length - 1], Q = document.activeElement;
        C.shiftKey && Q === O ? (C.preventDefault(), K.focus()) : !C.shiftKey && Q === K && (C.preventDefault(), O.focus());
      }
      return;
    }
    if (C.key === "Escape") {
      C.stopPropagation(), i();
      return;
    }
    const V = C.target, J = V === l.current;
    if (!(!J && V !== R.current)) {
      if (C.key === "ArrowDown" || C.key === "ArrowUp") {
        C.preventDefault(), j((z) => Math.max(0, Math.min($.length - 1, z + (C.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (C.key === " " && r && $[D] && !(J && ((X = l.current) != null && X.value))) {
        C.preventDefault(), F($[D]);
        return;
      }
      if (C.key === "Enter") {
        if (C.preventDefault(), E) return;
        r ? ae() : $[D] && L($[D]);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(Kt, null, /* @__PURE__ */ n.createElement("div", { className: U.ov, onClick: i }, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: u.wide ? `${U.modal} ${U.modalWide}` : U.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": u.title,
      ref: R,
      onClick: (C) => C.stopPropagation(),
      onKeyDown: Z
    },
    /* @__PURE__ */ n.createElement("div", { className: U.head }, /* @__PURE__ */ n.createElement("h2", null, u.title), r && /* @__PURE__ */ n.createElement("span", { className: U.sub }, "복수 선택 가능"), /* @__PURE__ */ n.createElement("button", { type: "button", className: U.x, onClick: i, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ n.createElement("div", { className: U.body }, u.filters && u.filters.length > 0 && /* @__PURE__ */ n.createElement("div", { className: U.chips }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: f === null ? `${U.chip} ${U.chipOn}` : U.chip,
        onClick: () => {
          y(null), b(0);
        }
      },
      "전체"
    ), u.filters.map((C) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: C.value,
        type: "button",
        className: f === C.value ? `${U.chip} ${U.chipOn}` : U.chip,
        onClick: () => {
          y(C.value), b(0);
        }
      },
      C.label
    ))), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        className: U.search,
        value: d,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (C) => {
          p(C.target.value), b(0);
        }
      }
    ), /* @__PURE__ */ n.createElement("div", { className: U.tbl }, /* @__PURE__ */ n.createElement("table", null, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, r && /* @__PURE__ */ n.createElement("th", { className: U.chk }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "checkbox",
        checked: te,
        onChange: v,
        "aria-label": "표시된 행 전체 선택"
      }
    )), ee.map((C) => /* @__PURE__ */ n.createElement("th", { key: C.key, style: C.width ? { width: C.width } : void 0 }, C.label)))), /* @__PURE__ */ n.createElement("tbody", { ref: P, className: E && $.length > 0 ? U.busy : void 0, "aria-busy": E }, $.length === 0 ? /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("td", { className: U.emptyCell, colSpan: ee.length + (r ? 1 : 0) }, E ? "조회 중…" : h || u.emptyText || "검색 결과가 없습니다")) : $.map((C, V) => /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: C.cd,
        className: [
          U.row,
          V === D ? U.rowCursor : "",
          B.has(C.cd) ? U.rowPicked : "",
          !r && s && C.cd === s ? U.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": V === D,
        onClick: () => {
          j(V), r ? F(C) : L(C);
        }
      },
      r && /* @__PURE__ */ n.createElement("td", { className: U.chk }, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: "checkbox",
          checked: B.has(C.cd),
          onChange: () => F(C),
          onClick: (J) => J.stopPropagation(),
          "aria-label": `${C.cd} 선택`
        }
      )),
      ee.map((J) => {
        var X, z;
        return /* @__PURE__ */ n.createElement(
          "td",
          {
            key: J.key,
            className: J.align === "left" ? U.tdLeft : U.tdCenter,
            title: J.render ? void 0 : String((X = C[J.key]) != null ? X : "")
          },
          J.render ? J.render(C) : String((z = C[J.key]) != null ? z : ""),
          J.key === "cd" && !r && s && C.cd === s && /* @__PURE__ */ n.createElement("em", { className: U.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ n.createElement("p", { className: U.count, role: "status", "aria-live": "polite" }, E ? "조회 중…" : h ? "" : `${$.length}건`, !r && !E && !h && $.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 줄을 누르세요"), (w || _ > 0) && /* @__PURE__ */ n.createElement("div", { className: U.more }, /* @__PURE__ */ n.createElement("span", null, w ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ n.createElement("span", { className: U.pager }, /* @__PURE__ */ n.createElement("button", { type: "button", disabled: _ === 0, onClick: () => b((C) => Math.max(0, C - 1)) }, "이전"), /* @__PURE__ */ n.createElement("b", null, _ + 1), w && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => b((C) => C + 1) }, "다음"))), r && /* @__PURE__ */ n.createElement("p", { className: U.note }, "선택 ", /* @__PURE__ */ n.createElement("b", null, B.size), "건 — 선택이 없으면 ", /* @__PURE__ */ n.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ n.createElement("div", { className: U.foot }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.ghost, onClick: () => I(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ n.createElement("button", { type: "button", className: U.ghost, onClick: i }, "취소"), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.primary, onClick: ae }, "확인"))
  )));
}
let Li = 0;
function qi({ source: e, items: t, anchorRef: a }) {
  const [r, o] = S(null), [s, l] = S(-1), [c, i] = S(null), m = q(null), u = q(0), d = q(`axe-cp-${++Li}`), p = q(e);
  p.current = e;
  const f = q(t);
  f.current = t;
  const y = le(() => {
    m.current != null && (window.clearTimeout(m.current), m.current = null), u.current += 1, o(null), l(-1);
  }, []);
  G(() => y, [y]);
  const _ = (b) => {
    m.current != null && window.clearTimeout(m.current), u.current += 1;
    const $ = u.current;
    if (!b.trim()) {
      o(null), l(-1);
      return;
    }
    m.current = window.setTimeout(async () => {
      var x;
      let k = [], w = !1;
      try {
        const E = p.current;
        if (E) {
          const g = await E.fetch({ q: b, ty: null, page: 0 });
          k = g.rows, w = !!g.hasMore || k.length > mn;
        } else {
          const g = b.trim().toLowerCase();
          k = ((x = f.current) != null ? x : []).filter((h) => {
            var N;
            return h.code.toLowerCase().includes(g) || h.name.toLowerCase().includes(g) || ((N = h.sub) != null ? N : "").toLowerCase().includes(g);
          }).map((h) => ({ cd: h.code, nm: h.name, sub: h.sub })), w = k.length > mn;
        }
      } catch {
        return;
      }
      $ === u.current && (o({ rows: k.slice(0, mn), more: w, q: b }), l(-1));
    }, fr);
  };
  return G(() => {
    if (!r) {
      i(null);
      return;
    }
    const b = () => {
      const $ = a.current;
      if (!$) return;
      const k = $.getBoundingClientRect(), w = Math.min(r.rows.length, mn) * 28 + 34, x = k.bottom + w > window.innerHeight - 8 && k.top - w - 2 > 8 ? k.top - w - 2 : k.bottom + 2, E = Math.max(k.width, 260);
      i({ left: Math.max(8, Math.min(k.left, window.innerWidth - E - 8)), top: x, width: E });
    };
    return b(), window.addEventListener("resize", b), window.addEventListener("scroll", b, !0), () => {
      window.removeEventListener("resize", b), window.removeEventListener("scroll", b, !0);
    };
  }, [r, a]), { sugg: r, active: s, setActive: l, suggPos: c, suggId: d, runSuggest: _, cancelSuggest: y };
}
function e0({
  value: e = "",
  name: t,
  show: a = "codeName",
  onChange: r,
  items: o,
  source: s,
  multiple: l = !1,
  selected: c,
  onConfirm: i,
  current: m,
  trigger: u,
  emptyLabel: d = "전체",
  open: p,
  onOpenChange: f,
  placeholder: y,
  title: _ = "코드도움",
  variant: b,
  disabled: $,
  className: k = "",
  maxLength: w,
  numeric: x = !1,
  ariaLabel: E,
  autoFocus: g,
  onEnter: h,
  onEscape: N,
  onBlur: D,
  invalid: j
}) {
  const B = s ? "source" : "static", I = E != null ? E : (s == null ? void 0 : s.title) || (typeof _ == "string" && _ !== "코드도움" ? _ : "") || "코드", T = b != null ? b : B === "source" ? "modal" : "anchor", P = u != null ? u : l ? "summary" : "input", [ee, F] = S(!1), L = p != null ? p : ee, ae = le(
    (H) => {
      p === void 0 && F(H), f && f(H);
    },
    [p, f]
  ), te = q(null), v = q(null), R = q(null), [Y, Z] = S(null), C = () => {
    if (!$) {
      if (T === "anchor") {
        const H = te.current;
        if (!H) return;
        const _e = H.getBoundingClientRect(), ze = 320, Lt = _e.bottom + ze > window.innerHeight ? Math.max(8, _e.top - ze - 4) : _e.bottom + 4;
        Z({ left: Math.min(_e.left, window.innerWidth - 320), top: Lt });
      }
      ae(!0);
    }
  }, V = le(() => ae(!1), [ae]), [J, X] = S(!1), [z, O] = S(null), K = q(null);
  (!K.current || K.current.name !== t) && (K.current = { name: t, code: e });
  const Q = Ic(e, K.current, z, o), Ne = Gn(e, Q, a), He = Gn(e, Q), qe = (H) => {
    !l && H[0] && O({ code: H[0].cd, name: H[0].nm }), i ? i(H) : H[0] && r && r(H[0].cd, { code: H[0].cd, name: H[0].nm });
  }, { sugg: ue, active: Oe, setActive: jt, suggPos: at, suggId: Pe, runSuggest: Bn, cancelSuggest: Xe } = qi({ source: s, items: o, anchorRef: te }), un = (H) => {
    Xe(), qe([H]);
  };
  return /* @__PURE__ */ n.createElement("span", { ref: te, className: [P === "none" ? U.rootNone : U.root, k].filter(Boolean).join(" ") }, P === "input" && /* @__PURE__ */ n.createElement("span", { className: U.field }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: U.codeInput,
      style: { paddingRight: 24 },
      value: J ? e : Ne,
      placeholder: y,
      disabled: $,
      maxLength: w,
      inputMode: x ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: g,
      "aria-label": I,
      "aria-invalid": j ? !0 : void 0,
      onChange: (H) => {
        const _e = H.target.value.trim(), ze = x ? _e.replace(/[^0-9]/g, "") : _e, Lt = w ? ze.slice(0, w) : ze;
        r && r(Lt), !$ && (s || o) && Bn(Lt);
      },
      onKeyDown: (H) => {
        if (H.key === "F2") {
          H.preventDefault(), Xe(), C();
          return;
        }
        if (!ue) {
          H.key === "Enter" && h && !H.nativeEvent.isComposing ? (H.preventDefault(), h()) : H.key === "Escape" && N && (H.preventDefault(), N());
          return;
        }
        const _e = ue.rows.length;
        H.key === "ArrowDown" && _e ? (H.preventDefault(), jt((ze) => (ze + 1) % _e)) : H.key === "ArrowUp" && _e ? (H.preventDefault(), jt((ze) => (ze <= 0 ? _e : ze) - 1)) : H.key === "Enter" && Oe >= 0 && ue.rows[Oe] ? (H.preventDefault(), un(ue.rows[Oe])) : H.key === "Enter" && h && !H.nativeEvent.isComposing ? (H.preventDefault(), Xe(), h()) : H.key === "Escape" && (H.preventDefault(), H.stopPropagation(), H.nativeEvent.stopImmediatePropagation(), Xe());
      },
      onFocus: () => X(!0),
      onBlur: () => {
        X(!1), Xe(), D && D();
      },
      title: typeof j == "string" && j ? j : He && He !== e ? `${He} (F2: 코드도움)` : "F2: 코드도움",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!ue,
      "aria-controls": ue ? Pe.current : void 0,
      "aria-activedescendant": ue && Oe >= 0 ? `${Pe.current}-${Oe}` : void 0,
      "aria-describedby": typeof j == "string" && j ? `${Pe.current}-inv` : void 0
    }
  ), typeof j == "string" && j && /* @__PURE__ */ n.createElement(_r, { id: `${Pe.current}-inv` }, j), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: U.pickBtn,
      "aria-label": "코드도움 열기",
      disabled: $,
      onClick: C,
      onMouseDown: (H) => H.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement(bn, { name: "search", size: 13 })
  )), P === "summary" && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.summaryBtn, disabled: $, onClick: C }, /* @__PURE__ */ n.createElement("span", null, qc(c != null ? c : [], d, a)), /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ n.createElement(bn, { name: "search", size: 13 }))), ue && at && P === "input" && !L && /* @__PURE__ */ n.createElement(Kt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: U.suggest,
      style: { left: at.left, top: at.top, width: at.width },
      onMouseDown: (H) => H.preventDefault()
    },
    ue.rows.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: U.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ n.createElement("ul", { id: Pe.current, role: "listbox", className: U.suggestList }, ue.rows.map((H, _e) => /* @__PURE__ */ n.createElement(
      "li",
      {
        key: H.cd,
        id: `${Pe.current}-${_e}`,
        role: "option",
        "aria-selected": _e === Oe,
        className: [U.suggestRow, _e === Oe ? U.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => jt(_e),
        onClick: () => un(H)
      },
      /* @__PURE__ */ n.createElement("code", null, Ea(H.cd, ue.q)),
      /* @__PURE__ */ n.createElement("span", null, Ea(H.nm, ue.q)),
      H.useYn === !1 && /* @__PURE__ */ n.createElement("em", null, "중단")
    ))),
    ue.more && /* @__PURE__ */ n.createElement("div", { className: U.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), L && B === "static" && T === "anchor" && Y && /* @__PURE__ */ n.createElement(
    Ti,
    {
      items: o != null ? o : [],
      value: e,
      title: _,
      popupRef: v,
      anchorRef: te,
      pos: Y,
      onPick: (H) => {
        O({ code: H.code, name: H.name }), r && r(H.code, H), V();
      },
      onClose: V
    }
  ), L && (B === "source" || T === "modal") && /* @__PURE__ */ n.createElement(
    ji,
    {
      source: s,
      items: o,
      title: _,
      multiple: l,
      selected: c,
      current: m,
      searchRef: R,
      onConfirm: (H) => {
        qe(H), V();
      },
      onClose: V
    }
  ));
}
const ra = 864e5;
function Ii(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Le(e, t) {
  return t === 2 ? Ii(e) ? 29 : 28 : t === 4 || t === 6 || t === 9 || t === 11 ? 30 : 31;
}
function gt(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / ra);
}
function Ri(e) {
  const t = new Date(e * ra);
  return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, "0")}-${String(t.getUTCDate()).padStart(2, "0")}`;
}
function Cn(e, t) {
  return Ri(gt(e) + t);
}
function oa(e) {
  return new Date(gt(e) * ra).getUTCDay();
}
const va = "1900-01-01", ka = "2099-12-31", qn = ["일", "월", "화", "수", "목", "금", "토"], gn = (e) => String(e).padStart(2, "0");
function nt(e, t, a) {
  return `${String(e).padStart(4, "0")}-${gn(t)}-${gn(a)}`;
}
function de(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2], o = +t[3];
  return r < 1 || r > 12 || o < 1 || o > Le(a, r) ? null : { y: a, m: r, d: o };
}
function Oi(e) {
  const t = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2];
  return r < 1 || r > 12 ? null : { y: a, m: r, d: 1 };
}
function Vt(e, t) {
  return t === "month" ? Oi(e) : de(e);
}
function Be(e, t) {
  return t === "month" ? `${String(e.y).padStart(4, "0")}-${gn(e.m)}` : nt(e.y, e.m, e.d);
}
function Ie(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function sn(e, t) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + t));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function Et(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), o = (a % 12 + 12) % 12 + 1;
  return { y: r, m: o, d: Math.min(e.d, Le(r, o)) };
}
function Pi(e, t, a) {
  return e >= t && e <= a;
}
function It(e, t) {
  return e.replace(/\D/g, "").slice(0, t === "month" ? 6 : 8);
}
function In(e, t) {
  const a = e.slice(0, 4), r = e.slice(4, 6), o = e.slice(6, 8);
  let s = a;
  return e.length > 4 && (s += "-" + r), t === "date" && e.length > 6 && (s += "-" + o), s;
}
function wa(e, t) {
  if (t <= 0) return 0;
  let a = 0;
  for (let r = 0; r < e.length; r++)
    if (/\d/.test(e[r]) && (a++, a === t))
      return r + 1;
  return e.length;
}
function pn(e, t, a) {
  let r, o, s = 1;
  if (t === "month")
    if (e.length === 6)
      r = +e.slice(0, 4), o = +e.slice(4, 6);
    else if (e.length === 4)
      r = 2e3 + +e.slice(0, 2), o = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    r = +e.slice(0, 4), o = +e.slice(4, 6), s = +e.slice(6, 8);
  else if (e.length === 6)
    r = 2e3 + +e.slice(0, 2), o = +e.slice(2, 4), s = +e.slice(4, 6);
  else if (e.length === 4)
    r = a.y, o = +e.slice(0, 2), s = +e.slice(2, 4);
  else return null;
  return o < 1 || o > 12 || s < 1 || s > Le(r, o) ? null : { y: r, m: o, d: s };
}
function Xi(e, t, a) {
  const r = e.trim(), o = t === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(r) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(r);
  if (o) {
    const s = { y: +o[1], m: +o[2], d: t === "month" ? 1 : +o[3] };
    return s.m >= 1 && s.m <= 12 && s.d >= 1 && s.d <= Le(s.y, s.m) ? s : null;
  }
  return pn(r.replace(/\D/g, ""), t, a);
}
function zi(e, t) {
  const a = { y: e, m: t, d: 1 }, r = sn(a, -Ie(a));
  return Array.from({ length: 42 }, (o, s) => sn(r, s));
}
function Fi(e, t) {
  const a = e.y, r = [], o = (m, u) => `${String(m).padStart(4, "0")}-${gn(u)}`, s = (m, u, d) => nt(m, u, d);
  if (t === "month") {
    r.push({ label: "이번 달", from: o(a, e.m), to: o(a, e.m) });
    const m = Et(e, -1);
    r.push({ label: "지난달", from: o(m.y, m.m), to: o(m.y, m.m) }), r.push({ label: "올해", from: o(a, 1), to: o(a, 12) }), r.push({ label: "올해 누계", from: o(a, 1), to: o(a, e.m) }), r.push({ label: "전년도", from: o(a - 1, 1), to: o(a - 1, 12) });
    for (let u = 1; u <= 4; u++) r.push({ label: `${u}분기`, from: o(a, u * 3 - 2), to: o(a, u * 3) });
    return r.push({ label: "상반기", from: o(a, 1), to: o(a, 6) }), r.push({ label: "하반기", from: o(a, 7), to: o(a, 12) }), r;
  }
  const l = nt(e.y, e.m, e.d);
  r.push({ label: "오늘", from: l, to: l });
  const c = sn(e, -Ie(e));
  r.push({ label: "이번 주", from: Be(c, "date"), to: Be(sn(c, 6), "date") }), r.push({ label: "이번 달", from: s(a, e.m, 1), to: s(a, e.m, Le(a, e.m)) });
  const i = Et({ ...e, d: 1 }, -1);
  r.push({ label: "지난달", from: s(i.y, i.m, 1), to: s(i.y, i.m, Le(i.y, i.m)) }), r.push({ label: "올해", from: s(a, 1, 1), to: s(a, 12, 31) }), r.push({ label: "올해 오늘까지", from: s(a, 1, 1), to: l }), r.push({ label: "전년도", from: s(a - 1, 1, 1), to: s(a - 1, 12, 31) });
  for (let m = 1; m <= 4; m++)
    r.push({ label: `${m}분기`, from: s(a, m * 3 - 2, 1), to: s(a, m * 3, Le(a, m * 3)) });
  return r;
}
const Wi = "_wrap_uxy72_1", Hi = "_disabled_uxy72_18", Ki = "_input_uxy72_22", Ui = "_month_uxy72_36", Yi = "_weekday_uxy72_39", Gi = "_sun_uxy72_40", Vi = "_sat_uxy72_41", Ji = "_icon_uxy72_43", Qi = "_readOnly_uxy72_57", Zi = "_required_uxy72_62", eu = "_invalid_uxy72_63", tu = "_pop_uxy72_66", nu = "_calHead_uxy72_79", au = "_calTitleStatic_uxy72_80", ru = "_calTitle_uxy72_80", ou = "_grid_uxy72_90", su = "_wd_uxy72_91", lu = "_day_uxy72_95", cu = "_mon_uxy72_36", iu = "_out_uxy72_104", uu = "_sel_uxy72_105", mu = "_today_uxy72_108", du = "_months_uxy72_111", _u = "_foot_uxy72_114", fu = "_clear_uxy72_127", pu = "_range_uxy72_130", yu = "_tilde_uxy72_131", bu = "_rangeErr_uxy72_132", re = {
  wrap: Wi,
  disabled: Hi,
  input: Ki,
  month: Ui,
  weekday: Yi,
  sun: Gi,
  sat: Vi,
  icon: Ji,
  readOnly: Qi,
  required: Zi,
  invalid: eu,
  pop: tu,
  calHead: nu,
  calTitleStatic: au,
  calTitle: ru,
  grid: ou,
  wd: su,
  day: lu,
  mon: cu,
  out: iu,
  sel: uu,
  today: mu,
  months: du,
  foot: _u,
  clear: fu,
  range: pu,
  tilde: yu,
  rangeErr: bu
}, pt = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function Na({
  value: e,
  onChange: t,
  mode: a = "date",
  min: r,
  max: o,
  disabled: s,
  readOnly: l,
  required: c,
  invalid: i,
  showWeekday: m,
  onReject: u,
  placeholder: d,
  id: p,
  name: f,
  onBlur: y,
  "aria-label": _,
  "aria-describedby": b,
  className: $ = "",
  style: k
}) {
  const w = a === "month", x = Ut("axe-dp"), E = r || (w ? va.slice(0, 7) : va), g = o || (w ? ka.slice(0, 7) : ka), h = (M) => Pi(M, E, g), N = !!s || !!l, [D, j] = S(e || ""), [B, I] = S(!1), [T, P] = S(!1), [ee, F] = S(w ? "month" : "day"), [L, ae] = S(() => {
    var W;
    const M = (W = Vt(e, a)) != null ? W : pt();
    return { y: M.y, m: M.m };
  }), [te, v] = S({ top: 0, left: 0 }), R = q(null), Y = q(null), Z = q(null), C = q(null);
  G(() => {
    j(e || ""), I(!1);
  }, [e]), G(() => {
    const M = Vt(e, a);
    M && ae({ y: M.y, m: M.m });
  }, [e, a]), je(() => {
    const M = Y.current;
    C.current != null && M && document.activeElement === M && M.setSelectionRange(C.current, C.current), C.current = null;
  }, [D]), je(() => {
    if (!T) return;
    const M = () => {
      const W = R.current, oe = Z.current;
      if (!W || !oe) return;
      const ce = W.getBoundingClientRect(), me = oe.offsetHeight, ge = oe.offsetWidth;
      let De = ce.bottom + 4;
      De + me > window.innerHeight - 8 && ce.top - me - 4 > 8 && (De = ce.top - me - 4);
      const Yt = Math.max(8, Math.min(ce.left, window.innerWidth - ge - 8));
      v((jn) => jn.top === De && jn.left === Yt ? jn : { top: De, left: Yt });
    };
    return M(), window.addEventListener("resize", M), window.addEventListener("scroll", M, !0), () => {
      window.removeEventListener("resize", M), window.removeEventListener("scroll", M, !0);
    };
  }, [T, ee, L.y, L.m]), G(() => {
    if (!T) return;
    const M = (W) => {
      var ce, me;
      const oe = W.target;
      (ce = R.current) != null && ce.contains(oe) || (me = Z.current) != null && me.contains(oe) || P(!1);
    };
    return document.addEventListener("mousedown", M), () => document.removeEventListener("mousedown", M);
  }, [T]);
  const V = (M) => {
    M !== (e || "") && t(M);
  }, J = (M) => {
    j(M), I(!1), V(M);
  }, X = () => {
    const M = It(D, a);
    if (!M) return;
    const W = pn(M, a, pt()), oe = W ? Be(W, a) : null;
    if (oe && h(oe)) {
      J(oe);
      return;
    }
    u == null || u(D, oe ? "range" : "format"), j(e || ""), I(!1);
  }, z = (M, W) => {
    const oe = It(M.slice(0, W), a).length, ce = It(M, a), me = In(ce, a);
    if (C.current = wa(me, Math.min(oe, ce.length)), j(me), !ce) {
      I(!1), V("");
      return;
    }
    if (ce.length === (w ? 6 : 8)) {
      const ge = pn(ce, a, pt()), De = ge ? Be(ge, a) : null;
      De && h(De) ? (I(!1), V(De)) : I(!0);
    } else I(!1);
  }, O = (M, W) => {
    var Yt;
    const oe = pt(), ce = It(D, a), me = (Yt = pn(ce, a, oe)) != null ? Yt : Vt(e, a);
    let ge;
    me ? w ? ge = Et(me, M === "year" ? 12 * W : W) : M === "day" ? ge = sn(me, W) : ge = Et(me, M === "month" ? W : 12 * W) : ge = oe;
    const De = Be(ge, a);
    h(De) && J(De);
  }, K = (M) => {
    var W;
    J(M), P(!1), (W = Y.current) == null || W.focus();
  }, Q = () => {
    var W;
    if (N) return;
    const M = (W = Vt(e, a)) != null ? W : pt();
    ae({ y: M.y, m: M.m }), F(w ? "month" : "day"), P(!0);
  }, Ne = (M) => {
    var oe, ce;
    if (N) return;
    const W = M.currentTarget;
    switch (M.key) {
      case "Escape":
        T ? (P(!1), M.preventDefault(), M.stopPropagation(), M.nativeEvent.stopImmediatePropagation()) : D !== (e || "") && (j(e || ""), I(!1), M.preventDefault(), M.stopPropagation(), M.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => W.select()));
        break;
      case "ArrowDown":
        M.preventDefault(), M.altKey ? T ? P(!1) : Q() : O("day", 1);
        break;
      case "ArrowUp":
        M.preventDefault(), O("day", -1);
        break;
      case "PageDown":
        M.preventDefault(), O("month", 1);
        break;
      case "PageUp":
        M.preventDefault(), O("month", -1);
        break;
      case "F2":
      case "F4":
        M.preventDefault(), T ? P(!1) : Q();
        break;
      case "Enter":
        X(), T && P(!1);
        break;
      case "t":
      case "T":
        if (M.ctrlKey || M.metaKey || M.altKey) break;
        M.preventDefault(), J(Be(pt(), a));
        break;
      case "Backspace": {
        const me = (oe = W.selectionStart) != null ? oe : 0;
        if (me === ((ce = W.selectionEnd) != null ? ce : 0) && me > 0 && D[me - 1] === "-") {
          M.preventDefault();
          const ge = It(D.slice(0, me), a).length, De = It(D, a);
          z(In(De.slice(0, ge - 1) + De.slice(ge), a), 0), C.current = wa(In(De.slice(0, ge - 1) + De.slice(ge), a), ge - 1);
        }
        break;
      }
    }
  }, He = (M) => {
    if (N) return;
    M.preventDefault();
    const W = Xi(M.clipboardData.getData("text"), a, pt()), oe = W ? Be(W, a) : null;
    oe && h(oe) ? J(oe) : I(!0);
  }, qe = (M) => {
    var oe, ce;
    const W = M.relatedTarget;
    W && ((oe = R.current) != null && oe.contains(W) || (ce = Z.current) != null && ce.contains(W)) || (X(), P(!1), y && y());
  }, ue = Vt(e, a), Oe = pt(), jt = B || !!i, at = m && !w && ue ? Ie(ue) : null, Pe = (M) => Be(M, a), Bn = (M, W) => {
    const oe = Be({ y: M, m: W, d: 1 }, "date"), ce = Be({ y: M, m: W, d: Le(M, W) }, "date"), me = w ? E + "-01" : E, ge = w ? g + "-31" : g;
    return ce >= me && oe <= ge;
  }, Xe = (M) => {
    const W = Et({ y: L.y, m: L.m, d: 1 }, M);
    ae({ y: W.y, m: W.m });
  }, un = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: re.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Xe(-12) }, "«"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => Xe(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: re.calTitle, "aria-label": "연·월 선택", onClick: () => F("month") }, L.y, "년 ", L.m, "월"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => Xe(1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Xe(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: re.grid }, qn.map((M, W) => /* @__PURE__ */ n.createElement("span", { key: M, className: [re.wd, W === 0 ? re.sun : "", W === 6 ? re.sat : ""].join(" ") }, M)), zi(L.y, L.m).map((M) => {
    const W = Be(M, "date"), oe = Ie(M), ce = [
      re.day,
      M.m !== L.m ? re.out : "",
      oe === 0 ? re.sun : "",
      oe === 6 ? re.sat : "",
      W === Be(Oe, "date") ? re.today : "",
      ue && W === Be(ue, "date") ? re.sel : ""
    ].join(" "), me = !h(W);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: W,
        type: "button",
        tabIndex: -1,
        className: ce,
        disabled: me,
        "aria-label": `${M.y}년 ${M.m}월 ${M.d}일 ${qn[oe]}요일`,
        "aria-pressed": !!ue && W === Be(ue, "date"),
        onClick: () => K(W)
      },
      M.d
    );
  }))), H = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: re.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Xe(-12) }, "«"), /* @__PURE__ */ n.createElement("span", { className: re.calTitleStatic }, L.y, "년"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Xe(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: re.months }, Array.from({ length: 12 }, (M, W) => W + 1).map((M) => {
    const W = !!ue && ue.y === L.y && ue.m === M, oe = [re.mon, W ? re.sel : "", Oe.y === L.y && Oe.m === M ? re.today : ""].join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: M,
        type: "button",
        tabIndex: -1,
        className: oe,
        disabled: !Bn(L.y, M),
        "aria-pressed": W,
        onClick: () => {
          w ? K(Pe({ y: L.y, m: M, d: 1 })) : (ae({ y: L.y, m: M }), F("day"));
        }
      },
      M,
      "월"
    );
  }))), _e = Be(Oe, a), ze = w ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !h(_e), onClick: () => K(_e) }, "이번 달")) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !h(_e), onClick: () => K(_e) }, "오늘"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !h(Pe({ y: L.y, m: L.m, d: 1 })),
      onClick: () => K(Pe({ y: L.y, m: L.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !h(Pe({ y: L.y, m: L.m, d: Le(L.y, L.m) })),
      onClick: () => K(Pe({ y: L.y, m: L.m, d: Le(L.y, L.m) }))
    },
    "월말"
  )), Lt = [
    re.wrap,
    s ? re.disabled : "",
    l ? re.readOnly : "",
    c && !e && !D ? re.required : "",
    jt ? re.invalid : "",
    w ? re.month : "",
    $
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.createElement("span", { ref: R, className: Lt, style: k, onBlur: qe }, /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: Y,
      id: p,
      name: f,
      className: re.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: D,
      placeholder: d != null ? d : w ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: s,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": T,
      "aria-controls": x,
      "aria-label": _,
      "aria-describedby": b,
      "aria-invalid": jt || void 0,
      "aria-required": c || void 0,
      onChange: (M) => {
        var W;
        return z(M.target.value, (W = M.target.selectionStart) != null ? W : M.target.value.length);
      },
      onKeyDown: Ne,
      onPaste: He
    }
  ), at != null && /* @__PURE__ */ n.createElement("span", { className: [re.weekday, at === 0 ? re.sun : "", at === 6 ? re.sat : ""].join(" "), "aria-hidden": "true" }, "(", qn[at], ")"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: re.icon,
      disabled: N,
      "aria-label": w ? "월 선택 열기" : "달력 열기",
      onMouseDown: (M) => M.preventDefault(),
      onClick: () => {
        var M;
        (M = Y.current) == null || M.focus(), T ? P(!1) : Q();
      }
    },
    /* @__PURE__ */ n.createElement(bn, { name: "calendar", size: 15 })
  ), T && /* @__PURE__ */ n.createElement(Kt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: Z,
      id: x,
      className: re.pop,
      style: { top: te.top, left: te.left },
      role: "dialog",
      "aria-label": w ? "월 선택" : "날짜 선택",
      onMouseDown: (M) => M.preventDefault()
    },
    ee === "day" && !w ? un() : H(),
    /* @__PURE__ */ n.createElement("div", { className: re.foot }, ze, !c && /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: re.clear, onClick: () => K("") }, "지우기"))
  )));
}
const Ct = (e) => String(e).padStart(2, "0");
function pr() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${Ct(e.getMonth() + 1)}-${Ct(e.getDate())}`;
}
function t0(e) {
  if (!e) return "";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? String(e) : `${t.getFullYear()}-${Ct(t.getMonth() + 1)}-${Ct(t.getDate())} ${Ct(t.getHours())}:${Ct(t.getMinutes())}:${Ct(t.getSeconds())}`;
}
function n0(e, t) {
  return !!e && !!t && e <= t;
}
function a0({
  from: e,
  to: t,
  onChange: a,
  mode: r = "date",
  min: o,
  max: s,
  disabled: l,
  label: c = "기간",
  presets: i = !0,
  showWeekday: m,
  onReject: u
}) {
  const d = !!e && !!t && e > t, p = /* @__PURE__ */ new Date(), f = i === !1 ? [] : Array.isArray(i) ? i : Fi({ y: p.getFullYear(), m: p.getMonth() + 1, d: p.getDate() }, r), y = (_) => (!o || _.from >= o) && (!s || _.to <= s);
  return /* @__PURE__ */ n.createElement("span", { className: re.range }, /* @__PURE__ */ n.createElement(
    Na,
    {
      value: e,
      mode: r,
      min: o,
      max: s,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 시작`,
      onChange: (_) => a(_, t),
      onReject: u && ((_, b) => u(_, b, "from"))
    }
  ), /* @__PURE__ */ n.createElement("span", { className: re.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ n.createElement(
    Na,
    {
      value: t,
      mode: r,
      min: o,
      max: s,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 끝`,
      onChange: (_) => a(e, _),
      onReject: u && ((_, b) => u(_, b, "to"))
    }
  ), f.length > 0 && /* @__PURE__ */ n.createElement(
    Lo,
    {
      label: "기간",
      title: `${c} 빠른 선택`,
      disabled: l,
      entries: f.map((_) => jo(
        _.label,
        _.label,
        () => a(_.from, _.to),
        y(_) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), d && /* @__PURE__ */ n.createElement("span", { className: re.rangeErr, role: "alert" }, "시작이 끝보다 늦습니다"));
}
const yr = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function br(e, t = yr) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let r = null;
  for (const o of t) o.start <= e.slice(0, 10) && (!r || o.start > r.start) && (r = o);
  return r ? { era: r, year: +a[1] - +r.start.slice(0, 4) + 1 } : null;
}
function hu(e, t = {}) {
  const a = br(e, t.eras);
  return a ? `${a.era.name}${a.year === 1 && t.gannen !== !1 ? "元" : a.year}年` : null;
}
function r0(e, t) {
  const a = br(e, t);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Se = 1440, En = (e) => String(e).padStart(2, "0");
function ye(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return t ? Date.UTC(+t[1], +t[2] - 1, +t[3], t[4] ? +t[4] : 0, t[5] ? +t[5] : 0) / 6e4 : NaN;
}
function St(e) {
  const t = new Date(e * 6e4);
  return nt(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
}
function tn(e) {
  const t = new Date(e * 6e4);
  return `${St(e)}T${En(t.getUTCHours())}:${En(t.getUTCMinutes())}`;
}
function et(e) {
  const t = (e % Se + Se) % Se;
  return `${En(Math.floor(t / 60))}:${En(t % 60)}`;
}
function ke(e, t) {
  return de(e) ? Cn(e, t) : e;
}
function Wt(e, t) {
  return Math.round((ye(t) - ye(e)) / Se);
}
function ln(e) {
  if (!de(e)) return !1;
  const t = oa(e);
  return t === 0 || t === 6;
}
function gu(e) {
  var o;
  const t = ye(e.start);
  if (Number.isNaN(t)) return null;
  const a = (o = e.allDay) != null ? o : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const s = St(t), l = e.end ? St(ye(e.end)) : s, c = l < s ? s : l;
    return { ev: e, s: ye(s), e: ye(c) + Se, allDay: a, sDay: s, eDay: c };
  }
  let r = e.end ? ye(e.end) : t + 60;
  return (Number.isNaN(r) || r <= t) && (r = t + 30), { ev: e, s: t, e: r, allDay: a, sDay: St(t), eDay: St(r - 1) };
}
function An(e, t, a, r) {
  const o = [];
  for (const s of e) {
    const l = r && s.id === r.id ? { ...s, start: r.start, end: r.end } : s, c = gu(l);
    c && c.eDay >= t && c.sDay <= a && o.push(c);
  }
  return o.sort(Eu);
}
function Eu(e, t) {
  if (e.sDay !== t.sDay) return e.sDay < t.sDay ? -1 : 1;
  const a = Wt(t.sDay, t.eDay) - Wt(e.sDay, e.eDay);
  return a || (e.allDay !== t.allDay ? e.allDay ? -1 : 1 : e.s !== t.s ? e.s - t.s : e.ev.title.localeCompare(t.ev.title));
}
function vu(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function hr(e) {
  return e.allDay || e.e - e.s >= Se;
}
function vn(e, t) {
  const a = de(e);
  if (!a) return e;
  const r = (Ie(a) - t + 7) % 7;
  return ke(e, -r);
}
function Sn(e, t) {
  const a = Wt(e, t);
  return Array.from({ length: Math.max(0, a + 1) }, (r, o) => ke(e, o));
}
function gr(e, t) {
  const a = de(e), r = nt(a.y, a.m, 1), o = nt(a.y, a.m, Le(a.y, a.m)), s = vn(r, t), l = ke(vn(o, t), 6), c = Sn(s, l), i = [];
  for (let m = 0; m < c.length; m += 7) i.push(c.slice(m, m + 7));
  return i;
}
function sa(e, t, a) {
  if (e === "month") {
    const r = gr(t, a);
    return { from: r[0][0], to: r[r.length - 1][6] };
  }
  if (e === "agenda") {
    const r = de(t);
    return { from: nt(r.y, r.m, 1), to: nt(r.y, r.m, Le(r.y, r.m)) };
  }
  if (e === "week") {
    const r = vn(t, a);
    return { from: r, to: ke(r, 6) };
  }
  return { from: t, to: t };
}
function ku(e, t, a, r = !1) {
  const o = de(t);
  if (!o) return t;
  if (e === "month" || e === "agenda") {
    const l = Et(o, a);
    return nt(l.y, l.m, l.d);
  }
  if (e === "week") return ke(t, 7 * a);
  let s = ke(t, a);
  for (; r && ln(s); ) s = ke(s, a);
  return s;
}
function wu(e, t, a, r) {
  if (!de(t)) return "";
  if (e === "month" || e === "agenda") return r.ym(`${t.slice(0, 7)}-01`);
  if (e === "day") return r.dayTitle(t);
  const { from: o, to: s } = sa("week", t, a);
  return r.year(o) !== r.year(s) ? `${r.ymd(o)} – ${r.ymd(s)}` : o.slice(5, 7) !== s.slice(5, 7) ? `${r.ymd(o)} – ${r.md(s)}` : `${r.ymd(o)} – ${r.d(s)}`;
}
function Er(e, t) {
  const a = [], r = [];
  for (const o of e) {
    let s = -1, l = -1;
    for (let i = 0; i < t.length; i++)
      t[i] >= o.sDay && t[i] <= o.eDay && (s < 0 && (s = i), l = i);
    if (s < 0) continue;
    let c = r.findIndex((i) => i < s);
    c < 0 ? (c = r.length, r.push(l)) : r[c] = l, a.push({ item: o, col: s, span: l - s + 1, lane: c, contL: o.sDay < t[s], contR: o.eDay > t[l] });
  }
  return a;
}
function Nu(e, t, a) {
  const r = new Array(t).fill(0);
  for (const c of e) for (let i = c.col; i < c.col + c.span; i++) r[i]++;
  const o = Math.max(1, a), s = e.filter((c) => {
    if (c.lane < o - 1) return !0;
    if (c.lane > o - 1) return !1;
    for (let i = c.col; i < c.col + c.span; i++) if (r[i] > o) return !1;
    return !0;
  }), l = new Array(t).fill(0);
  for (const c of s) for (let i = c.col; i < c.col + c.span; i++) l[i]++;
  return { shown: s, more: r.map((c, i) => c - l[i]) };
}
const $u = 20;
function xu(e, t) {
  const a = ye(t), r = a + Se, o = e.filter((m) => !hr(m) && m.s < r && m.e > a).map((m) => ({
    item: m,
    top: Math.max(m.s, a) - a,
    bottom: Math.min(m.e, r) - a,
    col: 0,
    cols: 1,
    contTop: m.s < a,
    contBottom: m.e > r
  })).sort((m, u) => m.top - u.top || u.bottom - m.bottom);
  let s = [], l = [], c = -1;
  const i = () => {
    for (const m of s) m.cols = l.length;
    s = [], l = [];
  };
  for (const m of o) {
    m.top >= c && i();
    const u = Math.max(m.bottom, m.top + $u);
    let d = l.findIndex((p) => p <= m.top);
    d < 0 ? (d = l.length, l.push(u)) : l[d] = u, m.col = d, s.push(m), c = Math.max(c, u);
  }
  return i(), o;
}
function $a(e, t) {
  return Math.round(e / t) * t;
}
function Vn(e, t) {
  if (e.allDay) {
    const a = Math.round(t / Se);
    return { start: ke(e.sDay, a), end: ke(e.eDay, a) };
  }
  return { start: tn(e.s + t), end: tn(e.e + t) };
}
function la(e, t = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return t;
    const l = de(e.sDay), c = de(e.eDay);
    return `${l.m}/${l.d} – ${c.m}/${c.d}`;
  }
  const a = ye(e.sDay), r = et(e.s - a);
  if (e.sDay === e.eDay) return `${r} – ${e.e - a === Se ? "24:00" : et(e.e - a)}`;
  const o = de(e.sDay), s = de(St(e.e));
  return `${o.m}/${o.d} ${r} – ${s.m}/${s.d} ${et(e.e - ye(St(e.e)))}`;
}
const Ce = (e) => {
  const t = de(e);
  return { ...t, w: Ie(t) };
};
function xa(e, t, a, r, o) {
  const s = `${+e.slice(0, 4)}${a}`;
  if (t === "gregorian") return s;
  const l = hu(e, { eras: r, gannen: o });
  return l ? t === "era" ? l : `${s}(${l})` : s;
}
function Du(e = "ko", t = {}) {
  var i, m;
  const a = (i = t.year) != null ? i : e === "ja" ? "era" : "gregorian", r = (m = t.eras) != null ? m : yr, o = t.gannen !== !1;
  if (e === "ja") {
    const u = ["日", "月", "火", "水", "木", "金", "土"], d = (f) => xa(f, a, "年", r, o), p = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: u,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (f) => `前の${p[f]} (P)`,
      next: (f) => `次の${p[f]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (f) => `他${f}件`,
      eventCount: (f) => `予定${f}件`,
      dayOfSpan: (f, y) => `${f}/${y}日目`,
      openDay: (f) => {
        const y = Ce(f);
        return `${y.m}月${y.d}日を日表示`;
      },
      year: d,
      ym: (f) => `${d(f)}${Ce(f).m}月`,
      ymd: (f) => {
        const y = Ce(f);
        return `${d(f)}${y.m}月${y.d}日`;
      },
      md: (f) => {
        const y = Ce(f);
        return `${y.m}月${y.d}日`;
      },
      d: (f) => `${Ce(f).d}日`,
      m: (f) => `${Ce(f).m}月`,
      dayTitle: (f) => {
        const y = Ce(f);
        return `${d(f)}${y.m}月${y.d}日(${u[y.w]})`;
      },
      dayAria: (f) => {
        const y = Ce(f);
        return `${y.m}月${y.d}日 ${u[y.w]}曜日`;
      }
    };
  }
  const s = ["일", "월", "화", "수", "목", "금", "토"], l = (u) => xa(u, a, "년", r, o), c = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: s,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (u) => `이전 ${c[u]} (P)`,
    next: (u) => `다음 ${c[u]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (u) => `+${u}개`,
    eventCount: (u) => `일정 ${u}건`,
    dayOfSpan: (u, d) => `${u}/${d}일째`,
    openDay: (u) => {
      const d = Ce(u);
      return `${d.m}월 ${d.d}일 일 보기`;
    },
    year: l,
    ym: (u) => `${l(u)} ${Ce(u).m}월`,
    ymd: (u) => {
      const d = Ce(u);
      return `${l(u)} ${d.m}월 ${d.d}일`;
    },
    md: (u) => {
      const d = Ce(u);
      return `${d.m}월 ${d.d}일`;
    },
    d: (u) => `${Ce(u).d}일`,
    m: (u) => `${Ce(u).m}월`,
    dayTitle: (u) => {
      const d = Ce(u);
      return `${l(u)} ${d.m}월 ${d.d}일 (${s[d.w]})`;
    },
    dayAria: (u) => {
      const d = Ce(u);
      return `${d.m}월 ${d.d}일 ${s[d.w]}요일`;
    }
  };
}
const vr = Du("ko"), Cu = "_cal_ooj0g_2", Au = "_toolbar_ooj0g_20", Su = "_navBtns_ooj0g_28", Mu = "_title_ooj0g_29", Tu = "_toolRight_ooj0g_36", Bu = "_toggle_ooj0g_37", ju = "_body_ooj0g_58", Lu = "_busy_ooj0g_59", qu = "_sun_ooj0g_71", Iu = "_sat_ooj0g_72", Ru = "_tAccent_ooj0g_75", Ou = "_tOk_ooj0g_76", Pu = "_tWarn_ooj0g_77", Xu = "_tDanger_ooj0g_78", zu = "_tViolet_ooj0g_79", Fu = "_tGray_ooj0g_80", Wu = "_month_ooj0g_83", Hu = "_mHead_ooj0g_84", Ku = "_wdName_ooj0g_85", Uu = "_mBody_ooj0g_91", Yu = "_mWeek_ooj0g_92", Gu = "_mCells_ooj0g_94", Vu = "_cell_ooj0g_96", Ju = "_out_ooj0g_104", Qu = "_dayNum_ooj0g_105", Zu = "_creatable_ooj0g_106", em = "_selDay_ooj0g_109", tm = "_cellHead_ooj0g_111", nm = "_isToday_ooj0g_124", am = "_holiday_ooj0g_125", rm = "_addHint_ooj0g_130", om = "_barLayer_ooj0g_138", sm = "_chip_ooj0g_139", lm = "_more_ooj0g_139", cm = "_tEv_ooj0g_155", im = "_aRow_ooj0g_155", um = "_popItem_ooj0g_155", mm = "_bar_ooj0g_138", dm = "_contL_ooj0g_165", _m = "_contR_ooj0g_166", fm = "_dotChip_ooj0g_167", pm = "_dot_ooj0g_167", ym = "_chipTime_ooj0g_170", bm = "_chipTitle_ooj0g_171", hm = "_movable_ooj0g_173", gm = "_ghost_ooj0g_176", Em = "_time_ooj0g_189", vm = "_tHead_ooj0g_190", km = "_tAllDay_ooj0g_190", wm = "_gutter_ooj0g_193", Nm = "_tHeadDays_ooj0g_197", $m = "_tAllDayCells_ooj0g_197", xm = "_tDay_ooj0g_198", Dm = "_tDayBtn_ooj0g_202", Cm = "_tWd_ooj0g_206", Am = "_tDayNum_ooj0g_208", Sm = "_tAllDayRow_ooj0g_216", Mm = "_allDayCell_ooj0g_218", Tm = "_tBody_ooj0g_222", Bm = "_tGrid_ooj0g_223", jm = "_tGutter_ooj0g_224", Lm = "_tCols_ooj0g_230", qm = "_tCol_ooj0g_230", Im = "_tSel_ooj0g_238", Rm = "_tEvTitle_ooj0g_258", Om = "_tEvTime_ooj0g_259", Pm = "_tEvShort_ooj0g_261", Xm = "_contTop_ooj0g_263", zm = "_contBottom_ooj0g_264", Fm = "_resize_ooj0g_265", Wm = "_now_ooj0g_268", Hm = "_agenda_ooj0g_272", Km = "_aDay_ooj0g_273", Um = "_aDate_ooj0g_275", Ym = "_aDateBtn_ooj0g_276", Gm = "_aDayNum_ooj0g_280", Vm = "_aDayWd_ooj0g_286", Jm = "_aList_ooj0g_288", Qm = "_aTime_ooj0g_295", Zm = "_aTitle_ooj0g_296", ed = "_aSpan_ooj0g_297", td = "_aLoc_ooj0g_298", nd = "_empty_ooj0g_303", ad = "_pop_ooj0g_155", rd = "_popHead_ooj0g_321", od = "_popDay_ooj0g_322", sd = "_popClose_ooj0g_329", ld = "_popList_ooj0g_334", A = {
  cal: Cu,
  toolbar: Au,
  navBtns: Su,
  title: Mu,
  toolRight: Tu,
  toggle: Bu,
  body: ju,
  busy: Lu,
  sun: qu,
  sat: Iu,
  tAccent: Ru,
  tOk: Ou,
  tWarn: Pu,
  tDanger: Xu,
  tViolet: zu,
  tGray: Fu,
  month: Wu,
  mHead: Hu,
  wdName: Ku,
  mBody: Uu,
  mWeek: Yu,
  mCells: Gu,
  cell: Vu,
  out: Ju,
  dayNum: Qu,
  creatable: Zu,
  selDay: em,
  cellHead: tm,
  isToday: nm,
  holiday: am,
  addHint: rm,
  barLayer: om,
  chip: sm,
  more: lm,
  tEv: cm,
  aRow: im,
  popItem: um,
  bar: mm,
  contL: dm,
  contR: _m,
  dotChip: fm,
  dot: pm,
  chipTime: ym,
  chipTitle: bm,
  movable: hm,
  ghost: gm,
  time: Em,
  tHead: vm,
  tAllDay: km,
  gutter: wm,
  tHeadDays: Nm,
  tAllDayCells: $m,
  tDay: xm,
  tDayBtn: Dm,
  tWd: Cm,
  tDayNum: Am,
  tAllDayRow: Sm,
  allDayCell: Mm,
  tBody: Tm,
  tGrid: Bm,
  tGutter: jm,
  tCols: Lm,
  tCol: qm,
  tSel: Im,
  tEvTitle: Rm,
  tEvTime: Om,
  tEvShort: Pm,
  contTop: Xm,
  contBottom: zm,
  resize: Fm,
  now: Wm,
  agenda: Hm,
  aDay: Km,
  aDate: Um,
  aDateBtn: Ym,
  aDayNum: Gm,
  aDayWd: Vm,
  aList: Jm,
  aTime: Qm,
  aTitle: Zm,
  aSpan: ed,
  aLoc: td,
  empty: nd,
  pop: ad,
  popHead: rd,
  popDay: od,
  popClose: sd,
  popList: ld
}, kn = 22, cd = {
  accent: A.tAccent,
  ok: A.tOk,
  warn: A.tWarn,
  danger: A.tDanger,
  violet: A.tViolet,
  gray: A.tGray
};
function Mn(e) {
  var t;
  return e.color ? "" : cd[(t = e.tone) != null ? t : "accent"];
}
function Tn(e) {
  if (e.color)
    return { "--ev": e.color };
}
function kr(e, t) {
  return [e.ev.title, la(e, t.allDay), e.ev.location].filter(Boolean).join(", ");
}
const nn = (e, t) => !!e.onEventChange && !t.locked;
function yn(e, t, a) {
  var r;
  for (const o of document.elementsFromPoint(e, t)) {
    const s = (r = o.closest) == null ? void 0 : r.call(o, `[${a}]`);
    if (s) return s;
  }
  return null;
}
function wn(e, t) {
  const a = e.clientX, r = e.clientY;
  let o = !1;
  const s = (u) => {
    !o && Math.hypot(u.clientX - a, u.clientY - r) < 4 || (o = !0, t.move(u));
  }, l = () => {
    window.removeEventListener("pointermove", s), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", i), window.removeEventListener("keydown", m, !0);
  }, c = (u) => {
    l(), t.end(u, o);
  }, i = () => {
    l(), t.cancel();
  }, m = (u) => {
    u.key === "Escape" && (u.preventDefault(), u.stopPropagation(), i());
  };
  window.addEventListener("pointermove", s), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", i), window.addEventListener("keydown", m, !0);
}
function wr(e) {
  const [t, a] = S(null), [r, o] = S(null), s = q(!1);
  return { preview: t, items: (d, p) => An(e.events, d, p, t), onItemDown: (d, p) => {
    var _;
    if (d.button !== 0 || !nn(e, p.ev)) return;
    const f = (_ = yn(d.clientX, d.clientY, "data-cal-day")) == null ? void 0 : _.dataset.calDay;
    if (!f) return;
    s.current = !1;
    let y = 0;
    wn(d, {
      move: (b) => {
        var k;
        s.current = !0;
        const $ = (k = yn(b.clientX, b.clientY, "data-cal-day")) == null ? void 0 : k.dataset.calDay;
        $ && (y = Wt(f, $), a({ id: p.ev.id, ...Vn(p, y * Se) }));
      },
      end: (b, $) => {
        var k;
        a(null), $ && y && ((k = e.onEventChange) == null || k.call(e, p.ev, Vn(p, y * Se)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (d, p) => {
    if (d.button !== 0 || !e.onCreate) return;
    d.preventDefault();
    let f = p;
    o({ a: p, b: p }), wn(d, {
      move: (y) => {
        var b;
        const _ = (b = yn(y.clientX, y.clientY, "data-cal-day")) == null ? void 0 : b.dataset.calDay;
        _ && (f = _, o({ a: p, b: _ }));
      },
      end: () => {
        var b;
        o(null);
        const [y, _] = p <= f ? [p, f] : [f, p];
        (b = e.onCreate) == null || b.call(e, { start: y, end: _, allDay: !0 });
      },
      cancel: () => o(null)
    });
  }, clickItem: (d, p) => {
    var f;
    if (s.current) {
      s.current = !1;
      return;
    }
    (f = e.onEventClick) == null || f.call(e, p, d);
  }, inSel: (d) => !!r && d >= (r.a < r.b ? r.a : r.b) && d <= (r.a < r.b ? r.b : r.a) };
}
function Nr({
  segs: e,
  cols: t,
  top: a,
  ctx: r,
  drag: o
}) {
  return /* @__PURE__ */ n.createElement("div", { className: A.barLayer }, e.map((s) => {
    var d;
    const l = s.item, c = l.ev, i = vu(l), m = et(l.s - ye(l.sDay)), u = [
      A.chip,
      i ? A.bar : A.dotChip,
      Mn(c),
      s.contL ? A.contL : "",
      s.contR ? A.contR : "",
      ((d = o.preview) == null ? void 0 : d.id) === c.id ? A.ghost : "",
      nn(r, c) ? A.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: `${c.id}:${s.col}`,
        type: "button",
        className: u,
        style: {
          left: `calc(${s.col / t * 100}% + 2px)`,
          width: `calc(${s.span / t * 100}% - 4px)`,
          top: a + s.lane * kn,
          ...Tn(c)
        },
        "aria-label": kr(l, r.L),
        onPointerDown: (p) => o.onItemDown(p, l),
        onClick: (p) => o.clickItem(p.currentTarget, c)
      },
      i ? /* @__PURE__ */ n.createElement("span", { className: A.chipTitle }, !l.allDay && !s.contL && /* @__PURE__ */ n.createElement("span", { className: A.chipTime }, m), c.title) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("i", { className: A.dot, "aria-hidden": !0 }), /* @__PURE__ */ n.createElement("span", { className: A.chipTime }, m), /* @__PURE__ */ n.createElement("span", { className: A.chipTitle }, c.title))
    );
  }));
}
const Rn = 26;
function id({ ctx: e }) {
  const { L: t, cursor: a, today: r, weekStartsOn: o, showWeekends: s, holidays: l } = e, c = a.slice(0, 7), i = we(
    () => gr(a, o).map((x) => s ? x : x.filter((E) => !ln(E))),
    [a, o, s]
  ), m = i[0].length, u = wr(e), d = u.items(i[0][0], i[i.length - 1][m - 1]), p = q(null), [f, y] = S(0);
  je(() => {
    const x = p.current;
    if (!x) return;
    const E = () => y(x.clientHeight / i.length);
    if (E(), typeof ResizeObserver == "undefined") return;
    const g = new ResizeObserver(E);
    return g.observe(x), () => g.disconnect();
  }, [i.length]);
  const _ = f ? Math.max(1, Math.floor((f - Rn - 4) / kn)) : 3, b = q(!1), $ = q(null);
  G(() => {
    var x, E;
    b.current && (b.current = !1, (E = (x = $.current) == null ? void 0 : x.querySelector(`[data-cal-day="${a}"]`)) == null || E.focus());
  }, [a, c]);
  const k = (x, E) => {
    let g = ke(x, E);
    for (; !s && ln(g); ) g = ke(g, E > 0 ? 1 : -1);
    return g;
  }, w = (x, E, g) => {
    let h = null;
    if (x.key === "ArrowLeft") h = k(E, -1);
    else if (x.key === "ArrowRight") h = k(E, 1);
    else if (x.key === "ArrowUp") h = k(E, -7);
    else if (x.key === "ArrowDown") h = k(E, 7);
    else if (x.key === "Home") h = g[0];
    else if (x.key === "End") h = g[g.length - 1];
    else if (x.key === "Enter" || x.key === " ") {
      x.preventDefault(), e.goto("day", E);
      return;
    }
    h && (x.preventDefault(), b.current = !0, e.setCursor(h));
  };
  return /* @__PURE__ */ n.createElement("div", { className: A.month, role: "grid", "aria-label": t.ym(`${c}-01`), ref: $ }, /* @__PURE__ */ n.createElement("div", { className: A.mHead, role: "row" }, i[0].map((x) => {
    const E = Ie(de(x));
    return /* @__PURE__ */ n.createElement("div", { key: x, role: "columnheader", className: [A.wdName, E === 0 ? A.sun : "", E === 6 ? A.sat : ""].join(" ") }, t.weekdays[E]);
  })), /* @__PURE__ */ n.createElement("div", { className: A.mBody, ref: p }, i.map((x) => {
    const { shown: E, more: g } = Nu(Er(d, x), m, _);
    return /* @__PURE__ */ n.createElement("div", { key: x[0], className: A.mWeek, role: "row" }, /* @__PURE__ */ n.createElement("div", { className: A.mCells, style: { gridTemplateColumns: `repeat(${m}, minmax(0, 1fr))` } }, x.map((h) => {
      const N = de(h), D = Ie(N), j = l[h], B = d.filter((T) => T.sDay <= h && T.eDay >= h).length, I = [
        A.cell,
        h.slice(0, 7) !== c ? A.out : "",
        D === 0 || j ? A.sun : D === 6 ? A.sat : "",
        h === r ? A.isToday : "",
        u.inSel(h) ? A.selDay : "",
        e.onCreate ? A.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ n.createElement(
        "div",
        {
          key: h,
          role: "gridcell",
          "data-cal-day": h,
          tabIndex: h === a ? 0 : -1,
          "aria-selected": h === a,
          "aria-current": h === r ? "date" : void 0,
          "aria-label": `${t.dayAria(h)}${j ? ` ${j}` : ""}, ${t.eventCount(B)}`,
          className: I,
          onPointerDown: (T) => u.onCellDown(T, h),
          onKeyDown: (T) => w(T, h, x)
        },
        /* @__PURE__ */ n.createElement("div", { className: A.cellHead }, /* @__PURE__ */ n.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: A.dayNum,
            "aria-label": t.openDay(h),
            onPointerDown: (T) => T.stopPropagation(),
            onClick: () => e.goto("day", h)
          },
          N.d === 1 ? t.md(h) : N.d
        ), j && /* @__PURE__ */ n.createElement("span", { className: A.holiday, title: j }, j), e.onCreate && /* @__PURE__ */ n.createElement("span", { className: A.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ n.createElement(Nr, { segs: E, cols: m, top: Rn, ctx: e, drag: u }), g.map((h, N) => h > 0 ? /* @__PURE__ */ n.createElement(
      "button",
      {
        key: x[N],
        type: "button",
        className: A.more,
        style: {
          left: `calc(${N / m * 100}% + 2px)`,
          width: `calc(${100 / m}% - 4px)`,
          top: Rn + (_ - 1) * kn
        },
        onClick: (D) => e.openMore(x[N], D.currentTarget)
      },
      t.more(h)
    ) : null));
  })));
}
const Qe = 44, ud = Array.from({ length: 23 }, (e, t) => t + 1);
function Da() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function On(e, t) {
  const a = t.getBoundingClientRect();
  return Math.max(0, Math.min(Se, (e - a.top) / Qe * 60));
}
function Ca({ ctx: e, days: t }) {
  const a = t.length, r = e.slotMinutes, o = wr(e), [s, l] = S(null), [c, i] = S(null), m = q(!1), u = An(e.events, t[0], t[a - 1], s != null ? s : o.preview), d = Er(u.filter(hr), t), p = d.reduce((E, g) => Math.max(E, g.lane + 1), 0), f = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [y, _] = S(Da);
  G(() => {
    const E = window.setInterval(() => _(Da()), 6e4);
    return () => window.clearInterval(E);
  }, []);
  const b = q(null), $ = t.includes(e.today);
  je(() => {
    const E = b.current;
    if (!E) return;
    const g = $ ? Math.max(0, Math.floor((y - ye(e.today)) / 60) - 1) : e.scrollToHour;
    E.scrollTop = g * Qe;
  }, [t[0], a]);
  const k = (E, g) => {
    if (E.button !== 0 || !e.onCreate) return;
    E.preventDefault();
    const h = E.currentTarget, N = Math.min(Se - r, Math.floor(On(E.clientY, h) / r) * r);
    let D = N;
    i({ day: g, a: N, b: N + r }), wn(E, {
      move: (j) => {
        D = Math.min(Se - r, Math.floor(On(j.clientY, h) / r) * r), i({ day: g, a: Math.min(N, D), b: Math.max(N, D) + r });
      },
      end: (j, B) => {
        var ee;
        i(null);
        const I = ye(g), T = B ? Math.min(N, D) : N, P = B ? Math.max(N, D) + r : Math.min(N + 60, Se);
        (ee = e.onCreate) == null || ee.call(e, { start: tn(I + T), end: tn(I + P), allDay: !1 });
      },
      cancel: () => i(null)
    });
  }, w = (E, g, h) => {
    if (E.stopPropagation(), E.button !== 0 || !nn(e, g.ev)) return;
    const N = (B, I) => {
      const T = yn(B, I, "data-cal-col");
      return T ? ye(T.dataset.calCol) + On(I, T) : null;
    }, D = N(E.clientX, E.clientY);
    if (D == null) return;
    m.current = !1;
    let j = null;
    wn(E, {
      move: (B) => {
        m.current = !0;
        const I = N(B.clientX, B.clientY);
        if (I != null) {
          if (h === "move") {
            const T = $a(I - D, r);
            j = T ? Vn(g, T) : null;
          } else {
            const T = Math.max(g.s + r, $a(I, r));
            j = T !== g.e ? { start: g.ev.start, end: tn(T) } : null;
          }
          l(j ? { id: g.ev.id, ...j } : null);
        }
      },
      end: (B, I) => {
        var T;
        l(null), I && j && ((T = e.onEventChange) == null || T.call(e, g.ev, j));
      },
      cancel: () => l(null)
    });
  }, x = (E, g) => {
    var h;
    if (m.current) {
      m.current = !1;
      return;
    }
    (h = e.onEventClick) == null || h.call(e, g, E);
  };
  return /* @__PURE__ */ n.createElement("div", { className: A.time }, /* @__PURE__ */ n.createElement("div", { className: A.tHead }, /* @__PURE__ */ n.createElement("div", { className: A.gutter }), /* @__PURE__ */ n.createElement("div", { className: A.tHeadDays, style: f }, t.map((E) => {
    const g = de(E), h = Ie(g), N = e.holidays[E];
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: E,
        className: [A.tDay, E === e.today ? A.isToday : "", h === 0 || N ? A.sun : h === 6 ? A.sat : ""].join(" ")
      },
      /* @__PURE__ */ n.createElement("button", { type: "button", className: A.tDayBtn, onClick: () => e.goto("day", E), "aria-label": e.L.openDay(E) }, /* @__PURE__ */ n.createElement("span", { className: A.tWd }, e.L.weekdays[h]), /* @__PURE__ */ n.createElement("span", { className: A.tDayNum }, g.d)),
      N && /* @__PURE__ */ n.createElement("span", { className: A.holiday, title: N }, N)
    );
  }))), /* @__PURE__ */ n.createElement("div", { className: A.tAllDay }, /* @__PURE__ */ n.createElement("div", { className: A.gutter }, e.L.allDay), /* @__PURE__ */ n.createElement("div", { className: A.tAllDayRow, style: { height: Math.max(1, p) * kn + 6 } }, /* @__PURE__ */ n.createElement("div", { className: A.tAllDayCells, style: f }, t.map((E) => /* @__PURE__ */ n.createElement(
    "div",
    {
      key: E,
      "data-cal-day": E,
      className: [A.allDayCell, o.inSel(E) ? A.selDay : "", e.onCreate ? A.creatable : ""].join(" "),
      onPointerDown: (g) => o.onCellDown(g, E)
    }
  ))), /* @__PURE__ */ n.createElement(Nr, { segs: d, cols: a, top: 3, ctx: e, drag: o }))), /* @__PURE__ */ n.createElement("div", { className: A.tBody, ref: b }, /* @__PURE__ */ n.createElement("div", { className: A.tGrid, style: { height: 24 * Qe } }, /* @__PURE__ */ n.createElement("div", { className: A.tGutter, "aria-hidden": !0 }, ud.map((E) => /* @__PURE__ */ n.createElement("span", { key: E, style: { top: E * Qe } }, et(E * 60)))), /* @__PURE__ */ n.createElement("div", { className: A.tCols, style: { ...f, backgroundSize: `100% ${Qe}px` } }, t.map((E) => {
    const g = xu(u, E);
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: E,
        "data-cal-col": E,
        className: [A.tCol, E === e.today ? A.isToday : "", e.onCreate ? A.creatable : ""].join(" "),
        onPointerDown: (h) => k(h, E)
      },
      (c == null ? void 0 : c.day) === E && /* @__PURE__ */ n.createElement("div", { className: A.tSel, style: { top: c.a / 60 * Qe, height: (c.b - c.a) / 60 * Qe } }, et(c.a), " – ", c.b === Se ? "24:00" : et(c.b)),
      g.map((h) => {
        const N = h.item.ev, D = (h.bottom - h.top) / 60 * Qe, j = [
          A.tEv,
          Mn(N),
          D < 34 ? A.tEvShort : "",
          h.contTop ? A.contTop : "",
          h.contBottom ? A.contBottom : "",
          (s == null ? void 0 : s.id) === N.id ? A.ghost : "",
          nn(e, N) ? A.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ n.createElement(
          "button",
          {
            key: N.id,
            type: "button",
            className: j,
            style: {
              top: h.top / 60 * Qe,
              height: Math.max(18, D - 1),
              left: `calc(${h.col / h.cols * 100}% + 1px)`,
              width: `calc(${100 / h.cols}% - 4px)`,
              ...Tn(N)
            },
            "aria-label": kr(h.item, e.L),
            onPointerDown: (B) => w(B, h.item, "move"),
            onClick: (B) => x(B.currentTarget, N)
          },
          /* @__PURE__ */ n.createElement("span", { className: A.tEvTitle }, N.title),
          /* @__PURE__ */ n.createElement("span", { className: A.tEvTime }, la(h.item, e.L.allDay)),
          nn(e, N) && !h.contBottom && /* @__PURE__ */ n.createElement("span", { className: A.resize, "aria-hidden": !0, onPointerDown: (B) => w(B, h.item, "resize") })
        );
      }),
      E === e.today && /* @__PURE__ */ n.createElement("div", { className: A.now, style: { top: (y - ye(E)) / 60 * Qe }, "aria-hidden": !0 })
    );
  })))));
}
function Aa(e, t, a) {
  return e.sDay === e.eDay ? la(e, a) : e.allDay ? a : t === e.sDay ? `${et(e.s - ye(t))} ~` : t === e.eDay ? `~ ${et(e.e - ye(t))}` : a;
}
function md({ ctx: e }) {
  const { L: t } = e, { from: a, to: r } = sa("agenda", e.cursor, e.weekStartsOn), o = An(e.events, a, r), s = Sn(a, r).filter((l) => e.showWeekends || !ln(l)).map((l) => {
    const c = ye(l), i = (u) => Aa(u, l, "") === "" ? -1 : Math.max(u.s, c), m = o.filter((u) => u.sDay <= l && u.eDay >= l);
    return { day: l, list: m.sort((u, d) => i(u) - i(d)) };
  }).filter((l) => l.list.length > 0);
  return s.length ? /* @__PURE__ */ n.createElement("div", { className: A.agenda }, s.map(({ day: l, list: c }) => {
    const i = de(l), m = e.holidays[l], u = Ie(i), d = t.weekdays[u];
    return /* @__PURE__ */ n.createElement("section", { key: l, className: [A.aDay, l === e.today ? A.isToday : ""].join(" "), "aria-label": t.dayAria(l) }, /* @__PURE__ */ n.createElement("div", { className: [A.aDate, u === 0 || m ? A.sun : u === 6 ? A.sat : ""].join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: A.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ n.createElement("span", { className: A.aDayNum }, i.d), /* @__PURE__ */ n.createElement("span", { className: A.aDayWd }, t.m(l), " · ", d)), m && /* @__PURE__ */ n.createElement("span", { className: A.holiday }, m)), /* @__PURE__ */ n.createElement("ul", { className: A.aList }, c.map((p) => {
      const f = p.ev, y = Wt(p.sDay, p.eDay) + 1;
      return /* @__PURE__ */ n.createElement("li", { key: f.id }, /* @__PURE__ */ n.createElement(
        "button",
        {
          type: "button",
          className: [A.aRow, Mn(f)].join(" "),
          style: Tn(f),
          onClick: (_) => {
            var b;
            return (b = e.onEventClick) == null ? void 0 : b.call(e, f, _.currentTarget);
          }
        },
        /* @__PURE__ */ n.createElement("i", { className: A.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ n.createElement("span", { className: A.aTime }, Aa(p, l, t.allDay)),
        /* @__PURE__ */ n.createElement("span", { className: A.aTitle }, f.title, y > 1 && /* @__PURE__ */ n.createElement("em", { className: A.aSpan }, t.dayOfSpan(Wt(p.sDay, l) + 1, y))),
        f.location && /* @__PURE__ */ n.createElement("span", { className: A.aLoc }, f.location)
      ));
    })));
  })) : /* @__PURE__ */ n.createElement("div", { className: A.empty }, t.empty);
}
const Pn = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function Sa(e, t, a) {
  const [r, o] = S(t), s = e !== void 0 ? e : r;
  return [s, (c) => {
    e === void 0 && o(c), c !== s && (a == null || a(c));
  }];
}
const Ma = ({ dir: e }) => /* @__PURE__ */ n.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ n.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function o0({
  events: e,
  view: t,
  defaultView: a,
  onViewChange: r,
  date: o,
  defaultDate: s,
  onDateChange: l,
  views: c = ["month", "week", "day", "agenda"],
  weekStartsOn: i = 0,
  defaultShowWeekends: m = !0,
  weekendToggle: u = !0,
  holidays: d,
  slotMinutes: p = 30,
  scrollToHour: f = 8,
  onRangeChange: y,
  onEventClick: _,
  onCreate: b,
  onEventChange: $,
  locale: k = vr,
  loading: w,
  headerExtra: x,
  className: E = "",
  style: g,
  "aria-label": h
}) {
  var z;
  const N = pr(), [D, j] = Sa(t, (z = a != null ? a : c[0]) != null ? z : "month", r), [B, I] = Sa(o, s != null ? s : N, l), T = de(B) ? B : N, [P, ee] = S(m), [F, L] = S(null), ae = q(null), te = q(!1);
  G(() => {
    var K;
    if (!te.current) return;
    te.current = !1;
    const O = ae.current;
    !O || O.contains(document.activeElement) || ((K = O.querySelector('[data-cal-day][tabindex="0"]')) != null ? K : O).focus();
  });
  const { from: v, to: R } = sa(D, T, i), Y = q(y);
  Y.current = y, G(() => {
    var O;
    (O = Y.current) == null || O.call(Y, { from: v, to: R, view: D });
  }, [v, R, D]);
  const Z = (O, K) => {
    I(K), c.includes(O) && j(O);
  }, C = {
    events: e,
    L: k,
    cursor: T,
    today: N,
    weekStartsOn: i,
    showWeekends: P,
    holidays: d != null ? d : {},
    slotMinutes: p,
    scrollToHour: f,
    setCursor: I,
    goto: Z,
    openMore: (O, K) => L({ day: O, anchor: K }),
    onEventClick: _,
    onCreate: b,
    onEventChange: $
  }, V = (O) => I(ku(D, T, O, D === "day" && !P)), J = (O) => {
    if (O.defaultPrevented || O.ctrlKey || O.metaKey || O.altKey || O.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const K = O.nativeEvent.code;
    if (K === "KeyT") I(N);
    else if (K === "KeyN" || K === "KeyJ" || O.key === "PageDown") V(1);
    else if (K === "KeyP" || K === "KeyK" || O.key === "PageUp") V(-1);
    else if (Pn[K] && c.includes(Pn[K])) j(Pn[K]);
    else if (K === "KeyC" && b)
      b(D === "month" || D === "agenda" ? { start: T, end: T, allDay: !0 } : { start: `${T}T09:00`, end: `${T}T10:00`, allDay: !1 });
    else return;
    O.preventDefault(), te.current = !0;
  }, X = we(
    () => Sn(v, R).filter((O) => P || !ln(O)),
    [v, R, P]
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [A.cal, E].filter(Boolean).join(" "),
      style: g,
      role: "region",
      "aria-label": h != null ? h : k.region,
      "aria-busy": w || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: J,
      ref: ae,
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement("div", { className: A.toolbar }, /* @__PURE__ */ n.createElement(Ft, { onClick: () => I(N), title: `${k.today} (T)` }, k.today), /* @__PURE__ */ n.createElement("span", { className: A.navBtns }, /* @__PURE__ */ n.createElement(Un, { label: k.prev(D), onClick: () => V(-1) }, /* @__PURE__ */ n.createElement(Ma, { dir: "l" })), /* @__PURE__ */ n.createElement(Un, { label: k.next(D), onClick: () => V(1) }, /* @__PURE__ */ n.createElement(Ma, { dir: "r" }))), /* @__PURE__ */ n.createElement("h2", { className: A.title, "aria-live": "polite" }, wu(D, T, i, k)), /* @__PURE__ */ n.createElement("span", { className: A.toolRight }, x, u && D !== "day" && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: A.toggle,
        "aria-pressed": !P,
        onClick: () => ee((O) => !O)
      },
      k.hideWeekends
    ), c.length > 1 && /* @__PURE__ */ n.createElement(
      rr,
      {
        variant: "segmented",
        "aria-label": k.viewTabs,
        items: c.map((O) => ({ key: O, label: k.views[O] })),
        value: D,
        onChange: (O) => j(O)
      }
    ))),
    /* @__PURE__ */ n.createElement("div", { className: A.body }, w && /* @__PURE__ */ n.createElement("div", { className: A.busy, role: "progressbar", "aria-label": k.loading }), D === "month" && /* @__PURE__ */ n.createElement(id, { ctx: C }), D === "week" && /* @__PURE__ */ n.createElement(Ca, { ctx: C, days: X }), D === "day" && /* @__PURE__ */ n.createElement(Ca, { ctx: C, days: [T] }), D === "agenda" && /* @__PURE__ */ n.createElement(md, { ctx: C })),
    F && /* @__PURE__ */ n.createElement(dd, { ctx: C, day: F.day, anchor: F.anchor, onClose: () => L(null) })
  );
}
function dd({ ctx: e, day: t, anchor: a, onClose: r }) {
  const o = q(null), [s, l] = S({ top: -9999, left: -9999 }), c = de(t), i = An(e.events, t, t);
  return je(() => {
    var f;
    const m = o.current;
    if (!m) return;
    const u = a.getBoundingClientRect(), d = m.offsetWidth, p = m.offsetHeight;
    l({
      left: Math.max(8, Math.min(u.left + u.width / 2 - d / 2, window.innerWidth - d - 8)),
      top: Math.max(8, Math.min(u.top - 60, window.innerHeight - p - 8))
    }), (f = m.querySelector("[data-cal-pop-item]")) == null || f.focus();
  }, [a]), G(() => {
    const m = () => {
      r(), a.isConnected && a.focus();
    }, u = (p) => {
      var f;
      (f = o.current) != null && f.contains(p.target) || r();
    }, d = (p) => {
      p.key !== "Escape" || p.isComposing || (p.preventDefault(), p.stopPropagation(), m());
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", d, !0), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", d, !0);
    };
  }, [a, r]), /* @__PURE__ */ n.createElement(Kt, null, /* @__PURE__ */ n.createElement("div", { ref: o, className: A.pop, style: s, role: "dialog", "aria-label": `${e.L.md(t)} ${e.L.eventCount(i.length)}` }, /* @__PURE__ */ n.createElement("div", { className: A.popHead }, /* @__PURE__ */ n.createElement("button", { type: "button", className: A.popDay, onClick: () => {
    r(), e.goto("day", t);
  } }, /* @__PURE__ */ n.createElement("span", null, e.L.weekdays[Ie(c)]), /* @__PURE__ */ n.createElement("b", null, c.d)), /* @__PURE__ */ n.createElement("button", { type: "button", className: A.popClose, "aria-label": e.L.close, onClick: r }, "✕")), /* @__PURE__ */ n.createElement("ul", { className: A.popList }, i.map((m) => {
    const u = m.ev, d = m.allDay || m.sDay !== m.eDay;
    return /* @__PURE__ */ n.createElement("li", { key: u.id }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [A.popItem, d ? A.bar : A.dotChip, Mn(u)].join(" "),
        style: Tn(u),
        onClick: () => {
          var p;
          r(), (p = e.onEventClick) == null || p.call(e, u, a);
        }
      },
      !d && /* @__PURE__ */ n.createElement("i", { className: A.dot, "aria-hidden": !0 }),
      !m.allDay && /* @__PURE__ */ n.createElement("span", { className: A.chipTime }, et(Math.max(m.s, ye(t)) - ye(t))),
      /* @__PURE__ */ n.createElement("span", { className: A.chipTitle }, u.title)
    ));
  }))));
}
const _d = "_mini_q7p5n_3", fd = "_nav_q7p5n_5", pd = "_navBtn_q7p5n_6", yd = "_todayBtn_q7p5n_6", bd = "_title_q7p5n_6", hd = "_day_q7p5n_25", gd = "_mon_q7p5n_25", Ed = "_grid_q7p5n_29", vd = "_wdRow_q7p5n_30", kd = "_row_q7p5n_30", wd = "_sun_q7p5n_35", Nd = "_sat_q7p5n_36", $d = "_num_q7p5n_45", xd = "_sel_q7p5n_46", Dd = "_out_q7p5n_50", Cd = "_isToday_q7p5n_52", Ad = "_dots_q7p5n_55", Sd = "_months_q7p5n_59", se = {
  mini: _d,
  nav: fd,
  navBtn: pd,
  todayBtn: yd,
  title: bd,
  day: hd,
  mon: gd,
  grid: Ed,
  wdRow: vd,
  row: kd,
  sun: wd,
  sat: Nd,
  num: $d,
  sel: xd,
  out: Dd,
  isToday: Cd,
  dots: Ad,
  months: Sd
}, Ta = (e, t) => `${String(e).padStart(4, "0")}-${String(t).padStart(2, "0")}`;
function s0({
  month: e,
  onMonthChange: t,
  value: a,
  onPick: r,
  marks: o = {},
  markLabel: s,
  holidays: l = {},
  weekStartsOn: c = 0,
  locale: i = vr,
  today: m,
  children: u,
  className: d = "",
  "aria-label": p
}) {
  const f = m != null ? m : pr(), y = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${f.slice(0, 7)}-01`, _ = de(y), b = vn(y, c), $ = Sn(b, ke(b, 41)), k = s != null ? s : i.eventCount, [w, x] = S("day"), [E, g] = S(_.y), h = (F) => !!F && F.slice(0, 7) === y.slice(0, 7), [N, D] = S(() => h(a) ? a : h(f) ? f : y);
  G(() => {
    h(N) || D(h(a) ? a : h(f) ? f : y);
  }, [y]);
  const j = q(!1), B = q(null);
  G(() => {
    var F, L;
    j.current && (j.current = !1, (L = (F = B.current) == null ? void 0 : F.querySelector(`[data-day="${N}"]`)) == null || L.focus());
  }, [N, y]);
  const I = (F) => {
    j.current = !0, D(F), h(F) || t(F.slice(0, 7));
  }, T = (F) => {
    const L = Et(_, F);
    t(Ta(L.y, L.m));
  }, P = (F, L) => {
    const ae = de(L), te = (Ie(ae) - c + 7) % 7;
    let v = null;
    if (F.key === "ArrowLeft") v = ke(L, -1);
    else if (F.key === "ArrowRight") v = ke(L, 1);
    else if (F.key === "ArrowUp") v = ke(L, -7);
    else if (F.key === "ArrowDown") v = ke(L, 7);
    else if (F.key === "Home") v = ke(L, -te);
    else if (F.key === "End") v = ke(L, 6 - te);
    else if (F.key === "PageUp" || F.key === "PageDown") {
      const R = Et(ae, F.key === "PageUp" ? -1 : 1);
      v = nt(R.y, R.m, R.d);
    }
    v && (F.preventDefault(), I(v));
  }, ee = () => {
    g(_.y), x("month");
  };
  return /* @__PURE__ */ n.createElement("div", { className: [se.mini, d].filter(Boolean).join(" "), role: p ? "group" : void 0, "aria-label": p }, w === "day" ? /* @__PURE__ */ n.createElement("div", { className: se.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: se.navBtn, "aria-label": i.prevMonth, onClick: () => T(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", className: se.title, "aria-label": `${i.ym(y)}, ${i.pickMonth}`, "aria-live": "polite", onClick: ee }, i.ym(y)), /* @__PURE__ */ n.createElement("button", { type: "button", className: se.navBtn, "aria-label": i.nextMonth, onClick: () => T(1) }, "›"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: se.todayBtn,
      disabled: h(f),
      onClick: () => {
        t(f.slice(0, 7)), I(f);
      }
    },
    i.today
  )) : /* @__PURE__ */ n.createElement("div", { className: se.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: se.navBtn, "aria-label": i.prevYear, onClick: () => g((F) => F - 1) }, "‹"), /* @__PURE__ */ n.createElement("span", { className: se.title, "aria-live": "polite" }, i.year(`${E}-12-31`)), /* @__PURE__ */ n.createElement("button", { type: "button", className: se.navBtn, "aria-label": i.nextYear, onClick: () => g((F) => F + 1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", className: se.todayBtn, onClick: () => x("day"), "aria-label": i.close }, "✕")), w === "month" ? /* @__PURE__ */ n.createElement("div", { className: se.months, onKeyDown: (F) => {
    F.key === "Escape" && (F.preventDefault(), x("day"));
  } }, Array.from({ length: 12 }, (F, L) => {
    const ae = Ta(E, L + 1), te = ae === y.slice(0, 7);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: ae,
        type: "button",
        className: [se.mon, te ? se.sel : "", ae === f.slice(0, 7) ? se.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": te,
        autoFocus: te,
        onClick: () => {
          t(ae), x("day");
        }
      },
      i.m(`${ae}-01`)
    );
  })) : /* @__PURE__ */ n.createElement("div", { className: se.grid, role: "grid", "aria-label": i.ym(y), ref: B }, /* @__PURE__ */ n.createElement("div", { className: se.wdRow, role: "row" }, $.slice(0, 7).map((F) => {
    const L = Ie(de(F));
    return /* @__PURE__ */ n.createElement("span", { key: F, role: "columnheader", className: L === 0 ? se.sun : L === 6 ? se.sat : "" }, i.weekdays[L]);
  })), [0, 1, 2, 3, 4, 5].map((F) => /* @__PURE__ */ n.createElement("div", { key: F, className: se.row, role: "row" }, $.slice(F * 7, F * 7 + 7).map((L) => {
    var Y;
    const ae = Ie(de(L)), te = l[L], v = (Y = o[L]) != null ? Y : 0, R = [
      se.day,
      h(L) ? "" : se.out,
      ae === 0 || te ? se.sun : ae === 6 ? se.sat : "",
      L === f ? se.isToday : "",
      L === a ? se.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: L,
        type: "button",
        role: "gridcell",
        "data-day": L,
        className: R,
        tabIndex: L === N ? 0 : -1,
        "aria-selected": L === a,
        "aria-current": L === f ? "date" : void 0,
        "aria-label": [i.dayAria(L), te, v ? k(v) : ""].filter(Boolean).join(", "),
        onKeyDown: (Z) => P(Z, L),
        onFocus: () => D(L),
        onClick: () => r(L)
      },
      /* @__PURE__ */ n.createElement("span", { className: se.num }, +L.slice(8)),
      /* @__PURE__ */ n.createElement("span", { className: se.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(v, 3) }, (Z, C) => /* @__PURE__ */ n.createElement("i", { key: C })))
    );
  })))), u);
}
function Md(e) {
  return e.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function $r(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[－ー−]/g, "-").replace(/，/g, ",").replace(/．/g, ".");
}
function xr(e, t = !0) {
  e = $r(e);
  const a = t && /^\s*-/.test(e), r = e.split(".", 1)[0].replace(/[^\d]/g, "");
  return r ? (a ? "-" : "") + r.replace(/^0+(?=\d)/, "") : a ? "-" : "";
}
function Td(e) {
  var r;
  if (e == null || e === "") return "";
  const t = typeof e == "number" ? String(e) : e.trim(), a = /^(-?)(\d+)(\.\d+)?$/.exec(t);
  return a ? a[1] + Md(a[2]) + ((r = a[3]) != null ? r : "") : t;
}
function Bd(e) {
  const t = xr(e);
  if (t === "" || t === "-") return;
  const a = Number(t);
  return Number.isFinite(a) ? a : void 0;
}
function jd(e) {
  const t = e.match(/\d/g);
  return t ? t.length : 0;
}
function l0({
  value: e,
  onChangeAm: t,
  allowNegative: a = !0,
  onReject: r,
  unit: o,
  className: s,
  ...l
}) {
  const c = q(null), i = q(null), [m, u] = S(!1), d = e == null || e === "";
  je(() => {
    const f = c.current, y = i.current;
    if (i.current = null, !f || y === null) return;
    let _ = 0, b = 0;
    for (; _ < f.value.length && b < y; )
      /\d/.test(f.value[_]) && (b += 1), _ += 1;
    _ === 0 && f.value[0] === "-" && (_ = 1), f.setSelectionRange(_, _);
  });
  const p = /* @__PURE__ */ n.createElement(
    "input",
    {
      ...l,
      ref: c,
      type: "text",
      inputMode: "numeric",
      className: s,
      value: m && d ? "-" : Td(e),
      onChange: (f) => {
        var b;
        const y = f.target;
        i.current = jd(y.value.slice(0, (b = y.selectionStart) != null ? b : y.value.length));
        const _ = xr(y.value, a);
        if (r) {
          const $ = $r(y.value);
          !a && /^\s*-/.test($) ? r("sign") : (/\.\d/.test($.replace(/^\s*-/, "")) || /\.$/.test($)) && r("decimal");
        }
        u(_ === "-"), t({ text: _, num: Bd(_) });
      }
    }
  );
  return o ? /* @__PURE__ */ n.createElement(n.Fragment, null, p, /* @__PURE__ */ n.createElement("span", { className: "axe-money-unit", style: { marginLeft: 6, fontSize: 12, color: "#334155", whiteSpace: "nowrap" } }, o)) : p;
}
const Ld = "_box_qzg36_3", qd = "_banner_qzg36_9", Id = "_verify_qzg36_10", Rd = "_t_info_qzg36_15", Od = "_t_warn_qzg36_16", Pd = "_t_danger_qzg36_17", Xd = "_error_qzg36_22", zd = "_note_qzg36_30", Fd = "_noteI_qzg36_42", Wd = "_noteBody_qzg36_43", Hd = "_badge_qzg36_49", Kd = "_b_muted_qzg36_53", Ud = "_b_ok_qzg36_54", Yd = "_b_warn_qzg36_55", Gd = "_b_info_qzg36_56", Vd = "_b_off_qzg36_57", We = {
  box: Ld,
  banner: qd,
  verify: Id,
  t_info: Rd,
  t_warn: Od,
  t_danger: Pd,
  error: Xd,
  note: zd,
  noteI: Fd,
  noteBody: Wd,
  badge: Hd,
  b_muted: Kd,
  b_ok: Ud,
  b_warn: Yd,
  b_info: Gd,
  b_off: Vd
};
function c0({ tone: e = "warn", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [We.box, We.banner, We[`t_${e}`], t].filter(Boolean).join(" ") }, a);
}
function i0({ tone: e = "ok", className: t = "", children: a }) {
  const r = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ n.createElement("div", { className: [We.box, We.verify, We[`t_${r}`], t].filter(Boolean).join(" ") }, a);
}
function Dr({ className: e = "", children: t }) {
  return t == null || t === !1 || t === "" ? null : /* @__PURE__ */ n.createElement("p", { className: [We.error, e].filter(Boolean).join(" "), role: "alert" }, typeof t == "string" ? /* @__PURE__ */ n.createElement(Jd, { text: t }) : t);
}
function u0({ label: e = "안내", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("details", { className: [We.note, t].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("summary", null, /* @__PURE__ */ n.createElement("span", { className: We.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ n.createElement("div", { className: We.noteBody }, a));
}
function m0({ tone: e = "muted", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("span", { className: ["axe-badge", We.badge, We[`b_${e}`], t].filter(Boolean).join(" ") }, a);
}
function Jd({ text: e }) {
  return e ? /* @__PURE__ */ n.createElement(n.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((t, a) => a % 2 ? /* @__PURE__ */ n.createElement("b", { key: a }, t) : /* @__PURE__ */ n.createElement(Wr, { key: a }, t))) : null;
}
const Qd = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function Zd(e, t = Qd) {
  const a = q(e);
  return a.current = e, G(() => {
    if (!e) return;
    const r = (o) => {
      o.preventDefault(), o.returnValue = "";
    };
    return window.addEventListener("beforeunload", r), () => window.removeEventListener("beforeunload", r);
  }, [e]), le(() => !a.current || window.confirm(t), [t]);
}
const e_ = "_overlay_1qt6w_2", t_ = "_modal_1qt6w_8", n_ = "_wide_1qt6w_15", a_ = "_head_1qt6w_16", r_ = "_title_1qt6w_20", o_ = "_close_1qt6w_21", s_ = "_body_1qt6w_25", l_ = "_flush_1qt6w_26", c_ = "_error_1qt6w_27", i_ = "_foot_1qt6w_29", Ve = {
  overlay: e_,
  modal: t_,
  wide: n_,
  head: a_,
  title: r_,
  close: o_,
  body: s_,
  flush: l_,
  error: c_,
  foot: i_
}, At = [];
function Ba(e) {
  const t = At[At.length - 1];
  e.key !== "Escape" || e.defaultPrevented || e.isComposing || !t || !t.esc || (e.preventDefault(), t.close());
}
const u_ = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function ja(e) {
  return Array.from(e.querySelectorAll(u_)).filter((t) => t.getClientRects().length > 0 && getComputedStyle(t).visibility !== "hidden");
}
let La = 0, qa = "";
function ca({
  title: e,
  onClose: t,
  children: a,
  wide: r,
  footer: o,
  headerExtra: s,
  flush: l,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !1,
  error: m,
  confirmDiscard: u = !0
}) {
  const [d, p] = S(!1), f = u ? () => {
    d || p(!0);
  } : void 0, y = Zd(u && d, "입력한 내용을 저장하지 않고 닫을까요?"), _ = () => {
    y() && t();
  }, b = q(_);
  b.current = _;
  const $ = q({ close: () => b.current(), esc: i });
  $.current.esc = i, G(() => {
    const g = $.current;
    return At.push(g), At.length === 1 && window.addEventListener("keydown", Ba), () => {
      const h = At.lastIndexOf(g);
      h >= 0 && At.splice(h, 1), At.length === 0 && window.removeEventListener("keydown", Ba);
    };
  }, []);
  const k = q(null), w = q(null), x = q(void 0);
  x.current === void 0 && (x.current = typeof document == "undefined" ? null : document.activeElement), G(() => {
    var N;
    const g = k.current, h = (N = x.current) != null ? N : null;
    return g && !g.contains(document.activeElement) && (w.current && ja(w.current)[0] || null || g).focus(), La++ === 0 && (qa = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --La === 0 && (document.body.style.overflow = qa), h && h.isConnected && typeof h.focus == "function" && h.focus();
    };
  }, []);
  const E = (g) => {
    const h = k.current;
    if (g.key !== "Tab" || !h || !h.contains(g.target)) return;
    const N = ja(h);
    if (N.length === 0) {
      g.preventDefault(), h.focus();
      return;
    }
    const D = N[0], j = N[N.length - 1], B = document.activeElement;
    g.shiftKey && (B === D || B === h) ? (g.preventDefault(), j.focus()) : !g.shiftKey && B === j && (g.preventDefault(), D.focus());
  };
  return /* @__PURE__ */ n.createElement("div", { className: Ve.overlay, onClick: c ? _ : void 0 }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: k,
      tabIndex: -1,
      className: [Ve.modal, r ? Ve.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (g) => g.stopPropagation(),
      onKeyDown: E
    },
    /* @__PURE__ */ n.createElement("header", { className: Ve.head }, /* @__PURE__ */ n.createElement("strong", { className: Ve.title }, e), s, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.close, onClick: _, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: w,
        className: [Ve.body, l ? Ve.flush : ""].filter(Boolean).join(" "),
        onInputCapture: f,
        onChangeCapture: f
      },
      a
    ),
    m != null && m !== !1 && m !== "" && /* @__PURE__ */ n.createElement("div", { className: Ve.error }, /* @__PURE__ */ n.createElement(Dr, null, m)),
    o && /* @__PURE__ */ n.createElement("footer", { className: Ve.foot }, o)
  ));
}
function d0(e = 4e3) {
  const [t, a] = S(""), [r, o] = S(!1), s = q(void 0), l = le((m) => {
    window.clearTimeout(s.current), o(!1), a(m), s.current = window.setTimeout(() => a(""), e);
  }, [e]), c = le((m) => {
    window.clearTimeout(s.current), o(!0), a(m);
  }, []), i = le(() => {
    window.clearTimeout(s.current), o(!1), a("");
  }, []);
  return [t, l, c, r, i];
}
const m_ = "_message_psco6_1", d_ = "_details_psco6_2", __ = "_warn_psco6_7", f_ = "_field_psco6_8", dn = {
  message: m_,
  details: d_,
  warn: __,
  field: f_
};
function _0() {
  var f, y;
  const [e, t] = S(null), [a, r] = S(""), o = q(null), s = q(null), l = q(null), c = le((_) => new Promise((b) => {
    t({ kind: "confirm", opts: _, resolve: b });
  }), []), i = le((_) => new Promise((b) => {
    var $, k, w, x;
    r((x = (w = _.defaultValue) != null ? w : (k = ($ = _.choices) == null ? void 0 : $[0]) == null ? void 0 : k.value) != null ? x : ""), t({ kind: "prompt", opts: _, resolve: b });
  }), []);
  G(() => {
    var _, b, $;
    e && (e.kind === "prompt" ? (_ = l.current) == null || _.focus() : e.opts.danger || e.opts.focusCancel ? (b = s.current) == null || b.focus() : ($ = o.current) == null || $.focus());
  }, [e]);
  const m = (_) => {
    e && (e.kind === "confirm" ? e.resolve(_) : e.resolve(_ ? a : null), t(null));
  }, u = e == null ? void 0 : e.opts, d = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), p = e && u ? /* @__PURE__ */ n.createElement(
    ca,
    {
      title: u.title,
      onClose: () => m(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(Ft, { ref: s, onClick: () => m(!1) }, (f = u.cancelLabel) != null ? f : "취소"), /* @__PURE__ */ n.createElement(
        Ft,
        {
          ref: o,
          variant: u.danger ? "danger" : "primary",
          disabled: d,
          onClick: () => m(!0)
        },
        (y = u.confirmLabel) != null ? y : "확인"
      ))
    },
    u.message && /* @__PURE__ */ n.createElement("div", { className: dn.message }, u.message),
    u.details && u.details.length > 0 && /* @__PURE__ */ n.createElement("ul", { className: dn.details }, u.details.map((_, b) => /* @__PURE__ */ n.createElement("li", { key: b }, _))),
    u.irreversible && /* @__PURE__ */ n.createElement("p", { className: dn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ n.createElement("label", { className: dn.field }, /* @__PURE__ */ n.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ n.createElement("select", { ref: l, value: a, onChange: (_) => r(_.target.value) }, e.opts.choices.map((_) => /* @__PURE__ */ n.createElement("option", { key: _.value, value: _.value }, _.label))) : /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (_) => r(_.target.value),
        onKeyDown: (_) => {
          _.key === "Enter" && !d && (_.preventDefault(), m(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: p };
}
function f0(e, t) {
  const a = t ? `${t}에 실패했습니다 — ` : "", r = e > 0 ? ` (오류 ${e})` : "";
  return a + p_(e) + r;
}
function p_(e) {
  return e === 0 ? "서버에 연결하지 못했습니다. 네트워크 상태를 확인한 뒤 다시 시도하세요" : e === 400 || e === 422 ? "서버가 요청 내용을 받아들이지 않았습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 필요합니다. 다시 로그인해 주세요" : e === 403 ? "이 작업을 할 권한이 없습니다. 필요하면 관리자에게 권한을 요청하세요" : e === 404 ? "요청한 자료나 기능을 찾지 못했습니다. 화면을 새로고침한 뒤 다시 시도하고, 계속되면 관리자에게 알려 주세요" : e === 409 ? "다른 곳에서 먼저 바뀌었습니다. 다시 조회한 뒤 시도하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "서버에서 처리하지 못했습니다. 잠시 후 다시 시도하고, 계속되면 관리자에게 알려 주세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
const y_ = "_section_dyrr7_3", b_ = "_row_dyrr7_10", h_ = "_label_dyrr7_15", g_ = "_value_dyrr7_21", E_ = "_invalid_dyrr7_43", v_ = "_help_dyrr7_45", k_ = "_err_dyrr7_45", w_ = "_req_dyrr7_49", N_ = "_opt_dyrr7_50", $_ = "_sr_dyrr7_51", x_ = "_ro_dyrr7_10", D_ = "_readonly_dyrr7_58", C_ = "_hint_dyrr7_65", A_ = "_toggle_dyrr7_73", S_ = "_table_dyrr7_80", M_ = "_isReq_dyrr7_95", Ae = {
  section: y_,
  row: b_,
  label: h_,
  value: g_,
  invalid: E_,
  help: v_,
  err: k_,
  req: w_,
  opt: N_,
  sr: $_,
  ro: x_,
  readonly: D_,
  hint: C_,
  toggle: A_,
  table: S_,
  isReq: M_
};
let T_ = 0;
const B_ = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function p0({
  label: e,
  children: t,
  hint: a,
  ro: r,
  htmlFor: o,
  required: s,
  optional: l,
  help: c,
  error: i,
  className: m = ""
}) {
  var E, g, h, N;
  const u = q(`axe-fr${++T_}`).current, d = `${u}-lbl`, p = q(null), f = c ? `${u}-help` : void 0, y = i ? `${u}-err` : void 0, _ = [f, y].filter(Boolean).join(" ") || void 0, b = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let $ = t;
  const k = Kn.count(t) === 1 ? Kn.toArray(t)[0] : null, w = on(k) && typeof k.type != "string" && !!k.type.axeFormControl;
  if (on(k) && (typeof k.type == "string" && B_.has(k.type) || w)) {
    const D = k, j = D.props;
    $ = na(D, {
      id: (E = j.id) != null ? E : o,
      "aria-describedby": (g = j["aria-describedby"]) != null ? g : _,
      "aria-invalid": (h = j["aria-invalid"]) != null ? h : i ? !0 : void 0,
      "aria-required": (N = j["aria-required"]) != null ? N : s ? !0 : void 0
    });
  }
  je(() => {
    var I;
    const D = (I = p.current) == null ? void 0 : I.querySelector("input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea");
    if (!D) return;
    const j = (T, P) => {
      const ee = `data-fr-${T}`;
      if (P == null) {
        D.hasAttribute(ee) && (D.removeAttribute(T), D.removeAttribute(ee));
        return;
      }
      D.hasAttribute(T) && !D.hasAttribute(ee) || (D.getAttribute(T) !== P && D.setAttribute(T, P), D.setAttribute(ee, ""));
    }, B = !!(D.id && document.querySelector(`label[for="${CSS.escape(D.id)}"]`));
    j("aria-labelledby", B ? null : d), j("aria-invalid", i ? "true" : null), j("aria-required", s ? "true" : null), j("aria-describedby", _ != null ? _ : null);
  });
  const x = /* @__PURE__ */ n.createElement(n.Fragment, null, e, s && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: Ae.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ n.createElement("span", { className: Ae.sr }, "필수")), l && /* @__PURE__ */ n.createElement("span", { className: Ae.opt }, "(선택)"));
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-form-row", Ae.row, r ? Ae.ro : "", i ? Ae.invalid : "", s ? Ae.isReq : "", m].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-label ${Ae.label}` }, o ? /* @__PURE__ */ n.createElement("label", { htmlFor: o, id: d }, x) : /* @__PURE__ */ n.createElement("span", { id: d }, x), a && /* @__PURE__ */ n.createElement(Bt, { content: b, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-hint ${Ae.hint}`, role: "img", "aria-label": `도움말: ${b}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ n.createElement("span", { ref: p, className: `axe-form-value ${Ae.value}` }, $, c && /* @__PURE__ */ n.createElement("span", { id: f, className: Ae.help }, c), i && /* @__PURE__ */ n.createElement("span", { id: y, className: Ae.err }, i)));
}
function y0({ title: e, children: t, className: a = "", variant: r = "stack" }) {
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-form-section", r === "table" ? `axe-form-table ${Ae.table}` : "", Ae.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), t);
}
function b0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ae.readonly }, e);
}
function h0({ checked: e, onChange: t, disabled: a, label: r, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [Ae.toggle, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (s) => t(s.target.checked) }), /* @__PURE__ */ n.createElement("span", null, r));
}
const j_ = "_mono_6omzf_2", L_ = "_invalid_6omzf_3", q_ = "_qty_6omzf_6", I_ = "_qtyInput_6omzf_7", R_ = "_unit_6omzf_8", O_ = "_note_6omzf_9", P_ = "_qtyErr_6omzf_10", ht = {
  mono: j_,
  invalid: L_,
  qty: q_,
  qtyInput: I_,
  unit: R_,
  note: O_,
  qtyErr: P_
};
function X_({
  value: e,
  onChange: t,
  disabled: a,
  maxLength: r,
  placeholder: o,
  mono: s,
  invalid: l,
  multiline: c,
  rows: i = 4,
  label: m,
  id: u,
  "aria-describedby": d,
  "aria-invalid": p,
  "aria-required": f,
  className: y = ""
}) {
  const _ = [s ? ht.mono : "", l ? ht.invalid : "", y].filter(Boolean).join(" ") || void 0, b = {
    id: u,
    className: _,
    value: e != null ? e : "",
    maxLength: r,
    placeholder: o,
    disabled: a,
    "aria-label": m,
    "aria-describedby": d,
    "aria-invalid": p != null ? p : l || void 0,
    "aria-required": f,
    onChange: ($) => t($.target.value === "" ? null : $.target.value)
  };
  return c ? /* @__PURE__ */ n.createElement("textarea", { ...b, rows: i }) : /* @__PURE__ */ n.createElement("input", { type: "text", ...b });
}
X_.axeFormControl = !0;
function z_(e) {
  const {
    value: t,
    options: a,
    allLabel: r,
    disabled: o,
    label: s,
    id: l,
    "aria-describedby": c,
    "aria-invalid": i,
    "aria-required": m,
    className: u
  } = e, d = (f) => {
    e.codeType === "string" ? e.onChange(f === "" ? null : f) : e.onChange(f === "" ? null : Number(f));
  }, p = Array.isArray(a) ? a : Object.entries(a);
  return /* @__PURE__ */ n.createElement(
    "select",
    {
      id: l,
      className: u,
      value: t == null ? "" : String(t),
      disabled: o,
      "aria-label": s,
      "aria-describedby": c,
      "aria-invalid": i,
      "aria-required": m,
      onChange: (f) => d(f.target.value)
    },
    r != null && /* @__PURE__ */ n.createElement("option", { value: "" }, r),
    p.map(([f, y]) => /* @__PURE__ */ n.createElement("option", { key: f, value: String(f) }, y))
  );
}
z_.axeFormControl = !0;
function F_(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const W_ = /^-?(\d+\.?\d*|\.\d+)$/;
function Jt(e) {
  const t = F_(e).trim().replace(/,/g, "");
  if (t === "") return { kind: "empty" };
  if (t === "-" || t === "." || t === "-.") return { kind: "partial" };
  if (!W_.test(t)) return { kind: "bad" };
  const a = Number(t);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function Nn(e) {
  if (!Number.isFinite(e)) return 0;
  const t = Math.abs(e).toString(), a = t.indexOf("e-");
  if (a >= 0) {
    const o = t.slice(0, a), s = o.indexOf(".");
    return (s >= 0 ? o.length - s - 1 : 0) + Number(t.slice(a + 2));
  }
  const r = t.indexOf(".");
  return r >= 0 ? t.length - r - 1 : 0;
}
function Cr(e, t) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(t));
  if (Nn(e) <= a) return e;
  const r = e < 0 ? -1 : 1, o = Math.abs(e).toFixed(Math.min(20, Nn(e))), s = Math.round(+`${o}e${a}`), l = r * +`${s}e-${a}`;
  return l === 0 ? 0 : l;
}
function Rt(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function H_(e, t, a) {
  return t != null && e < t || a != null && e > a;
}
function K_(e, t, a, r, o, s) {
  let l = e == null ? o != null ? o : 0 : Cr(e + a * t, Math.max(r, Nn(t)));
  return o != null && l < o && (l = o), s != null && l > s && (l = s), l;
}
const U_ = 2500;
function Y_({
  value: e,
  onChange: t,
  decimals: a = 1,
  min: r,
  max: o,
  step: s,
  unit: l,
  disabled: c,
  label: i,
  id: m,
  "aria-describedby": u,
  "aria-invalid": d,
  "aria-required": p,
  width: f,
  onEnter: y,
  onInvalidChange: _,
  placeholder: b,
  className: $ = ""
}) {
  const [k, w] = S(() => Rt(e)), [x, E] = S(!1), [g, h] = S(null), [N, D] = S(!1), j = q(null), B = q(k);
  B.current = k, G(() => {
    const v = Jt(B.current), R = v.kind === "num" ? v.value : v.kind === "empty" ? null : void 0;
    R !== void 0 && R === (e != null ? e : null) || w(Rt(e));
  }, [e]), G(() => () => {
    j.current && clearTimeout(j.current);
  }, []);
  const I = Jt(k), T = I.kind === "bad" || I.kind === "partial";
  G(() => {
    T || D(!1);
  }, [T]);
  const P = q(_);
  P.current = _, G(() => {
    var v;
    (v = P.current) == null || v.call(P, T);
  }, [T]), G(() => () => {
    var v;
    (v = P.current) == null || v.call(P, !1);
  }, []);
  const ee = (v) => {
    j.current && clearTimeout(j.current), h(v), j.current = setTimeout(() => h(null), U_);
  }, F = (v) => {
    w(v);
    const R = Jt(v);
    R.kind === "empty" ? t(null) : R.kind === "num" && t(R.value);
  }, L = () => {
    const v = Jt(k);
    if (v.kind !== "num") return;
    if (Nn(v.value) > a) {
      const Y = Cr(v.value, a);
      w(Rt(Y)), t(Y), ee(`반올림했습니다 → ${Rt(Y)}`);
      return;
    }
    const R = Rt(v.value);
    R !== k && w(R);
  }, ae = (v) => {
    if (!v.nativeEvent.isComposing) {
      if (v.key === "Enter") {
        if (T) {
          D(!0);
          return;
        }
        L(), y == null || y();
        return;
      }
      if (s && (v.key === "ArrowUp" || v.key === "ArrowDown")) {
        v.preventDefault();
        const R = Jt(k), Y = R.kind === "num" ? R.value : R.kind === "empty" ? null : e, Z = K_(Y, s, v.key === "ArrowUp" ? 1 : -1, a, r, o);
        w(Rt(Z)), t(Z);
      }
    }
  }, te = I.kind === "bad" || I.kind === "partial" && (!x || N) || I.kind === "num" && H_(I.value, r, o);
  return /* @__PURE__ */ n.createElement("span", { className: [ht.qty, $].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: m,
      className: [ht.qtyInput, te ? ht.invalid : ""].filter(Boolean).join(" "),
      style: f != null ? { width: f, maxWidth: "none" } : void 0,
      value: k,
      placeholder: b,
      disabled: c,
      "aria-label": i,
      "aria-describedby": u,
      "aria-invalid": d != null ? d : te || void 0,
      "aria-required": p,
      onChange: (v) => F(v.target.value),
      onFocus: () => E(!0),
      onBlur: () => {
        E(!1), L();
      },
      onKeyDown: ae
    }
  ), l && /* @__PURE__ */ n.createElement("span", { className: ht.unit }, l), (I.kind === "bad" || I.kind === "partial" && (!x || N)) && /* @__PURE__ */ n.createElement("span", { className: ht.qtyErr, role: "alert" }, "숫자로 입력하세요"), /* @__PURE__ */ n.createElement("span", { className: ht.note, role: "status", "aria-live": "polite" }, g));
}
Y_.axeFormControl = !0;
function G_(e, t) {
  if (e === t || e == null && t == null) return !0;
  if (e == null || t == null) return !1;
  if (typeof e == "object" && typeof t == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(t);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof t == "number" && Number.isNaN(e) && Number.isNaN(t);
}
function V_(e, t) {
  var o;
  if (e === t) return [];
  if (e === null || t === null) return e === null && t === null ? [] : Object.keys((o = e != null ? e : t) != null ? o : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]), r = [];
  return a.forEach((s) => {
    G_(e[s], t[s]) || r.push(s);
  }), r;
}
function J_(e, t) {
  return e === null || t === null ? e === t : V_(e, t).length === 0;
}
function g0() {
  const [e, t] = S(null), [a, r] = S(!1), [o, s] = S(null), l = we(() => a || !J_(o, e), [a, o, e]), c = le((f) => {
    t((y) => y === null ? y : { ...y, ...f });
  }, []), i = le((f, y) => {
    t((_) => _ === null ? _ : { ..._, [f]: y });
  }, []), m = q(null), u = le((f) => {
    m.current = f, t(f), s(f), r(!1);
  }, []), d = le((f) => {
    m.current = f, t(f), s(f), r(!0);
  }, []), p = le(() => t(m.current), []);
  return we(
    () => ({ draft: e, isNew: a, dirty: l, set: i, patch: c, load: u, start: d, reset: p, snapshot: o }),
    [e, a, l, i, c, u, d, p, o]
  );
}
function E0() {
  const e = q(!1), [t, a] = S(!1), r = le(async (o) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await o();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [t, r];
}
const Q_ = "_panel_1w7xx_2", Z_ = "_band_1w7xx_7", ef = "_chev_1w7xx_11", tf = "_title_1w7xx_17", nf = "_note_1w7xx_19", af = "_chip_1w7xx_21", rf = "_other_1w7xx_32", of = "_reset_1w7xx_33", sf = "_form_1w7xx_42", ot = {
  panel: Q_,
  band: Z_,
  chev: ef,
  title: tf,
  note: nf,
  chip: af,
  other: rf,
  reset: of,
  form: sf
};
function v0({
  chips: e,
  onReset: t,
  open: a,
  onToggle: r,
  toggleLabel: o = "상세검색",
  title: s = "적용된 조건",
  note: l,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: m = "상세검색",
  className: u = ""
}) {
  const d = q(null);
  if (i && !a && e.length === 0) return null;
  const p = (y, _ = 0) => {
    var x, E, g;
    const b = (x = document.querySelector(`section[aria-label="${CSS.escape(m)}"]`)) != null ? x : d.current, $ = b == null ? void 0 : b.querySelectorAll("button[data-chip-clear]"), k = (g = $ && ((E = $[y]) != null ? E : $[y - 1])) != null ? g : b == null ? void 0 : b.querySelector("button[aria-expanded]"), w = !document.activeElement || document.activeElement === document.body;
    k && k !== document.activeElement && (_ === 0 || w) && k.focus(), _ < 4 && setTimeout(() => p(y, _ + 1), 250);
  }, f = (y) => {
    e[y].onClear(), requestAnimationFrame(() => p(y));
  };
  return /* @__PURE__ */ n.createElement("section", { className: [ot.panel, u].filter(Boolean).join(" "), "aria-label": m }, /* @__PURE__ */ n.createElement("div", { className: ot.band, ref: d }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: ot.chev, "aria-expanded": !!a, onClick: r }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", o), s !== null && /* @__PURE__ */ n.createElement("span", { className: ot.title, "aria-live": "polite" }, s, " ", /* @__PURE__ */ n.createElement("b", null, e.length), "개"), e.map((y, _) => {
    var b;
    return /* @__PURE__ */ n.createElement("span", { key: y.key, className: [ot.chip, y.tone === "other" ? ot.other : ""].filter(Boolean).join(" ") }, y.text, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(b = y.label) != null ? b : typeof y.text == "string" ? y.text : "조건"} 해제`,
        onClick: () => f(_)
      },
      "✕"
    ));
  }), t && e.length > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", className: ot.reset, onClick: () => {
    t(), requestAnimationFrame(() => p(0));
  } }, "초기화"), l && /* @__PURE__ */ n.createElement("span", { className: ot.note }, l)), a && c && /* @__PURE__ */ n.createElement("div", { className: ot.form }, c));
}
const lf = "_zone_1y6sp_2", cf = "_drag_1y6sp_8", uf = "_busy_1y6sp_9", mf = "_attached_1y6sp_10", df = "_left_1y6sp_12", _f = "_icon_1y6sp_13", ff = "_title_1y6sp_18", pf = "_desc_1y6sp_19", yf = "_right_1y6sp_20", bf = "_count_1y6sp_21", hf = "_pick_1y6sp_22", Ke = {
  zone: lf,
  drag: cf,
  busy: uf,
  attached: mf,
  left: df,
  icon: _f,
  title: ff,
  desc: pf,
  right: yf,
  count: bf,
  pick: hf
};
function k0({
  onFiles: e,
  title: t = "파일 업로드",
  desc: a,
  countText: r,
  accept: o,
  multiple: s = !0,
  disabled: l,
  attached: c,
  pickLabel: i = "파일 선택",
  className: m = ""
}) {
  const u = q(null), [d, p] = S(!1), f = (y) => {
    !y || y.length === 0 || l || e(Array.from(y));
  };
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [Ke.zone, d ? Ke.drag : "", l ? Ke.busy : "", c ? Ke.attached : "", m].filter(Boolean).join(" "),
      onClick: () => {
        var y;
        l || (y = u.current) == null || y.click();
      },
      onDragOver: (y) => {
        y.preventDefault(), l || p(!0);
      },
      onDragLeave: () => p(!1),
      onDrop: (y) => {
        y.preventDefault(), p(!1), f(y.dataTransfer.files);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: Ke.left }, /* @__PURE__ */ n.createElement("div", { className: Ke.icon, "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ n.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ n.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ n.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: Ke.title }, t), a && /* @__PURE__ */ n.createElement("div", { className: Ke.desc }, a))),
    /* @__PURE__ */ n.createElement("div", { className: Ke.right }, r && /* @__PURE__ */ n.createElement("span", { className: Ke.count, "aria-live": "polite" }, r), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Ke.pick,
        disabled: l,
        onClick: (y) => {
          var _;
          y.stopPropagation(), (_ = u.current) == null || _.click();
        }
      },
      i
    ), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: u,
        type: "file",
        accept: o,
        multiple: s,
        hidden: !0,
        onChange: (y) => {
          f(y.target.files), y.target.value = "";
        }
      }
    ))
  );
}
function gf(e, t) {
  var s, l;
  const a = (s = e.headers.get("Content-Disposition")) != null ? s : "", r = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (r)
    try {
      return decodeURIComponent(r[1]);
    } catch {
    }
  const o = /filename="?([^";]+)"?/i.exec(a);
  return (l = o == null ? void 0 : o[1]) != null ? l : t;
}
function Ar(e, t) {
  const a = URL.createObjectURL(e), r = document.createElement("a");
  r.href = a, r.download = t, document.body.appendChild(r), r.click(), r.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function w0(e, t, a) {
  Ar(await e.blob(), a != null ? a : gf(e, t));
}
const Ef = /^([△▲\-−]?)\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, vf = /^\(\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function Sr(e, t = {}) {
  var o, s;
  const a = e.trim();
  if (t.parenNegative) {
    const l = vf.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(o = l[2]) != null ? o : ""}`;
  }
  const r = Ef.exec(a);
  return r ? (r[1] ? "-" : "") + r[2].replace(/,/g, "") + ((s = r[3]) != null ? s : "") : null;
}
function zt(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function kf(e, t = {}) {
  const a = [];
  t.meta && t.meta.length && (t.meta.forEach((l) => a.push(l.map((c) => fn(zt(String(c != null ? c : "")))).join(","))), a.push(""));
  const r = a.length;
  let o = null;
  const s = (l) => {
    var i;
    const c = wf(l, e);
    !c || c === o || (o = c, a.length > r && a.push(""), a.push(fn(zt((i = c.getAttribute("data-csv-title")) != null ? i : ""))));
  };
  return e.querySelectorAll("table, [data-csv-kv]").forEach((l) => {
    var f;
    if (l.tagName !== "TABLE") {
      if ((f = l.parentElement) != null && f.closest("table") && e.contains(l.parentElement.closest("table"))) return;
      const y = Nf(l, t);
      if (!y) return;
      s(l), a.push(y.map(fn).join(","));
      return;
    }
    const c = l;
    s(c);
    const i = c.querySelector("[data-tree-depth]"), m = i ? i.closest("td, th") : null, u = m ? m.cellIndex : -1, d = u >= 0 && !!c.querySelector("[data-csv-path]"), p = [];
    Array.from(c.rows).forEach((y) => {
      if (y.hasAttribute("data-state") || y.getAttribute("aria-hidden") === "true") return;
      const _ = [];
      let b = 0;
      const $ = () => {
        for (; p[b] && p[b].n > 0; )
          p[b].n -= 1, p[b].skip || _.push(""), b += 1;
      };
      Array.from(y.cells).forEach((k) => {
        var h, N;
        $();
        const w = xf(k), x = w ? "" : Df(k, t), E = Math.max(1, k.colSpan || 1), g = Math.max(1, k.rowSpan || 1);
        for (let D = 0; D < E; D += 1)
          w || _.push(D === 0 ? x : ""), p[b] = { n: g - 1, skip: w }, b += 1;
        if (u >= 0 && k.cellIndex === u) {
          const D = k.querySelector("[data-tree-depth]");
          D ? (_.push(String(Number(D.getAttribute("data-tree-depth")) + 1)), d && _.push(zt((h = D.getAttribute("data-csv-path")) != null ? h : ""))) : ((N = y.parentElement) == null ? void 0 : N.tagName) === "THEAD" ? (_.push("단계"), d && _.push("상위 경로")) : (_.push(""), d && _.push(""));
        }
      }), $(), _.some((k) => k !== "") && a.push(_.map(fn).join(","));
    });
  }), a.join(`\r
`);
}
function wf(e, t) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === t) return null;
    a = a.parentElement;
  }
  return null;
}
function Nf(e, t) {
  var m, u;
  const a = e.querySelector("[data-csv-k]"), r = e.querySelector("[data-csv-v]"), o = e.querySelector("[data-csv-unit]"), s = o ? _n(o) : "";
  let c = ((m = e.getAttribute("data-csv-kv")) != null ? m : "") || (a ? _n(a) : "");
  if (!c) return null;
  s && (c = `${c} (${s})`);
  let i;
  if (r) {
    const d = r.cloneNode(!0);
    d.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((p) => p.remove()), i = _n(d);
  } else {
    const d = e.cloneNode(!0);
    d.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((p) => p.remove()), i = _n(d);
  }
  return (i === "—" || i === "-" || i === "–") && (i = ""), [zt(c), (u = Sr(i, t)) != null ? u : zt(i)];
}
function _n(e) {
  var t, a;
  return ((a = (t = e.innerText) != null ? t : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function $f(e, t) {
  const a = t.toLowerCase().endsWith(".csv") ? t : `${t}.csv`;
  Ar(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function xf(e) {
  var t;
  return ((t = e.textContent) != null ? t : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function Df(e, t) {
  var o, s, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((c) => c.remove()), a.querySelectorAll("[data-csv-sep]").forEach((c) => c.after(" ")));
  let r = ((s = (o = a.innerText) != null ? o : a.textContent) != null ? s : "").replace(/\s+/g, " ").trim();
  if (!r && a.textContent && (r = a.textContent.replace(/\s+/g, " ").trim()), !r) {
    const c = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    c && (r = c.value.trim());
  }
  return r === "—" || r === "-" || r === "–" ? "" : (l = Sr(r, t)) != null ? l : zt(r);
}
function fn(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const Cf = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function N0({ target: e, fileName: t, label: a = "CSV 내려받기", disabled: r, parenNegative: o, prepare: s, meta: l }) {
  return /* @__PURE__ */ n.createElement(
    Un,
    {
      label: a,
      disabled: r,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let c;
        s && (c = await s(), await Cf());
        try {
          const i = e.current;
          if (!i) return;
          $f(kf(i, { parenNegative: o, meta: l == null ? void 0 : l() }), typeof t == "function" ? t() : t);
        } finally {
          typeof c == "function" && c();
        }
      }
    },
    /* @__PURE__ */ n.createElement(bn, { name: "download", size: 14 }),
    "CSV"
  );
}
const Af = "_card_1adld_1", Sf = "_sub_1adld_2", Mf = "_state_1adld_3", Tf = "_list_1adld_7", Bf = "_row_1adld_8", jf = "_warn_1adld_20", Lf = "_danger_1adld_21", wt = {
  card: Af,
  sub: Sf,
  state: Mf,
  list: Tf,
  row: Bf,
  warn: jf,
  danger: Lf
};
function $0({
  title: e,
  sub: t,
  trailing: a,
  state: r = "ready",
  error: o,
  onRetry: s,
  loadingText: l = "불러오는 중…",
  rows: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement(
    dr,
    {
      flush: !0,
      className: [wt.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(n.Fragment, null, e, t ? /* @__PURE__ */ n.createElement("small", { className: wt.sub }, t) : null),
      trailing: a
    },
    r === "loading" && /* @__PURE__ */ n.createElement("div", { className: wt.state }, l),
    r === "error" && /* @__PURE__ */ n.createElement("div", { className: wt.state }, /* @__PURE__ */ n.createElement(Dr, null, o != null ? o : "불러오지 못했습니다"), s && /* @__PURE__ */ n.createElement(aa, { onClick: s }, "다시 시도")),
    r === "ready" && /* @__PURE__ */ n.createElement("div", { className: wt.list }, c.map((m, u) => {
      var f, y;
      const d = [wt.row, m.tone ? wt[m.tone] : ""].filter(Boolean).join(" "), p = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", null, m.label), /* @__PURE__ */ n.createElement("strong", null, m.value, m.unit ? /* @__PURE__ */ n.createElement("small", null, m.unit) : null));
      return m.onClick ? /* @__PURE__ */ n.createElement("button", { type: "button", key: (f = m.key) != null ? f : u, className: d, onClick: m.onClick }, p) : /* @__PURE__ */ n.createElement("div", { key: (y = m.key) != null ? y : u, className: d }, p);
    }))
  );
}
function qf(e, t, a, r, o) {
  const s = Math.max(0, Math.floor(e));
  if (s === 0) return 1;
  const l = Math.max(1, Math.min(s, o != null && o > 0 ? Math.floor(o) : s)), c = Math.max(1, Math.min(l, Math.floor((t + r) / (a + r)))), i = Math.ceil(s / c);
  return Math.ceil(s / i);
}
const If = "_group_16rha_1", Rf = "_tile_16rha_2", Of = "_click_16rha_9", Pf = "_ok_16rha_12", Xf = "_warn_16rha_13", zf = "_danger_16rha_14", Ff = "_info_16rha_15", Wf = "_accent_16rha_16", Hf = "_muted_16rha_17", Kf = "_label_16rha_18", Uf = "_value_16rha_20", Yf = "_desc_16rha_25", $t = {
  group: If,
  tile: Rf,
  click: Of,
  ok: Pf,
  warn: Xf,
  danger: zf,
  info: Ff,
  accent: Wf,
  muted: Hf,
  label: Kf,
  value: Uf,
  desc: Yf
};
function x0({
  label: e,
  value: t,
  unit: a,
  desc: r,
  tone: o = "info",
  onClick: s,
  className: l = ""
}) {
  const c = [$t.tile, $t[o], s ? $t.click : "", l].filter(Boolean).join(" "), i = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: $t.label, "data-csv-k": "" }, /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ n.createElement("span", { className: $t.value, "data-csv-v": "" }, t, a ? /* @__PURE__ */ n.createElement("small", { "data-csv-unit": "" }, a) : null), r ? /* @__PURE__ */ n.createElement("span", { className: $t.desc, title: typeof r == "string" ? r : void 0 }, r) : null);
  return s ? /* @__PURE__ */ n.createElement("button", { type: "button", className: c, onClick: s, "data-csv-kv": "" }, i) : /* @__PURE__ */ n.createElement("div", { className: c, "data-csv-kv": "" }, i);
}
const Gf = 150, Vf = 12, Jf = 8;
function D0({ children: e, columns: t, className: a = "" }) {
  const r = q(null), o = Kn.toArray(e).filter(on).length, s = t != null || o <= Jf, [l, c] = S(null);
  je(() => {
    const u = r.current;
    if (!s || !u || (c(u.clientWidth), typeof ResizeObserver == "undefined")) return;
    const d = new ResizeObserver(() => c(u.clientWidth));
    return d.observe(u), () => d.disconnect();
  }, [s]);
  const i = s ? qf(o, l != null ? l : Number.MAX_SAFE_INTEGER, Gf, Vf, t) : 0, m = s ? { gridTemplateColumns: `repeat(${i}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ n.createElement("div", { ref: r, className: [$t.group, a].filter(Boolean).join(" "), style: m }, e);
}
const Qf = "_card_1lav2_1", Zf = "_n_1lav2_2", ep = "_list_1lav2_7", tp = "_row_1lav2_8", np = "_go_1lav2_15", ap = "_name_1lav2_16", rp = "_empty_1lav2_17", op = "_star_1lav2_18", sp = "_clear_1lav2_27", Je = {
  card: Qf,
  n: Zf,
  list: ep,
  row: tp,
  go: np,
  name: ap,
  empty: rp,
  star: op,
  clear: sp
};
function C0({
  mine: e,
  recent: t,
  onOpen: a,
  onClearRecent: r,
  mineHint: o = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: s = ""
}) {
  const [l, c] = S("mine"), i = l === "mine" ? e : t;
  return /* @__PURE__ */ n.createElement(
    dr,
    {
      flush: !0,
      className: [Je.card, s].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(
        rr,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: l,
          onChange: (m) => c(m),
          items: [
            { key: "mine", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Je.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "최근 사용", t.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Je.n }, t.length)) }
          ]
        }
      ),
      trailing: l === "recent" && t.length > 0 && r ? /* @__PURE__ */ n.createElement(aa, { className: Je.clear, onClick: r }, "지우기") : void 0
    },
    i.length > 0 ? /* @__PURE__ */ n.createElement("ul", { className: Je.list }, i.map((m) => /* @__PURE__ */ n.createElement("li", { key: m.path }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Je.row, onClick: () => a(m) }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Je.go }, "↗"), /* @__PURE__ */ n.createElement("span", { className: Je.name }, m.label))))) : /* @__PURE__ */ n.createElement("div", { className: Je.empty }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Je.star }, "★"), /* @__PURE__ */ n.createElement("strong", null, l === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ n.createElement("p", null, l === "mine" ? o : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function Ia(e) {
  var t;
  try {
    const a = JSON.parse((t = window.localStorage.getItem(e)) != null ? t : "[]");
    return Array.isArray(a) ? a.filter((r) => r && typeof r.path == "string" && typeof r.label == "string") : [];
  } catch {
    return [];
  }
}
function Xn(e, t) {
  try {
    window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
function A0({ mineKey: e, recentKey: t, recentMax: a = 6 }) {
  const [r, o] = S(() => Ia(e)), [s, l] = S(() => Ia(t)), c = le((d) => r.some((p) => p.path === d), [r]), i = le((d) => o((p) => {
    const f = p.some((y) => y.path === d.path) ? p.filter((y) => y.path !== d.path) : [...p, d];
    return Xn(e, f), f;
  }), [e]), m = le((d) => l((p) => {
    const f = [d, ...p.filter((y) => y.path !== d.path)].slice(0, a);
    return Xn(t, f), f;
  }), [t, a]), u = le(() => {
    l([]), Xn(t, []);
  }, [t]);
  return { mine: r, recent: s, isMine: c, toggleMine: i, remember: m, clearRecent: u };
}
const lp = "_banner_7tqhk_2", cp = "_heading_7tqhk_7", ip = "_sparkleBox_7tqhk_8", up = "_eyebrow_7tqhk_12", mp = "_headline_7tqhk_13", dp = "_desc_7tqhk_15", _p = "_err_7tqhk_16", fp = "_chips_7tqhk_18", pp = "_footer_7tqhk_28", yp = "_kicker_7tqhk_35", bp = "_list_7tqhk_36", hp = "_row_7tqhk_37", gp = "_icon_7tqhk_39", Ep = "_text_7tqhk_40", vp = "_cap_7tqhk_41", kp = "_body_7tqhk_43", wp = "_reason_7tqhk_44", Np = "_empty_7tqhk_45", be = {
  banner: lp,
  heading: cp,
  sparkleBox: ip,
  eyebrow: up,
  headline: mp,
  desc: dp,
  err: _p,
  chips: fp,
  footer: pp,
  kicker: yp,
  list: bp,
  row: hp,
  icon: gp,
  text: Ep,
  cap: vp,
  body: kp,
  reason: wp,
  empty: Np
};
function Ra({ size: e = 18 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function S0({
  eyebrow: e,
  headline: t,
  desc: a,
  error: r,
  groups: o,
  maxChips: s = 4,
  onOpen: l,
  note: c,
  noteError: i,
  allLabel: m = "전체 업무 제안 보기",
  allDisabled: u,
  className: d = ""
}) {
  const p = o.slice(0, s), f = o.length - p.length;
  return /* @__PURE__ */ n.createElement("section", { className: [be.banner, d].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: be.heading }, /* @__PURE__ */ n.createElement("span", { className: be.sparkleBox }, /* @__PURE__ */ n.createElement(Ra, { size: 22 })), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: be.eyebrow }, /* @__PURE__ */ n.createElement(Ra, { size: 11 }), " ", e), /* @__PURE__ */ n.createElement("h2", { className: be.headline }, t), a ? /* @__PURE__ */ n.createElement("p", { className: [be.desc, r ? be.err : ""].filter(Boolean).join(" ") }, a) : null)), o.length > 0 && /* @__PURE__ */ n.createElement("div", { className: be.chips }, p.map((y) => /* @__PURE__ */ n.createElement("button", { type: "button", key: y.key, title: y.label, onClick: () => l(y.key) }, /* @__PURE__ */ n.createElement("i", { style: y.color ? { background: y.color } : void 0, "aria-hidden": "true" }), y.label, " ", /* @__PURE__ */ n.createElement("strong", { style: y.color ? { color: y.color } : void 0 }, y.count, "건"))), f > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(null) }, "+", f, "종류 더")), /* @__PURE__ */ n.createElement("div", { className: be.footer }, /* @__PURE__ */ n.createElement(
    "span",
    {
      className: i ? be.err : void 0,
      role: i ? "alert" : void 0
    },
    c
  ), /* @__PURE__ */ n.createElement(aa, { onClick: () => l(null), disabled: u }, m, " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function $p({ items: e, onRun: t, onSkip: a, busy: r, emptyText: o = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: be.empty }, o) : /* @__PURE__ */ n.createElement("ul", { className: be.list }, e.map((s) => {
    var l, c;
    return /* @__PURE__ */ n.createElement("li", { key: s.id, className: be.row }, /* @__PURE__ */ n.createElement("span", { className: be.icon, "aria-hidden": "true" }, (l = s.icon) != null ? l : "💡"), /* @__PURE__ */ n.createElement("div", { className: be.text }, /* @__PURE__ */ n.createElement("div", { className: be.cap }, s.title, s.meta ? /* @__PURE__ */ n.createElement("small", null, " · ", s.meta) : null), /* @__PURE__ */ n.createElement("div", { className: be.body }, s.body), s.reason ? /* @__PURE__ */ n.createElement("div", { className: be.reason }, s.reason) : null), /* @__PURE__ */ n.createElement(Ft, { variant: "primary", disabled: r, onClick: () => t(s) }, (c = s.actionLabel) != null ? c : "실행"), /* @__PURE__ */ n.createElement(Ft, { disabled: r, onClick: () => a(s) }, "무시"));
  }));
}
function M0({ title: e, kicker: t = "ProActive AI 업무 제안", items: a, onClose: r, onRun: o, onSkip: s }) {
  const l = q(!1), [c, i] = S(!1), [m, u] = S(""), d = async (p) => {
    if (!l.current) {
      l.current = !0, i(!0), u("");
      try {
        await p();
      } catch (f) {
        u(f instanceof Error ? f.message : "처리에 실패했습니다");
      } finally {
        l.current = !1, i(!1);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(
    ca,
    {
      title: e,
      onClose: r,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ n.createElement("span", { className: be.kicker }, "✦ ", t),
      error: m,
      footer: /* @__PURE__ */ n.createElement(Ft, { onClick: r }, "닫기")
    },
    /* @__PURE__ */ n.createElement($p, { items: a, busy: c, onRun: (p) => d(() => o(p)), onSkip: (p) => d(() => s(p)) })
  );
}
const xp = "_wrap_1wvdc_2", Dp = "_header_1wvdc_7", Cp = "_iconBox_1wvdc_8", Ap = "_headText_1wvdc_12", Sp = "_eyebrow_1wvdc_13", Mp = "_headline_1wvdc_14", Tp = "_headerExtra_1wvdc_16", Bp = "_grid_1wvdc_19", jp = "_card_1wvdc_20", Lp = "_badge_1wvdc_29", qp = "_toneRed_1wvdc_33", Ip = "_toneViolet_1wvdc_34", Rp = "_toneGreen_1wvdc_35", Op = "_toneBlue_1wvdc_36", Pp = "_title_1wvdc_38", Xp = "_summary_1wvdc_42", zp = "_action_1wvdc_46", Fp = "_notice_1wvdc_53", Wp = "_err_1wvdc_56", fe = {
  wrap: xp,
  header: Dp,
  iconBox: Cp,
  headText: Ap,
  eyebrow: Sp,
  headline: Mp,
  headerExtra: Tp,
  grid: Bp,
  card: jp,
  badge: Lp,
  toneRed: qp,
  toneViolet: Ip,
  toneGreen: Rp,
  toneBlue: Op,
  title: Pp,
  summary: Xp,
  action: zp,
  notice: Fp,
  err: Wp
};
function Oa({ size: e = 16 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const Hp = {
  red: fe.toneRed,
  violet: fe.toneViolet,
  green: fe.toneGreen,
  blue: fe.toneBlue
};
function T0({
  items: e,
  onOpen: t,
  eyebrow: a = "PROACTIVE AI",
  headline: r = "지금 처리할 수 있는 업무를 발견했습니다",
  error: o,
  loading: s,
  emptyText: l = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [fe.wrap, i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: fe.header }, /* @__PURE__ */ n.createElement("span", { className: fe.iconBox }, /* @__PURE__ */ n.createElement(Oa, { size: 18 })), /* @__PURE__ */ n.createElement("div", { className: fe.headText }, /* @__PURE__ */ n.createElement("div", { className: fe.eyebrow }, a), /* @__PURE__ */ n.createElement("h2", { className: fe.headline }, r)), c ? /* @__PURE__ */ n.createElement("div", { className: fe.headerExtra }, c) : null), o ? /* @__PURE__ */ n.createElement("div", { className: fe.notice + " " + fe.err, role: "alert" }, o) : null, e.length === 0 ? o ? null : s ? /* @__PURE__ */ n.createElement("div", { className: fe.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ n.createElement("div", { className: fe.notice }, l) : /* @__PURE__ */ n.createElement("div", { className: fe.grid }, e.map((m) => {
    var u, d;
    return /* @__PURE__ */ n.createElement("button", { type: "button", key: m.id, className: fe.card, onClick: () => t(m) }, /* @__PURE__ */ n.createElement("span", { className: [fe.badge, Hp[(u = m.tone) != null ? u : "violet"]].join(" ") }, /* @__PURE__ */ n.createElement(Oa, { size: 9 }), m.badge), /* @__PURE__ */ n.createElement("span", { className: fe.title }, m.title), m.summary ? /* @__PURE__ */ n.createElement("span", { className: fe.summary, title: typeof m.summary == "string" ? m.summary : void 0 }, m.summary) : null, /* @__PURE__ */ n.createElement("span", { className: fe.action }, (d = m.actionLabel) != null ? d : "상세 보기", " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const Kp = "_wrapper_wrch3_1", Up = "_searchIcon_wrch3_18", Yp = "_input_wrch3_26", Gp = "_clearButton_wrch3_40", Vp = "_hint_wrch3_60", Qt = {
  wrapper: Kp,
  searchIcon: Up,
  input: Yp,
  clearButton: Gp,
  hint: Vp
}, Jp = /* @__PURE__ */ n.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ n.createElement("path", { d: "M21 21l-4.35-4.35" }));
function Qp({
  value: e,
  onChange: t,
  placeholder: a,
  hint: r,
  onSubmit: o,
  onClear: s
}) {
  const l = (c) => {
    c.key === "Enter" && (o == null || o());
  };
  return /* @__PURE__ */ n.createElement("div", { className: Qt.wrapper }, /* @__PURE__ */ n.createElement("span", { className: Qt.searchIcon }, Jp), /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      className: Qt.input,
      value: e,
      placeholder: a,
      onChange: (c) => t(c.target.value),
      onKeyDown: l
    }
  ), s && e.length > 0 && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Qt.clearButton,
      onClick: s,
      "aria-label": "clear"
    },
    /* @__PURE__ */ n.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ n.createElement("path", { d: "M6 6l12 12" }))
  ), r && /* @__PURE__ */ n.createElement("span", { className: Qt.hint }, r));
}
const Zp = "_screen_1bsma_1", ey = "_shell_1bsma_8", ty = "_command_1bsma_10", ny = "_body_1bsma_20", ay = "_overview_1bsma_22", ry = "_areaHead_1bsma_25", Pt = {
  screen: Zp,
  shell: ey,
  command: ty,
  body: ny,
  overview: ay,
  areaHead: ry
};
function B0({ search: e, panel: t, children: a, className: r = "" }) {
  var o;
  return /* @__PURE__ */ n.createElement("main", { className: [Pt.screen, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: Pt.shell }, e && /* @__PURE__ */ n.createElement("div", { className: Pt.command }, /* @__PURE__ */ n.createElement(
    Qp,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (o = e.hint) != null ? o : /* @__PURE__ */ n.createElement("kbd", null, "F10")
    }
  ), t), /* @__PURE__ */ n.createElement("div", { className: Pt.body }, a)));
}
function j0({ children: e, className: t = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Pt.overview, t].filter(Boolean).join(" ") }, e);
}
function L0({ title: e, hint: t }) {
  return /* @__PURE__ */ n.createElement("div", { className: Pt.areaHead }, /* @__PURE__ */ n.createElement("h2", null, e), t && /* @__PURE__ */ n.createElement("span", null, t));
}
const oy = "_group_oodts_1", sy = "_grid_oodts_7", ly = "_row_oodts_8", cy = "_item_oodts_9", iy = "_launch_oodts_14", uy = "_name_oodts_17", my = "_desc_oodts_18", dy = "_badge_oodts_19", _y = "_disabled_oodts_23", fy = "_tab_oodts_25", py = "_star_oodts_25", yy = "_on_oodts_30", by = "_empty_oodts_32", Re = {
  group: oy,
  grid: sy,
  row: ly,
  item: cy,
  launch: iy,
  name: uy,
  desc: my,
  badge: dy,
  disabled: _y,
  tab: fy,
  star: py,
  on: yy,
  empty: by
};
function hy() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function gy() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function q0({ title: e, items: t, emptyText: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("section", { className: [Re.group, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), /* @__PURE__ */ n.createElement("div", { className: Re.grid }, t.map((o) => /* @__PURE__ */ n.createElement("div", { className: Re.row, key: o.key }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Re.item, o.disabled ? Re.disabled : ""].filter(Boolean).join(" "),
      disabled: o.disabled,
      onClick: o.onOpen
    },
    /* @__PURE__ */ n.createElement("span", { className: Re.launch }, /* @__PURE__ */ n.createElement(hy, null)),
    /* @__PURE__ */ n.createElement("span", { className: Re.name }, o.label),
    o.desc && /* @__PURE__ */ n.createElement("span", { className: Re.desc }, o.desc),
    o.badge != null && /* @__PURE__ */ n.createElement("em", { className: Re.badge }, o.badge)
  ), o.onOpenNewTab && !o.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Re.tab,
      "aria-label": `${o.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: o.onOpenNewTab
    },
    /* @__PURE__ */ n.createElement(gy, null)
  ), o.onToggleStar && !o.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Re.star, o.starred ? Re.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!o.starred,
      "aria-label": `${o.label} ${o.starred ? "마이메뉴에서 빼기" : "마이메뉴에 담기"}`,
      onClick: o.onToggleStar
    },
    o.starred ? "★" : "☆"
  ))), t.length === 0 && a != null && /* @__PURE__ */ n.createElement("p", { className: Re.empty }, a)));
}
const Ey = "_strip_8zhai_2", vy = "_day_8zhai_9", ky = "_total_8zhai_10", wy = "_sel_8zhai_31", Ny = "_today_8zhai_35", $y = "_md_8zhai_35", xy = "_off_8zhai_36", Dy = "_head_8zhai_45", Cy = "_wd_8zhai_46", Ay = "_sun_8zhai_47", Sy = "_sat_8zhai_48", My = "_lock_8zhai_50", Ty = "_value_8zhai_60", By = "_mark_8zhai_66", jy = "_warn_8zhai_67", Ly = "_danger_8zhai_68", qy = "_info_8zhai_69", $e = {
  strip: Ey,
  day: vy,
  total: ky,
  sel: wy,
  today: Ny,
  md: $y,
  off: xy,
  head: Dy,
  wd: Cy,
  sun: Ay,
  sat: Sy,
  lock: My,
  value: Ty,
  mark: By,
  warn: jy,
  danger: Ly,
  info: qy
}, Pa = ["일", "월", "화", "수", "목", "금", "토"];
function Iy(e) {
  const [t, a, r] = e.split("-").map(Number), o = new Date(t, a - 1, r).getDay();
  return { md: `${a}/${r}`, wd: o };
}
function I0({
  days: e,
  selected: t,
  today: a,
  onSelect: r,
  total: o,
  totalLabel: s = "합계",
  "aria-label": l,
  className: c
}) {
  const i = q([]), m = (p) => {
    var y;
    const f = e.length;
    for (let _ = 0; _ < f; _++) {
      const b = (p + _ + f) % f;
      if (!e[b].disabled) {
        (y = i.current[b]) == null || y.focus();
        return;
      }
    }
  }, u = (p, f) => {
    p.key === "ArrowRight" ? (p.preventDefault(), m(f + 1)) : p.key === "ArrowLeft" ? (p.preventDefault(), m(f - 1)) : p.key === "Home" ? (p.preventDefault(), m(0)) : p.key === "End" && (p.preventDefault(), m(e.length - 1));
  }, d = Math.max(0, e.findIndex((p) => p.date === t));
  return /* @__PURE__ */ n.createElement("div", { className: `${$e.strip}${c ? ` ${c}` : ""}`, role: "group", "aria-label": l }, e.map((p, f) => {
    var k, w, x, E;
    const { md: y, wd: _ } = Iy(p.date), b = [
      $e.day,
      p.off ? $e.off : "",
      p.date === t ? $e.sel : "",
      p.date === a ? $e.today : "",
      _ === 0 ? $e.sun : _ === 6 ? $e.sat : ""
    ].filter(Boolean).join(" "), $ = [`${y}(${Pa[_]})`, p.offLabel, p.locked ? "잠김" : null, (k = p.mark) == null ? void 0 : k.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: p.date,
        ref: (g) => {
          i.current[f] = g;
        },
        type: "button",
        className: b,
        disabled: p.disabled,
        tabIndex: f === d ? 0 : -1,
        "aria-pressed": p.date === t,
        "aria-label": $,
        title: $,
        onClick: () => r == null ? void 0 : r(p.date),
        onKeyDown: (g) => u(g, f)
      },
      /* @__PURE__ */ n.createElement("span", { className: $e.head }, /* @__PURE__ */ n.createElement("span", { className: $e.wd }, Pa[_]), /* @__PURE__ */ n.createElement("span", { className: $e.md }, y), p.locked && /* @__PURE__ */ n.createElement("span", { className: $e.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ n.createElement("span", { className: $e.value }, p.value),
      /* @__PURE__ */ n.createElement("span", { className: `${$e.mark}${p.mark ? ` ${$e[p.mark.tone]}` : ""}` }, (E = (w = p.mark) == null ? void 0 : w.text) != null ? E : p.off && (x = p.offLabel) != null ? x : "")
    );
  }), o !== void 0 && /* @__PURE__ */ n.createElement("div", { className: $e.total }, /* @__PURE__ */ n.createElement("span", { className: $e.wd }, s), /* @__PURE__ */ n.createElement("span", { className: $e.value }, o)));
}
const Ry = "_stepper_1wbt2_1", Oy = "_nav_1wbt2_2", Py = "_today_1wbt2_3", Xy = "_range_1wbt2_14", Zt = {
  stepper: Ry,
  nav: Oy,
  today: Py,
  range: Xy
};
function zy(e) {
  const t = oa(e);
  return t === 0 ? 7 : t;
}
function Fy(e, t = 1) {
  const a = (zy(e) - t + 7) % 7;
  return Cn(e, -a);
}
function zn(e, t) {
  return Cn(e, t);
}
function R0({ value: e, onChange: t, weekStart: a = 1, today: r, disabled: o, label: s = "주" }) {
  const l = zn(e, 6), c = Fy(r, a), i = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ n.createElement("span", { className: Zt.stepper, role: "group", "aria-label": s }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Zt.nav,
      onClick: () => t(zn(e, -7)),
      disabled: o,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ n.createElement("span", { className: Zt.range, "aria-live": "polite" }, e, " ~ ", i), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Zt.nav,
      onClick: () => t(zn(e, 7)),
      disabled: o,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Zt.today,
      onClick: () => t(c),
      disabled: o || e === c
    },
    "이번 주"
  ));
}
const Wy = "_wrap_1dtpy_1", Hy = "_svg_1dtpy_2", Ky = "_grid_1dtpy_3", Uy = "_axis_1dtpy_4", Yy = "_accent_1dtpy_5", Gy = "_muted_1dtpy_6", Vy = "_ok_1dtpy_7", Jy = "_warn_1dtpy_8", Qy = "_danger_1dtpy_9", Zy = "_legend_1dtpy_10", eb = "_dot_accent_1dtpy_13", tb = "_dot_muted_1dtpy_14", nb = "_dot_ok_1dtpy_15", ab = "_dot_warn_1dtpy_16", rb = "_dot_danger_1dtpy_17", yt = {
  wrap: Wy,
  svg: Hy,
  grid: Ky,
  axis: Uy,
  accent: Yy,
  muted: Gy,
  ok: Vy,
  warn: Jy,
  danger: Qy,
  legend: Zy,
  dot_accent: eb,
  dot_muted: tb,
  dot_ok: nb,
  dot_warn: ab,
  dot_danger: rb
}, ob = 600;
function sb(e) {
  if (e <= 0) return 1;
  const t = Math.pow(10, Math.floor(Math.log10(e))), a = e / t;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * t;
}
const Xa = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function O0({ categories: e, series: t, unit: a = "", height: r = 180, label: o, labelEvery: s }) {
  const l = q(null), [c, i] = S(ob);
  je(() => {
    const h = l.current;
    if (!h) return;
    const N = () => {
      const j = h.clientWidth;
      j > 0 && i((B) => B === j ? B : j);
    };
    if (N(), typeof ResizeObserver == "undefined") return;
    const D = new ResizeObserver(N);
    return D.observe(h), () => D.disconnect();
  }, []);
  const m = r, u = 40, d = 22, p = 8, f = c - u - 4, y = m - d - p, _ = t.flatMap((h) => h.values.filter((N) => N != null)), b = sb(Math.max(0, ..._)), $ = Math.max(e.length, 1), k = f / $, w = Math.min(8, k * 0.2), x = Math.max(1, (k - w) / Math.max(t.length, 1)), E = s != null ? s : Math.max(1, Math.ceil($ / 8)), g = [0, b / 2, b];
  return /* @__PURE__ */ n.createElement("div", { className: yt.wrap, ref: l }, /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: yt.svg,
      viewBox: `0 0 ${c} ${m}`,
      role: "img",
      "aria-label": o,
      style: { height: r }
    },
    g.map((h) => {
      const N = p + y - h / b * y;
      return /* @__PURE__ */ n.createElement("g", { key: h }, /* @__PURE__ */ n.createElement("line", { className: yt.grid, x1: u, x2: c - 4, y1: N, y2: N }), /* @__PURE__ */ n.createElement("text", { className: yt.axis, x: u - 4, y: N + 3, textAnchor: "end" }, Xa(h)));
    }),
    e.map((h, N) => /* @__PURE__ */ n.createElement("g", { key: h }, t.map((D, j) => {
      var T;
      const B = D.values[N];
      if (B == null || B <= 0) return null;
      const I = B / b * y;
      return /* @__PURE__ */ n.createElement(
        "rect",
        {
          key: D.key,
          className: yt[(T = D.tone) != null ? T : "accent"],
          x: u + N * k + w / 2 + j * x,
          y: p + y - I,
          width: x,
          height: I
        },
        /* @__PURE__ */ n.createElement("title", null, `${h} · ${D.label} ${Xa(B)}${a}`)
      );
    }), N % E === 0 && /* @__PURE__ */ n.createElement("text", { className: yt.axis, x: u + N * k + k / 2, y: m - 6, textAnchor: "middle" }, h)))
  ), /* @__PURE__ */ n.createElement("ul", { className: yt.legend }, t.map((h) => {
    var N;
    return /* @__PURE__ */ n.createElement("li", { key: h.key }, /* @__PURE__ */ n.createElement("i", { className: yt[`dot_${(N = h.tone) != null ? N : "accent"}`], "aria-hidden": "true" }), h.label, a ? ` (${a})` : "");
  })));
}
const lb = "_wrap_85lir_1", cb = "_track_85lir_2", ib = "_accent_85lir_3", ub = "_muted_85lir_3", mb = "_ok_85lir_3", db = "_warn_85lir_3", _b = "_danger_85lir_3", fb = "_center_85lir_9", pb = "_legend_85lir_10", yb = "_name_85lir_13", bb = "_val_85lir_14", hb = "_pct_85lir_15", gb = "_dot_accent_85lir_16", Eb = "_dot_muted_85lir_17", vb = "_dot_ok_85lir_18", kb = "_dot_warn_85lir_19", wb = "_dot_danger_85lir_20", st = {
  wrap: lb,
  track: cb,
  accent: ib,
  muted: ub,
  ok: mb,
  warn: db,
  danger: _b,
  center: fb,
  legend: pb,
  name: yb,
  val: bb,
  pct: hb,
  dot_accent: gb,
  dot_muted: Eb,
  dot_ok: vb,
  dot_warn: kb,
  dot_danger: wb
}, Jn = 40, za = 2 * Math.PI * Jn;
function P0({ items: e, center: t, size: a = 120, label: r, emptyText: o = "자료 없음", unit: s = "" }) {
  const l = e.reduce((i, m) => i + Math.max(0, m.value), 0);
  let c = 0;
  return /* @__PURE__ */ n.createElement("div", { className: st.wrap }, /* @__PURE__ */ n.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": r }, /* @__PURE__ */ n.createElement("circle", { className: st.track, cx: "50", cy: "50", r: Jn }), l > 0 && e.map((i) => {
    var d;
    const m = Math.max(0, i.value) / l * za, u = c;
    return c += m, m <= 0 ? null : /* @__PURE__ */ n.createElement(
      "circle",
      {
        key: i.key,
        className: st[(d = i.tone) != null ? d : "accent"],
        cx: "50",
        cy: "50",
        r: Jn,
        strokeDasharray: `${m} ${za - m}`,
        strokeDashoffset: -u,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ n.createElement("title", null, `${i.label} ${i.value.toLocaleString("ko-KR")}${s}`)
    );
  }), /* @__PURE__ */ n.createElement("text", { className: st.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? t != null ? t : l.toLocaleString("ko-KR") : o)), /* @__PURE__ */ n.createElement("ul", { className: st.legend }, e.map((i) => {
    var m;
    return /* @__PURE__ */ n.createElement("li", { key: i.key }, /* @__PURE__ */ n.createElement("i", { className: st[`dot_${(m = i.tone) != null ? m : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ n.createElement("span", { className: st.name }, i.label), /* @__PURE__ */ n.createElement("span", { className: st.val }, i.value.toLocaleString("ko-KR"), s), /* @__PURE__ */ n.createElement("span", { className: st.pct }, l > 0 ? `${Math.round(i.value / l * 100)}%` : "-"));
  })));
}
const Nb = "_wrap_1b8ll_1", $b = "_track_1b8ll_2", xb = "_compact_1b8ll_3", Db = "_fill_1b8ll_4", Cb = "_accent_1b8ll_5", Ab = "_muted_1b8ll_6", Sb = "_ok_1b8ll_7", Mb = "_warn_1b8ll_8", Tb = "_danger_1b8ll_9", Bb = "_num_1b8ll_10", jb = "_none_1b8ll_12", Nt = {
  wrap: Nb,
  track: $b,
  compact: xb,
  fill: Db,
  accent: Cb,
  muted: Ab,
  ok: Sb,
  warn: Mb,
  danger: Tb,
  num: Bb,
  none: jb
};
function X0({ value: e, label: t, tone: a = "accent", compact: r }) {
  if (e == null)
    return /* @__PURE__ */ n.createElement("span", { className: Nt.none, "aria-label": `${t} 해당 없음` }, "-");
  const o = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Nt.wrap, r ? Nt.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": t,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": o
    },
    /* @__PURE__ */ n.createElement("span", { className: Nt.track }, /* @__PURE__ */ n.createElement("span", { className: `${Nt.fill} ${Nt[a]}`, style: { width: `${o}%` } })),
    /* @__PURE__ */ n.createElement("span", { className: Nt.num }, o, "%")
  );
}
const Lb = { day: 28, week: 10, month: 3 };
function Mt(e, t) {
  return Cn(e, t);
}
function Qn(e, t) {
  return gt(t) - gt(e) + 1;
}
function Mr(e) {
  return oa(e);
}
const Fa = (e) => {
  const t = Mr(e);
  return t === 0 || t === 6;
};
function Ot(e, t, a, r) {
  const o = [], s = Qn(e, t);
  for (let l = 0; l < s; l++) {
    const c = Mt(e, l), i = a(c), m = o[o.length - 1];
    m && m.key === i ? m.days++ : o.push({ key: i, label: r(c), offset: l, days: 1 });
  }
  return o;
}
function qb(e, t, a) {
  const r = (s) => s.slice(0, 7), o = (s) => `${s.slice(0, 4)}.${s.slice(5, 7)}`;
  if (a === "month")
    return {
      top: Ot(e, t, (s) => s.slice(0, 4), (s) => `${s.slice(0, 4)}년`),
      bottom: Ot(e, t, r, (s) => `${Number(s.slice(5, 7))}월`)
    };
  if (a === "week") {
    const s = (l) => Mt(l, -((Mr(l) + 6) % 7));
    return {
      top: Ot(e, t, r, o),
      bottom: Ot(e, t, s, (l) => {
        const c = s(l);
        return `${Number(c.slice(5, 7))}/${Number(c.slice(8, 10))}`;
      })
    };
  }
  return {
    top: Ot(e, t, r, o),
    bottom: Ot(e, t, (s) => s, (s) => String(Number(s.slice(8, 10))))
  };
}
function Fn(e, t, a, r) {
  if (a === "move") return { start: Mt(e, r), end: Mt(t, r) };
  if (a === "start") {
    const s = Mt(e, r);
    return { start: s > t ? t : s, end: t };
  }
  const o = Mt(t, r);
  return { start: e, end: o < e ? e : o };
}
const Ib = "_gantt_1smka_3", Rb = "_scroll_1smka_15", Ob = "_canvas_1smka_21", Pb = "_head_1smka_24", Xb = "_headLabel_1smka_32", zb = "_headTrack_1smka_43", Fb = "_band_1smka_44", Wb = "_seg_1smka_46", Hb = "_tick_1smka_59", Kb = "_tickOff_1smka_60", Ub = "_body_1smka_62", Yb = "_overlay_1smka_65", Gb = "_weekend_1smka_66", Vb = "_holiday_1smka_66", Jb = "_today_1smka_68", Qb = "_row_1smka_70", Zb = "_label_1smka_76", eh = "_sel_1smka_77", th = "_track_1smka_77", nh = "_dim_1smka_78", ah = "_labelText_1smka_95", rh = "_dot_1smka_96", oh = "_warn_1smka_97", sh = "_err_1smka_98", lh = "_bar_1smka_113", ch = "_can_1smka_21", ih = "_dragging_1smka_126", uh = "_fill_1smka_127", mh = "_late_1smka_128", dh = "_summary_1smka_130", _h = "_handle_1smka_133", fh = "_hL_1smka_134", ph = "_hR_1smka_135", yh = "_mark_1smka_137", bh = "_barText_1smka_138", hh = "_empty_1smka_147", gh = "_srOnly_1smka_150", ne = {
  gantt: Ib,
  scroll: Rb,
  canvas: Ob,
  head: Pb,
  headLabel: Xb,
  headTrack: zb,
  band: Fb,
  seg: Wb,
  tick: Hb,
  tickOff: Kb,
  body: Ub,
  overlay: Yb,
  weekend: Gb,
  holiday: Vb,
  today: Jb,
  row: Qb,
  label: Zb,
  sel: eh,
  track: th,
  dim: nh,
  labelText: ah,
  dot: rh,
  warn: oh,
  err: sh,
  bar: lh,
  can: ch,
  dragging: ih,
  fill: uh,
  late: mh,
  summary: dh,
  handle: _h,
  hL: fh,
  hR: ph,
  mark: yh,
  barText: bh,
  empty: hh,
  srOnly: gh
}, Wa = 28, Ha = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let Eh = 0;
function z0({
  rows: e,
  from: t,
  to: a,
  scale: r = "day",
  holidays: o = {},
  today: s,
  scrollToToday: l = !0,
  onChange: c,
  onRowClick: i,
  selectedId: m,
  labelWidth: u = 280,
  labelHeader: d,
  lockedReason: p,
  scrollMemory: f,
  className: y = "",
  style: _,
  "aria-label": b
}) {
  const $ = q("");
  $.current || ($.current = `axe-gantt-keys-${++Eh}`);
  const k = Lb[r], w = Math.max(Qn(t, a), 1), x = gt(t), E = w * k, g = we(() => qb(t, a, r), [t, a, r]), h = we(() => {
    const v = [];
    for (let R = 0; R < w; R++) {
      const Y = Mt(t, R), Z = Y in o;
      if (!Z && !Fa(Y)) continue;
      const C = v[v.length - 1];
      C && C.offset + C.days === R && C.holiday === Z ? C.days++ : v.push({ offset: R, days: 1, holiday: Z });
    }
    return v;
  }, [t, w, o]), [N, D] = S(null), j = q(null), B = (v) => !!c && !v.locked && !v.summary && !!v.start && !!v.end, I = (v, R, Y) => {
    if (!B(R) || v.button !== 0) return;
    v.stopPropagation(), v.currentTarget.setPointerCapture(v.pointerId);
    const Z = { id: R.id, mode: Y, x: v.clientX, delta: 0, moved: !1 };
    j.current = Z, D(Z);
  }, T = (v) => {
    const R = j.current;
    if (!R) return;
    const Y = Math.round((v.clientX - R.x) / k), Z = R.moved || Math.abs(v.clientX - R.x) > 3;
    if (Y !== R.delta || Z !== R.moved) {
      const C = { ...R, delta: Y, moved: Z };
      j.current = C, D(C);
    }
  }, P = (v) => {
    const R = j.current;
    if (j.current = null, D(null), !!R) {
      if (!R.moved) {
        i == null || i(v);
        return;
      }
      R.delta !== 0 && v.start && v.end && (c == null || c(v, Fn(v.start, v.end, R.mode, R.delta), R.mode));
    }
  }, ee = () => {
    j.current = null, D(null);
  }, F = (v, R) => {
    if (v.key === "Escape" && j.current) {
      ee();
      return;
    }
    if (v.key === "Enter") {
      i == null || i(R);
      return;
    }
    if (!B(R) || v.key !== "ArrowLeft" && v.key !== "ArrowRight") return;
    v.preventDefault();
    const Y = v.key === "ArrowLeft" ? -1 : 1, Z = v.shiftKey ? "end" : v.altKey ? "start" : "move";
    c == null || c(R, Fn(R.start, R.end, Z, Y), Z);
  }, L = s ? gt(s) - x : -1, ae = q(null), te = q(null);
  return je(() => {
    const v = ae.current;
    if (v && (f != null && f.current) && te.current === null) {
      te.current = r, v.scrollLeft = f.current.left, v.scrollTop = f.current.top;
      return;
    }
    if (!l || !v || L < 0 || L >= w || te.current === r) return;
    te.current = r;
    const R = Math.max(v.clientWidth - u, 0);
    v.scrollLeft = Math.max(0, L * k + k / 2 - R / 3);
  }, [l, r, L, w, k, u]), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ne.gantt, y].filter(Boolean).join(" "),
      style: _,
      role: "region",
      "aria-label": b != null ? b : "간트",
      onKeyDown: (v) => {
        v.key === "Escape" && j.current && ee();
      }
    },
    /* @__PURE__ */ n.createElement("span", { id: $.current, className: ne.srOnly }, Ha),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: ae,
        className: ne.scroll,
        onScroll: f ? (v) => {
          f.current = { left: v.currentTarget.scrollLeft, top: v.currentTarget.scrollTop };
        } : void 0
      },
      /* @__PURE__ */ n.createElement("div", { className: ne.canvas, style: { width: u + E } }, /* @__PURE__ */ n.createElement("div", { className: ne.head, style: { gridTemplateColumns: `${u}px ${E}px` } }, /* @__PURE__ */ n.createElement("div", { className: ne.headLabel }, d), /* @__PURE__ */ n.createElement("div", { className: ne.headTrack }, /* @__PURE__ */ n.createElement("div", { className: ne.band }, g.top.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.key, className: ne.seg, style: { left: v.offset * k, width: v.days * k }, title: v.label }, v.label))), /* @__PURE__ */ n.createElement("div", { className: ne.band }, g.bottom.map((v) => {
        var Y;
        const R = r === "day" && (v.key in o || Fa(v.key));
        return /* @__PURE__ */ n.createElement(
          "span",
          {
            key: v.key,
            className: [ne.seg, ne.tick, R ? ne.tickOff : ""].filter(Boolean).join(" "),
            style: { left: v.offset * k, width: v.days * k },
            title: (Y = o[v.key]) != null ? Y : v.key
          },
          v.days * k >= 16 ? v.label : ""
        );
      })))), /* @__PURE__ */ n.createElement("div", { className: ne.body, style: { minHeight: Wa } }, /* @__PURE__ */ n.createElement("div", { className: ne.overlay, style: { left: u, width: E }, "aria-hidden": "true" }, h.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.offset, className: v.holiday ? ne.holiday : ne.weekend, style: { left: v.offset * k, width: v.days * k } })), L >= 0 && L < w && /* @__PURE__ */ n.createElement("span", { className: ne.today, style: { left: L * k + k / 2 }, title: "오늘" })), e.map((v) => {
        var K, Q, Ne, He;
        const R = !!v.start && !!v.end && v.start <= v.end, Y = N && N.id === v.id ? N : null, Z = R && Y && Y.delta !== 0 ? Fn(v.start, v.end, Y.mode, Y.delta) : R ? { start: v.start, end: v.end } : null, C = Z ? (gt(Z.start) - x) * k : 0, V = Z ? Qn(Z.start, Z.end) * k : 0, J = Math.max(0, Math.min(100, (K = v.progress) != null ? K : 0)), X = m != null && m === v.id, z = B(v), O = !z && c && Z ? p == null ? void 0 : p(v) : void 0;
        return /* @__PURE__ */ n.createElement(
          "div",
          {
            key: v.id,
            className: [ne.row, X ? ne.sel : "", v.dim ? ne.dim : ""].filter(Boolean).join(" "),
            style: { height: Wa }
          },
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: ne.label,
              style: { width: u },
              title: v.name,
              onClick: () => i == null ? void 0 : i(v)
            },
            /* @__PURE__ */ n.createElement("span", { className: ne.labelText }, v.label),
            v.marked && /* @__PURE__ */ n.createElement("span", { className: ne.dot, title: "저장 대기", "aria-label": "저장 대기" }),
            v.warn && /* @__PURE__ */ n.createElement("span", { className: ne.warn, title: v.warn, "aria-label": v.warn }, "⚠"),
            v.error && /* @__PURE__ */ n.createElement("span", { className: ne.err, title: v.error, "aria-label": v.error }, "!")
          ),
          /* @__PURE__ */ n.createElement("div", { className: ne.track, style: { width: E }, onClick: () => !Y && (i == null ? void 0 : i(v)) }, Z ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
            "div",
            {
              className: [ne.bar, v.summary ? ne.summary : "", v.late ? ne.late : "", z ? ne.can : "", Y ? ne.dragging : ""].filter(Boolean).join(" "),
              style: { left: C, width: Math.max(V, 2) },
              role: "button",
              tabIndex: 0,
              "aria-label": `${(Q = v.name) != null ? Q : ""} ${Z.start} ~ ${Z.end}${v.progress != null ? ` ${J}%` : ""}${v.late ? " 지연" : ""}${O ? ` 잠김: ${O}` : ""}`,
              "aria-describedby": z ? $.current : void 0,
              title: `${Z.start} ~ ${Z.end}${v.progress != null ? ` · ${J}%` : ""}${v.late ? " · 지연" : ""}${z ? `
끌어 옮기기·양 끝 조절
${Ha}` : ""}${O ? `
잠김: ${O}` : ""}`,
              onPointerDown: (qe) => I(qe, v, "move"),
              onPointerMove: T,
              onPointerUp: () => P(v),
              onPointerCancel: ee,
              onClick: (qe) => qe.stopPropagation(),
              onKeyDown: (qe) => F(qe, v)
            },
            v.progress != null && /* @__PURE__ */ n.createElement("span", { className: ne.fill, style: { width: `${J}%` } }),
            z && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${ne.handle} ${ne.hL}`, onPointerDown: (qe) => I(qe, v, "start") }), /* @__PURE__ */ n.createElement("span", { className: `${ne.handle} ${ne.hR}`, onPointerDown: (qe) => I(qe, v, "end") }))
          ), v.markDate && v.markDate >= t && v.markDate <= a && /* @__PURE__ */ n.createElement("span", { className: ne.mark, style: { left: (gt(v.markDate) - x + 1) * k - 1 }, title: (Ne = v.markLabel) != null ? Ne : v.markDate }), v.barText && /* @__PURE__ */ n.createElement("span", { className: ne.barText, style: { left: C + Math.max(V, 2) + 4 } }, v.barText)) : /* @__PURE__ */ n.createElement("span", { className: ne.empty }, (He = v.emptyText) != null ? He : "기간 없음"))
        );
      })))
    )
  );
}
const vh = "_board_192fl_3", kh = "_col_192fl_15", wh = "_over_192fl_23", Nh = "_head_192fl_25", $h = "_title_192fl_33", xh = "_count_192fl_34", Dh = "_hint_192fl_43", Ch = "_list_192fl_45", Ah = "_empty_192fl_54", Sh = "_card_192fl_56", Mh = "_sel_192fl_68", Th = "_dragging_192fl_69", Bh = "_hasErr_192fl_70", jh = "_dot_192fl_71", Lh = "_err_192fl_72", Me = {
  board: vh,
  col: kh,
  over: wh,
  head: Nh,
  title: $h,
  count: xh,
  hint: Dh,
  list: Ch,
  empty: Ah,
  card: Sh,
  sel: Mh,
  dragging: Th,
  hasErr: Bh,
  dot: jh,
  err: Lh
}, Wn = "application/x-axerp-kanban";
function F0({
  columns: e,
  cards: t,
  cardKey: a,
  columnOf: r,
  renderCard: o,
  cardLabel: s,
  onMove: l,
  onCardClick: c,
  selectedKey: i,
  marked: m,
  error: u,
  lockedReason: d,
  emptyText: p = "카드가 없습니다",
  moveHint: f,
  className: y = "",
  style: _,
  "aria-label": b
}) {
  const $ = Ut("axe-kb"), [k, w] = S(null), [x, E] = S(null), g = new Map(t.map((B) => [String(a(B)), B])), h = q(null), N = q(null);
  G(() => {
    var T, P;
    const B = N.current;
    if (!B) return;
    if (Date.now() > B.until) {
      N.current = null;
      return;
    }
    const I = Array.from((P = (T = h.current) == null ? void 0 : T.querySelectorAll("[data-kanban-key]")) != null ? P : []).find((ee) => ee.dataset.kanbanKey === B.key);
    I && document.activeElement !== I && I.focus(), N.current = null;
  });
  const D = (B, I) => {
    B.preventDefault(), w(null), E(null);
    const T = B.dataTransfer.getData(Wn), P = g.get(T);
    P && r(P) !== I && (l == null || l(P, I));
  }, j = (B, I) => {
    if (B.key === "Enter" || B.key === " ") {
      B.preventDefault(), c == null || c(I);
      return;
    }
    if (!l || !B.altKey || B.key !== "ArrowLeft" && B.key !== "ArrowRight" || d != null && d(I)) return;
    B.preventDefault();
    const T = e.findIndex((ee) => ee.key === r(I)), P = T + (B.key === "ArrowLeft" ? -1 : 1);
    T >= 0 && P >= 0 && P < e.length && (N.current = { key: String(a(I)), until: Date.now() + 1500 }, l(I, e[P].key));
  };
  return /* @__PURE__ */ n.createElement("div", { ref: h, className: [Me.board, y].filter(Boolean).join(" "), style: _, role: "region", "aria-label": b != null ? b : "보드" }, e.map((B) => {
    const I = t.filter((T) => r(T) === B.key);
    return /* @__PURE__ */ n.createElement(
      "section",
      {
        key: B.key,
        className: [Me.col, k === B.key ? Me.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof B.title == "string" ? B.title : void 0,
        onDragOver: l ? (T) => {
          T.dataTransfer.types.includes(Wn) && (T.preventDefault(), w(B.key));
        } : void 0,
        onDragLeave: l ? (T) => {
          T.currentTarget.contains(T.relatedTarget) || w((P) => P === B.key ? null : P);
        } : void 0,
        onDrop: l ? (T) => D(T, B.key) : void 0
      },
      /* @__PURE__ */ n.createElement("header", { className: Me.head }, /* @__PURE__ */ n.createElement("span", { className: Me.title }, B.title), /* @__PURE__ */ n.createElement("span", { className: Me.count }, I.length), B.hint && /* @__PURE__ */ n.createElement("span", { className: Me.hint }, B.hint)),
      /* @__PURE__ */ n.createElement("div", { className: Me.list }, I.length === 0 && /* @__PURE__ */ n.createElement("p", { className: Me.empty }, p), I.map((T) => {
        const P = a(T), ee = d == null ? void 0 : d(T), F = u == null ? void 0 : u(T), L = !!l && !ee, ae = ee != null ? ee : L ? f != null ? f : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0;
        return /* @__PURE__ */ n.createElement(
          "article",
          {
            key: P,
            className: [Me.card, i === P ? Me.sel : "", x === P ? Me.dragging : "", F ? Me.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            "data-kanban-key": String(P),
            role: "button",
            "aria-label": s == null ? void 0 : s(T),
            "aria-keyshortcuts": L ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: ae,
            "aria-describedby": ae ? `${$}-h-${String(P)}` : void 0,
            draggable: L,
            onDragStart: L ? (te) => {
              te.dataTransfer.setData(Wn, String(P)), te.dataTransfer.effectAllowed = "move", E(P);
            } : void 0,
            onDragEnd: () => {
              E(null), w(null);
            },
            onClick: () => c == null ? void 0 : c(T),
            onKeyDown: (te) => j(te, T)
          },
          ae && /* @__PURE__ */ n.createElement(_r, { id: `${$}-h-${String(P)}` }, ae),
          (m == null ? void 0 : m(T)) && /* @__PURE__ */ n.createElement("span", { className: Me.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          o(T),
          F && /* @__PURE__ */ n.createElement("p", { className: Me.err, role: "alert" }, F)
        );
      }))
    );
  }));
}
const qh = "_list_1aqum_2", Ih = "_empty_1aqum_3", Rh = "_item_1aqum_5", Oh = "_row_block_1aqum_6", Ph = "_row_warn_1aqum_7", Xh = "_head_1aqum_9", zh = "_mark_1aqum_16", Fh = "_msg_1aqum_17", Wh = "_count_1aqum_18", Hh = "_aside_1aqum_19", Kh = "_caret_1aqum_20", Uh = "_block_1aqum_22", Yh = "_warn_1aqum_23", Gh = "_info_1aqum_24", Vh = "_body_1aqum_29", Jh = "_actions_1aqum_30", Te = {
  list: qh,
  empty: Ih,
  item: Rh,
  row_block: Oh,
  row_warn: Ph,
  head: Xh,
  mark: zh,
  msg: Fh,
  count: Wh,
  aside: Hh,
  caret: Kh,
  block: Uh,
  warn: Yh,
  info: Gh,
  body: Vh,
  actions: Jh
}, Qh = { block: "■", warn: "▲", info: "●" }, Zh = { block: "차단", warn: "경고", info: "정보" };
function W0({ items: e, empty: t = "점검할 항목이 없습니다", openTones: a = ["block"], className: r = "" }) {
  const [o, s] = S({}), [l, c] = S(e);
  return l !== e && (c(e), s({})), e.length ? /* @__PURE__ */ n.createElement("ul", { className: `${Te.list} ${r}` }, e.map((i) => {
    var p;
    const m = !!i.detail || !!i.actions, u = m && ((p = o[i.key]) != null ? p : a.includes(i.tone)), d = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${Te.mark} ${Te[i.tone]}`, "aria-label": Zh[i.tone], role: "img" }, Qh[i.tone]), /* @__PURE__ */ n.createElement("span", { className: Te.msg }, i.message), !!i.count && /* @__PURE__ */ n.createElement("span", { className: `${Te.count} ${Te[i.tone]}` }, i.count.toLocaleString("ko-KR"), "건"), i.aside != null && /* @__PURE__ */ n.createElement("span", { className: Te.aside }, i.aside), m && /* @__PURE__ */ n.createElement("span", { className: Te.caret, "aria-hidden": "true" }, u ? "▾" : "▸"));
    return /* @__PURE__ */ n.createElement("li", { key: i.key, className: `${Te.item} ${Te[`row_${i.tone}`]}` }, m ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Te.head,
        "aria-expanded": u,
        onClick: () => s((f) => ({ ...f, [i.key]: !u }))
      },
      d
    ) : /* @__PURE__ */ n.createElement("div", { className: Te.head }, d), u && /* @__PURE__ */ n.createElement("div", { className: Te.body }, i.detail, i.actions && /* @__PURE__ */ n.createElement("div", { className: Te.actions }, i.actions)));
  })) : /* @__PURE__ */ n.createElement("p", { className: `${Te.empty} ${r}` }, t);
}
function e1(e, t) {
  const a = Math.max(1, Math.floor(t) || 1), r = Math.min(a, Math.max(1, Math.floor(e) || 1)), o = (s, l) => Array.from({ length: l - s + 1 }, (c, i) => s + i);
  return a <= 10 ? o(1, a) : r <= 5 ? [...o(1, 7), "…", a] : r >= a - 4 ? [1, "…", ...o(a - 6, a)] : [1, "…", ...o(r - 2, r + 2), "…", a];
}
function t1(e, t) {
  const a = parseInt(e.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(a) ? Math.min(Math.max(1, t), Math.max(1, a)) : null;
}
function H0(e) {
  return e === "page" ? "쪽 합계" : "전체 합계";
}
function K0(e, t) {
  return Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, t)));
}
const n1 = "_nav_1r2z8_1", a1 = "_list_1r2z8_3", r1 = "_btn_1r2z8_4", o1 = "_cur_1r2z8_13", s1 = "_gap_1r2z8_15", l1 = "_total_1r2z8_16", c1 = "_jump_1r2z8_17", i1 = "_go_1r2z8_20", u1 = "_size_1r2z8_22", m1 = "_more_1r2z8_24", d1 = "_moreBtn_1r2z8_25", _1 = "_moreN_1r2z8_29", Ee = {
  nav: n1,
  list: a1,
  btn: r1,
  cur: o1,
  gap: s1,
  total: l1,
  jump: c1,
  in: "_in_1r2z8_18",
  go: i1,
  size: u1,
  more: m1,
  moreBtn: d1,
  moreN: _1
};
function U0({ page: e, pageCount: t, onPageChange: a, jump: r = !1, pageSizes: o, pageSize: s, onPageSizeChange: l, total: c, className: i = "" }) {
  const m = Math.max(1, t), u = Math.min(m, Math.max(1, e)), [d, p] = S(String(u));
  G(() => p(String(u)), [u]);
  const f = (_) => {
    _ !== u && _ >= 1 && _ <= m && a(_);
  }, y = () => {
    const _ = t1(d, m);
    if (_ === null) {
      p(String(u));
      return;
    }
    p(String(_)), f(_);
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [Ee.nav, i].filter(Boolean).join(" "), "aria-label": "페이지 이동" }, c !== void 0 && /* @__PURE__ */ n.createElement("span", { className: Ee.total }, "총 ", c.toLocaleString("ko-KR"), "건"), /* @__PURE__ */ n.createElement("ol", { className: Ee.list }, /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ee.btn, onClick: () => f(1), disabled: u === 1, "aria-label": "첫 쪽" }, "«")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ee.btn, onClick: () => f(u - 1), disabled: u === 1, "aria-label": "이전 쪽" }, "‹")), e1(u, m).map((_, b) => _ === "…" ? /* @__PURE__ */ n.createElement("li", { key: `e${b}`, className: Ee.gap, "aria-hidden": "true" }, "…") : /* @__PURE__ */ n.createElement("li", { key: _ }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Ee.btn, _ === u ? Ee.cur : ""].filter(Boolean).join(" "),
      onClick: () => f(_),
      "aria-current": _ === u ? "page" : void 0,
      "aria-label": `${_}쪽`
    },
    _
  ))), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ee.btn, onClick: () => f(u + 1), disabled: u === m, "aria-label": "다음 쪽" }, "›")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ee.btn, onClick: () => f(m), disabled: u === m, "aria-label": "마지막 쪽" }, "»"))), /* @__PURE__ */ n.createElement("span", { className: Ee.total }, "전체 ", m, "쪽"), r && /* @__PURE__ */ n.createElement("span", { className: Ee.jump }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: Ee.in,
      inputMode: "numeric",
      value: d,
      "aria-label": "이동할 쪽 번호",
      onChange: (_) => p(_.target.value.replace(/[^\d]/g, "")),
      onKeyDown: (_) => {
        _.key === "Enter" && (_.preventDefault(), y());
      }
    }
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: Ee.go, onClick: y }, "이동")), o && s !== void 0 && l && /* @__PURE__ */ n.createElement("label", { className: Ee.size }, "쪽당", /* @__PURE__ */ n.createElement("select", { value: s, onChange: (_) => l(Number(_.target.value)) }, o.map((_) => /* @__PURE__ */ n.createElement("option", { key: _, value: _ }, _, "건")))));
}
function Y0({ shown: e, total: t, onMore: a, busy: r = !1, className: o = "" }) {
  return e >= t ? null : /* @__PURE__ */ n.createElement("div", { className: [Ee.more, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ee.moreBtn, onClick: a, disabled: r, "aria-busy": r }, "더보기 ", /* @__PURE__ */ n.createElement("span", { className: Ee.moreN }, "(", e.toLocaleString("ko-KR"), "/", t.toLocaleString("ko-KR"), ")")));
}
const f1 = "_ol_fbatg_1", p1 = "_li_fbatg_2", y1 = "_done_fbatg_5", b1 = "_now_fbatg_5", h1 = "_item_fbatg_6", g1 = "_dot_fbatg_12", E1 = "_label_fbatg_19", v1 = "_opt_fbatg_21", k1 = "_sr_fbatg_22", lt = {
  ol: f1,
  li: p1,
  done: y1,
  now: b1,
  item: h1,
  dot: g1,
  label: E1,
  opt: v1,
  sr: k1
};
function G0({ steps: e, current: t, onStepClick: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("ol", { className: [lt.ol, r].filter(Boolean).join(" "), "aria-label": `${e.length}단계 중 ${Math.min(t + 1, e.length)}단계` }, e.map((o, s) => {
    const l = s < t ? "done" : s === t ? "now" : "todo", c = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: lt.dot, "aria-hidden": "true" }, l === "done" ? "✓" : s + 1), /* @__PURE__ */ n.createElement("span", { className: lt.label }, o.label, o.optional && /* @__PURE__ */ n.createElement("span", { className: lt.opt }, " (선택)"), l === "done" && /* @__PURE__ */ n.createElement("span", { className: lt.sr }, " 완료"))), i = !!a && s <= t;
    return /* @__PURE__ */ n.createElement("li", { key: o.key, className: [lt.li, lt[l]].join(" "), "aria-current": l === "now" ? "step" : void 0 }, i ? /* @__PURE__ */ n.createElement("button", { type: "button", className: lt.item, onClick: () => a(s, o) }, c) : /* @__PURE__ */ n.createElement("span", { className: lt.item }, c));
  }));
}
const w1 = "_root_7y5bc_5", N1 = "_block_7y5bc_6", $1 = "_svg_7y5bc_7", x1 = "_sm_7y5bc_8", D1 = "_md_7y5bc_9", C1 = "_lg_7y5bc_10", A1 = "_track_7y5bc_11", S1 = "_bar_7y5bc_12", M1 = "_spin_7y5bc_13", T1 = "_txt_7y5bc_15", bt = {
  root: w1,
  "axe-sp-in": "_axe-sp-in_7y5bc_1",
  block: N1,
  svg: $1,
  sm: x1,
  md: D1,
  lg: C1,
  track: A1,
  bar: S1,
  spin: M1,
  "axe-sp-rot": "_axe-sp-rot_7y5bc_1",
  txt: T1,
  "axe-sp-blink": "_axe-sp-blink_7y5bc_1"
};
function V0({ size: e = "md", value: t, label: a = "불러오는 중", delay: r = 300, block: o = !1, className: s = "" }) {
  const l = typeof t == "number", c = l ? Math.min(100, Math.max(0, t)) : 0, i = 15.9155;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [bt.root, o ? bt.block : "", s].filter(Boolean).join(" "),
      style: { "--sp-delay": `${r}ms` },
      role: "status",
      "aria-live": "polite",
      "aria-busy": "true"
    },
    /* @__PURE__ */ n.createElement("svg", { className: [bt.svg, bt[e], l ? "" : bt.spin].filter(Boolean).join(" "), viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ n.createElement("circle", { className: bt.track, cx: "18", cy: "18", r: i, fill: "none" }), /* @__PURE__ */ n.createElement(
      "circle",
      {
        className: bt.bar,
        cx: "18",
        cy: "18",
        r: i,
        fill: "none",
        strokeDasharray: l ? `${c} ${100 - c}` : "25 75",
        transform: "rotate(-90 18 18)"
      }
    )),
    /* @__PURE__ */ n.createElement("span", { className: bt.txt }, a, l ? ` ${Math.round(c)}%` : "")
  );
}
const B1 = "_group_xpsei_1", j1 = "_legend_xpsei_2", L1 = "_req_xpsei_3", q1 = "_opts_xpsei_4", I1 = "_inline_xpsei_5", R1 = "_all_xpsei_6", O1 = "_opt_xpsei_4", P1 = "_dis_xpsei_11", X1 = "_radio_xpsei_12", z1 = "_check_xpsei_12", F1 = "_text_xpsei_14", W1 = "_hint_xpsei_15", H1 = "_err_xpsei_16", pe = {
  group: B1,
  legend: j1,
  req: L1,
  opts: q1,
  inline: I1,
  all: R1,
  opt: O1,
  dis: P1,
  radio: X1,
  check: z1,
  text: F1,
  hint: W1,
  err: H1
};
function Tr({ legend: e, required: t }) {
  return /* @__PURE__ */ n.createElement("legend", { className: pe.legend }, e, t && /* @__PURE__ */ n.createElement("span", { className: pe.req }, " (필수)"));
}
function J0({ name: e, legend: t, options: a, value: r, onChange: o, required: s, disabled: l, error: c, inline: i = !1, className: m = "" }) {
  const u = Ut("axe-rg-err");
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [pe.group, m].filter(Boolean).join(" "),
      disabled: l,
      "aria-describedby": c ? u : void 0,
      "aria-invalid": c ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Tr, { legend: t, required: s }),
    /* @__PURE__ */ n.createElement("div", { className: [pe.opts, i ? pe.inline : ""].filter(Boolean).join(" "), role: "radiogroup" }, a.map((d) => /* @__PURE__ */ n.createElement("label", { key: d.value, className: [pe.opt, d.disabled ? pe.dis : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "radio",
        className: pe.radio,
        name: e,
        value: d.value,
        checked: r === d.value,
        disabled: d.disabled,
        required: s,
        onChange: () => o(d.value)
      }
    ), /* @__PURE__ */ n.createElement("span", { className: pe.text }, d.label, d.hint && /* @__PURE__ */ n.createElement("span", { className: pe.hint }, d.hint))))),
    c && /* @__PURE__ */ n.createElement("p", { id: u, className: pe.err }, c)
  );
}
function Ka({ checked: e, indeterminate: t = !1, onChange: a, disabled: r, children: o, className: s = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [pe.opt, r ? pe.dis : "", s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "checkbox",
      className: pe.check,
      checked: e,
      disabled: r,
      ref: (l) => {
        l && (l.indeterminate = t && !e);
      },
      onChange: (l) => a(l.target.checked)
    }
  ), o !== void 0 && /* @__PURE__ */ n.createElement("span", { className: pe.text }, o));
}
function Q0({ legend: e, options: t, value: a, onChange: r, required: o, disabled: s, error: l, inline: c = !1, selectAll: i, className: m = "" }) {
  const u = Ut("axe-cg-err"), d = t.filter((_) => !_.disabled).map((_) => _.value), p = d.length > 0 && d.every((_) => a.includes(_)), f = d.some((_) => a.includes(_)), y = (_, b) => r(b ? [...a, _] : a.filter(($) => $ !== _));
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [pe.group, m].filter(Boolean).join(" "),
      disabled: s,
      "aria-describedby": l ? u : void 0,
      "aria-invalid": l ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Tr, { legend: e, required: o }),
    i && /* @__PURE__ */ n.createElement("div", { className: pe.all }, /* @__PURE__ */ n.createElement(
      Ka,
      {
        checked: p,
        indeterminate: f && !p,
        onChange: (_) => r(_ ? Array.from(/* @__PURE__ */ new Set([...a, ...d])) : a.filter((b) => !d.includes(b)))
      },
      i
    )),
    /* @__PURE__ */ n.createElement("div", { className: [pe.opts, c ? pe.inline : ""].filter(Boolean).join(" ") }, t.map((_) => /* @__PURE__ */ n.createElement(Ka, { key: _.value, checked: a.includes(_.value), disabled: _.disabled, onChange: (b) => y(_.value, b) }, _.label, _.hint && /* @__PURE__ */ n.createElement("span", { className: pe.hint }, _.hint)))),
    l && /* @__PURE__ */ n.createElement("p", { id: u, className: pe.err }, l)
  );
}
const K1 = "_list_13vw7_1", U1 = "_tag_13vw7_2", Y1 = "_main_13vw7_3", G1 = "_x_13vw7_6", V1 = "_t_muted_13vw7_10", J1 = "_t_accent_13vw7_11", Q1 = "_t_ok_13vw7_12", Z1 = "_t_warn_13vw7_13", eg = "_t_danger_13vw7_14", tg = "_sel_13vw7_16", xt = {
  list: K1,
  tag: U1,
  main: Y1,
  x: G1,
  t_muted: V1,
  t_accent: J1,
  t_ok: Q1,
  t_warn: Z1,
  t_danger: eg,
  sel: tg
};
function Z0({ children: e, tone: t = "muted", selected: a, onClick: r, onRemove: o, removeLabel: s, disabled: l, className: c = "" }) {
  const i = [xt.tag, xt[`t_${t}`], a ? xt.sel : "", c].filter(Boolean).join(" "), m = s != null ? s : typeof e == "string" ? `${e} 삭제` : "태그 삭제";
  return /* @__PURE__ */ n.createElement("span", { className: i }, r ? /* @__PURE__ */ n.createElement("button", { type: "button", className: xt.main, onClick: r, disabled: l, "aria-pressed": a }, a && /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "✓ "), e) : /* @__PURE__ */ n.createElement("span", { className: xt.main }, e), o && /* @__PURE__ */ n.createElement("button", { type: "button", className: xt.x, onClick: o, disabled: l, "aria-label": m }, "✕"));
}
function ev({ label: e, children: t, className: a = "" }) {
  return /* @__PURE__ */ n.createElement("ul", { className: [xt.list, a].filter(Boolean).join(" "), "aria-label": e }, (Array.isArray(t) ? t : [t]).filter(Boolean).map((r, o) => /* @__PURE__ */ n.createElement("li", { key: o }, r)));
}
const ng = "_acc_1lmty_1", ag = "_item_1lmty_2", rg = "_h_1lmty_3", og = "_btn_1lmty_4", sg = "_title_1lmty_8", lg = "_meta_1lmty_9", cg = "_chev_1lmty_10", ig = "_open_1lmty_11", ug = "_body_1lmty_12", ct = {
  acc: ng,
  item: ag,
  h: rg,
  btn: og,
  title: sg,
  meta: lg,
  chev: cg,
  open: ig,
  body: ug
};
function tv({ items: e, single: t = !1, defaultOpen: a = [], openKeys: r, onOpenChange: o, headingLevel: s = 3, className: l = "" }) {
  const [c, i] = S(a), m = r != null ? r : c, u = Ut("axe-acc"), d = `h${s}`, p = (f) => {
    const y = m.includes(f) ? m.filter((_) => _ !== f) : t ? [f] : [...m, f];
    r === void 0 && i(y), o == null || o(y);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ct.acc, l].filter(Boolean).join(" ") }, e.map((f) => {
    const y = m.includes(f.key), _ = `${u}-b-${f.key}`, b = `${u}-p-${f.key}`;
    return /* @__PURE__ */ n.createElement("div", { key: f.key, className: [ct.item, y ? ct.open : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(d, { className: ct.h }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        id: _,
        className: ct.btn,
        "aria-expanded": y,
        "aria-controls": b,
        disabled: f.disabled,
        onClick: () => p(f.key)
      },
      /* @__PURE__ */ n.createElement("span", { className: ct.title }, f.title),
      f.meta && /* @__PURE__ */ n.createElement("span", { className: ct.meta }, f.meta),
      /* @__PURE__ */ n.createElement("span", { className: ct.chev, "aria-hidden": "true" }, "▾")
    )), /* @__PURE__ */ n.createElement("div", { id: b, role: "region", "aria-labelledby": _, hidden: !y, className: ct.body }, f.content));
  }));
}
const mg = "_stack_1u83j_2", dg = "_toast_1u83j_3", _g = "_t_danger_1u83j_9", fg = "_ico_1u83j_10", pg = "_t_ok_1u83j_11", yg = "_msg_1u83j_12", bg = "_act_1u83j_13", hg = "_x_1u83j_15", Dt = {
  stack: mg,
  toast: dg,
  "axe-toast-in": "_axe-toast-in_1u83j_1",
  t_danger: _g,
  ico: fg,
  t_ok: pg,
  msg: yg,
  act: bg,
  x: hg
}, Br = Dn(null);
let gg = 0;
function nv() {
  const e = xn(Br);
  if (!e) throw new Error("useAXErpToast 는 AXErpToastProvider 안에서만 쓴다");
  return e;
}
function Eg({ item: e, onClose: t }) {
  var l, c;
  const [a, r] = S(!1), o = (l = e.duration) != null ? l : e.action ? 8e3 : 4e3;
  G(() => {
    if (a || o === 0) return;
    const i = window.setTimeout(t, o);
    return () => window.clearTimeout(i);
  }, [a, o, t, e.message]);
  const s = (c = e.tone) != null ? c : "info";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [Dt.toast, Dt[`t_${s}`]].join(" "),
      role: s === "danger" ? "alert" : void 0,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      onFocus: () => r(!0),
      onBlur: () => r(!1)
    },
    /* @__PURE__ */ n.createElement("span", { className: Dt.ico, "aria-hidden": "true" }, s === "ok" ? "✓" : s === "danger" ? "▲" : "ⓘ"),
    /* @__PURE__ */ n.createElement("span", { className: Dt.msg }, e.message),
    e.action && /* @__PURE__ */ n.createElement("button", { type: "button", className: Dt.act, onClick: () => {
      e.action.onAction(), t();
    } }, e.action.label),
    /* @__PURE__ */ n.createElement("button", { type: "button", className: Dt.x, onClick: t, "aria-label": "알림 닫기" }, "✕")
  );
}
function av({ children: e }) {
  const [t, a] = S([]), r = q(t);
  r.current = t;
  const o = le((c) => a((i) => i.filter((m) => m.id !== c)), []), s = le((c) => {
    const i = typeof c == "string" ? { message: c } : c, m = r.current.find((d) => d.message === i.message);
    if (m)
      return a((d) => d.map((p) => p.id === m.id ? { ...p, ...i } : p)), m.id;
    const u = ++gg;
    return a((d) => [...d, { ...i, id: u }].slice(-3)), u;
  }, []), l = we(() => ({ toast: s, dismiss: o }), [s, o]);
  return /* @__PURE__ */ n.createElement(Br.Provider, { value: l }, e, /* @__PURE__ */ n.createElement("div", { className: Dt.stack, role: "status", "aria-live": "polite", "aria-atomic": "false" }, t.map((c) => /* @__PURE__ */ n.createElement(Eg, { key: c.id, item: c, onClose: () => o(c.id) }))));
}
const vg = [
  {
    title: "공통",
    items: [
      { keys: ["?"], text: "단축키 도움말 열기 (입력 칸 밖에서)" },
      { keys: ["Tab", "Shift+Tab"], text: "다음·이전 입력 칸 / 버튼으로 이동" },
      { keys: ["Esc"], text: "열린 달력·메뉴·대화상자 닫기, 입력 중이던 값 취소" },
      { keys: ["Ctrl+Enter"], text: "저장 (저장 버튼 옆에 표기된 화면)" }
    ]
  },
  {
    title: "날짜 입력 칸",
    items: [
      { keys: ["숫자만"], text: "20260930 · 260930 · 0930 처럼 구분 기호 없이 입력" },
      { keys: ["↑", "↓"], text: "하루 뒤·앞 (월 입력은 한 달)" },
      { keys: ["PageUp", "PageDown"], text: "한 달 앞·뒤 (월 입력은 한 해)" },
      { keys: ["T"], text: "오늘" },
      { keys: ["F2", "F4", "Alt+↓"], text: "달력 열기" }
    ]
  },
  {
    title: "코드 입력 칸",
    items: [
      { keys: ["코드·명칭 입력"], text: "입력하는 동안 후보 표시" },
      { keys: ["↑", "↓"], text: "후보 선택" },
      { keys: ["Enter"], text: "선택한 후보 확정" },
      { keys: ["F2"], text: "전체 검색 창 열기" }
    ]
  },
  {
    title: "표 (행·칸 이동)",
    items: [
      { keys: ["←", "→", "↑", "↓"], text: "칸 이동" },
      { keys: ["Home", "End"], text: "줄의 처음·끝 칸" },
      { keys: ["Ctrl+Home", "Ctrl+End"], text: "표의 처음·끝 칸" },
      { keys: ["Enter", "Space"], text: "행 열기 (행 클릭이 되는 표)" }
    ]
  },
  {
    title: "달력 (달력에 포커스가 있을 때)",
    items: [
      { keys: ["T"], text: "오늘로" },
      { keys: ["N", "PageDown"], text: "다음 기간" },
      { keys: ["P", "PageUp"], text: "이전 기간" },
      { keys: ["M", "W", "D", "A"], text: "월 · 주 · 일 · 목록 보기" },
      { keys: ["C"], text: "새 일정 만들기" }
    ]
  },
  {
    title: "간트 · 칸반 (막대·카드에 포커스)",
    items: [
      { keys: ["←", "→"], text: "간트: 막대 옮기기" },
      { keys: ["Shift+←", "Shift+→"], text: "간트: 끝 날짜 조절" },
      { keys: ["Alt+←", "Alt+→"], text: "간트: 시작 날짜 조절 / 칸반: 옆 열로 옮기기" },
      { keys: ["Enter"], text: "열기" }
    ]
  },
  {
    title: "메뉴",
    items: [
      { keys: ["↓"], text: "메뉴 열기 · 다음 항목" },
      { keys: ["↑", "Home", "End"], text: "이전 · 처음 · 마지막 항목" },
      { keys: ["Esc"], text: "닫고 버튼으로 돌아가기" }
    ]
  }
];
function kg(e, t, a) {
  return a || t.ctrl || t.alt || t.meta ? !1 : e === "?";
}
const wg = "_grid_yplhe_1", Ng = "_group_yplhe_2", $g = "_h_yplhe_3", xg = "_list_yplhe_4", Dg = "_row_yplhe_5", Cg = "_keys_yplhe_6", Ag = "_text_yplhe_7", Sg = "_or_yplhe_8", Mg = "_kbd_yplhe_9", it = {
  grid: wg,
  group: Ng,
  h: $g,
  list: xg,
  row: Dg,
  keys: Cg,
  text: Ag,
  or: Sg,
  kbd: Mg
};
function Tg({ onClose: e, extra: t }) {
  const a = [...t != null ? t : [], ...vg];
  return /* @__PURE__ */ n.createElement(ca, { title: "단축키", onClose: e, closeOnEsc: !0, confirmDiscard: !1, wide: !0 }, /* @__PURE__ */ n.createElement("div", { className: it.grid }, a.map((r) => /* @__PURE__ */ n.createElement("section", { key: r.title, className: it.group }, /* @__PURE__ */ n.createElement("h3", { className: it.h }, r.title), /* @__PURE__ */ n.createElement("dl", { className: it.list }, r.items.map((o, s) => /* @__PURE__ */ n.createElement("div", { key: s, className: it.row }, /* @__PURE__ */ n.createElement("dt", { className: it.keys }, o.keys.map((l, c) => /* @__PURE__ */ n.createElement("span", { key: l }, c > 0 && /* @__PURE__ */ n.createElement("span", { className: it.or }, " 또는 "), /* @__PURE__ */ n.createElement("kbd", { className: it.kbd }, l)))), /* @__PURE__ */ n.createElement("dd", { className: it.text }, o.text))))))));
}
function Bg(e) {
  const t = e;
  return !t || typeof t.closest != "function" ? !1 : !!t.closest('input, textarea, select, [contenteditable="true"], [role="combobox"], [role="textbox"]');
}
function rv(e = {}) {
  const { enabled: t = !0, extra: a } = e, [r, o] = S(!1);
  return G(() => {
    if (!t) return;
    const s = (l) => {
      kg(l.key, { ctrl: l.ctrlKey, alt: l.altKey, meta: l.metaKey }, Bg(l.target)) && (document.querySelector('[role="dialog"][aria-modal="true"]') || (l.preventDefault(), o(!0)));
    };
    return document.addEventListener("keydown", s), () => document.removeEventListener("keydown", s);
  }, [t]), { open: () => o(!0), dialog: r ? /* @__PURE__ */ n.createElement(Tg, { extra: a, onClose: () => o(!1) }) : null };
}
const Ua = 30, jg = BigInt(10);
function Ht(e) {
  let t = BigInt(1);
  for (let a = 0; a < e; a += 1) t = t * jg;
  return t;
}
function dt(e, t = 0) {
  return { u: e, s: t };
}
const jr = dt(BigInt(0));
function Lr(e, t) {
  if (e.s === t.s) return [e.u, t.u, e.s];
  const a = Math.max(e.s, t.s);
  return [e.u * Ht(a - e.s), t.u * Ht(a - t.s), a];
}
function cn(e, t) {
  const [a, r, o] = Lr(e, t);
  return dt(a + r, o);
}
function ia(e, t) {
  const [a, r, o] = Lr(e, t);
  return dt(a - r, o);
}
function tt(e, t) {
  return dt(e.u * t.u, e.s + t.s);
}
function Tt(e, t) {
  if (t.u === BigInt(0)) return null;
  const a = e.u * Ht(t.s + Ua), r = t.u * Ht(e.s);
  return dt(a / r, Ua);
}
function qr(e) {
  return dt(-e.u, e.s);
}
function _t(e, t, a) {
  if (t >= e.s)
    return dt(e.u * Ht(t - e.s), t);
  const r = Ht(e.s - t), o = e.u < BigInt(0), s = o ? -e.u : e.u, l = s / r, c = s % r;
  let i;
  return c === BigInt(0) || a === "down" ? i = l : a === "up" ? i = l + BigInt(1) : i = c * BigInt(2) >= r ? l + BigInt(1) : l, dt(o ? -i : i, t);
}
function he(e) {
  const t = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const a = t.startsWith("-"), r = t.replace(/^[+-]/, ""), o = r.indexOf("."), s = o < 0 ? r : r.slice(0, o) + r.slice(o + 1), l = o < 0 ? 0 : r.length - o - 1, c = BigInt(s === "" ? "0" : s);
  return dt(a ? -c : c, l);
}
function ua(e) {
  var a;
  const t = he(String(e));
  return t || ((a = he(e.toFixed(20))) != null ? a : jr);
}
function Ye(e, t = e.s, a = !1) {
  const r = _t(e, Math.max(t, 0), "half"), o = r.u < BigInt(0), s = (o ? -r.u : r.u).toString().padStart(t + 1, "0"), l = s.length - t;
  let c = s.slice(0, l);
  const i = s.slice(l);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (o ? "-" : "") + c + (t > 0 ? "." + i : "");
}
function Zn(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!t) return null;
  const a = Number(t[1]), r = Number(t[2]), o = Number(t[3]);
  return r < 1 || r > 12 || o < 1 || o > Le(a, r) ? null : { y: a, m: r, d: o };
}
function Xt({ y: e, m: t, d: a }) {
  const r = Math.floor((14 - t) / 12), o = e + 4800 - r, s = t + 12 * r - 3;
  return a + Math.floor((153 * s + 2) / 5) + 365 * o + Math.floor(o / 4) - Math.floor(o / 100) + Math.floor(o / 400) - 32045;
}
function Ir(e, t) {
  const a = Xt(e) + t + 32044, r = Math.floor((4 * a + 3) / 146097), o = a - Math.floor(146097 * r / 4), s = Math.floor((4 * o + 3) / 1461), l = o - Math.floor(1461 * s / 4), c = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * r + s - 4800 + Math.floor(c / 10)
  };
}
function Rr(e, t, a = "exclude-first") {
  const r = Xt(e) > Xt(t), o = r ? t : e, s = r ? e : t, l = a === "include-first", c = Xt(s) - Xt(o) + (l ? 1 : 0), i = l ? Ir(s, 1) : s;
  let m = i.y - o.y, u = i.m - o.m, d = i.d - o.d;
  if (d < 0) {
    u -= 1;
    const p = i.m === 1 ? 12 : i.m - 1, f = i.m === 1 ? i.y - 1 : i.y;
    d += Le(f, p);
  }
  return u < 0 && (m -= 1, u += 12), { days: c, y: m, m: u, d, swapped: r };
}
function $n(e, t) {
  return Ir(e, t);
}
function Ya(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), o = a % 12 + 1;
  return { y: r, m: o, d: Math.min(e.d, Le(r, o)) };
}
const Lg = ["월", "화", "수", "목", "금", "토", "일"];
function ea(e) {
  return Lg[Xt(e) % 7];
}
function Fe(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const en = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], Hn = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function Ga(e) {
  var t;
  return (t = Hn[e]) != null ? t : e in Hn ? Hn[e] : null;
}
function ta(e, t) {
  return e.find((a) => a.code === t);
}
function Or(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function Pr(e, t, a, r) {
  const o = ta(e, a), s = ta(e, r);
  if (!o || !s) return null;
  const l = he(o.krw), c = he(s.krw), i = he(String(o.per)), m = he(String(s.per));
  if (!l || !c || !i || !m) return null;
  const u = Tt(tt(t, l), i);
  if (!u) return null;
  const d = Tt(tt(u, m), c);
  return d ? {
    value: _t(d, 2, "half"),
    notice: `${Or(o)} · 샘플 고시(원천 미결)`
  } : null;
}
function qg(e, t) {
  let a = null;
  for (const o of e)
    if (o.value) {
      if (a === null) {
        a = o.sign === "-" ? qr(o.value) : o.value;
        continue;
      }
      switch (o.sign) {
        case "+":
          a = cn(a, o.value);
          break;
        case "-":
          a = ia(a, o.value);
          break;
        case "*":
          a = tt(a, o.value);
          break;
        default: {
          const s = Tt(a, o.value);
          if (!s) return { ok: !1, error: "divide-by-zero" };
          a = s;
          break;
        }
      }
    }
  const r = a != null ? a : jr;
  return { ok: !0, value: t ? _t(r, t.digits, t.mode) : r };
}
const Va = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function an() {
  return { sign: "+", text: "" };
}
function Ig(e) {
  const t = e.replace(/[^\d.-]/g, ""), a = t.startsWith("-"), r = t.replace(/-/g, ""), o = r.indexOf("."), s = o < 0 ? r : r.slice(0, o), l = o < 0 ? "" : "." + r.slice(o + 1).replace(/\./g, "");
  return (a ? "-" : "") + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function Rg(e) {
  return e.map((t) => ({ sign: t.sign, value: he(t.text) }));
}
function Og(e) {
  const { lines: t, onLines: a, active: r, onActive: o, digits: s, onDigits: l, mode: c, onMode: i } = e, m = q([]), u = Math.min(r, t.length - 1);
  G(() => {
    var w;
    (w = m.current[u]) == null || w.focus();
  }, [u, t.length]);
  const d = qg(Rg(t), { digits: s, mode: c }), p = d.ok ? Ye(d.value, s, !0) : "0으로 나눌 수 없음", f = (w, x) => {
    a(t.map((E, g) => g === w ? { ...E, ...x } : E));
  }, y = (w = t.length, x = "") => {
    const E = [...t];
    E.splice(w, 0, { ...an(), text: x }), a(E), o(w);
  }, _ = (w) => {
    if (t.length === 1) {
      a([an()]);
      return;
    }
    a(t.filter((x, E) => E !== w)), o(Math.max(0, w - 1));
  }, b = () => {
    d.ok && y(t.length, Ye(d.value, s, !0));
  }, $ = (w, x) => {
    const E = w.key, g = Pg(E);
    if (g && !(E === "-" && t[x].text === "")) {
      w.preventDefault(), f(x, { sign: g });
      return;
    }
    if (E === "v" || E === "V") {
      w.preventDefault(), b();
      return;
    }
    E === "Enter" ? (w.preventDefault(), x === t.length - 1 ? y() : o(x + 1)) : E === "ArrowDown" ? (w.preventDefault(), o(Math.min(x + 1, t.length - 1))) : E === "ArrowUp" ? (w.preventDefault(), o(Math.max(x - 1, 0))) : E === "Insert" ? (w.preventDefault(), y(x + 1)) : E === "Delete" && t[x].text === "" ? (w.preventDefault(), _(x)) : E === "F4" && (w.preventDefault(), k());
  }, k = () => {
    a([an()]), o(0);
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-general" }, /* @__PURE__ */ n.createElement("div", { className: "bical-side" }, /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => y(u + 1) }, "라인추가 (Ins)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => _(u) }, "라인삭제 (Del)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: b }, "현재금액추가 (V)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: k }, "초기화 (F4)")), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, Va.map((w) => {
    var x;
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: w.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((x = t[u]) == null ? void 0 : x.sign) === w.key,
        onClick: () => f(u, { sign: w.key })
      },
      w.label,
      " (",
      w.hot,
      ")"
    );
  })), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "결과값 자리수", className: "bical-select", value: s, onChange: (w) => l(Number(w.target.value)) }, [0, 1, 2, 3, 4].map((w) => /* @__PURE__ */ n.createElement("option", { key: w, value: w }, w))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기방법", className: "bical-select", value: c, onChange: (w) => i(w.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ n.createElement("div", { className: "bical-grid" }, t.map((w, x) => {
    var E;
    return /* @__PURE__ */ n.createElement("div", { key: x, className: `bical-line${x === u ? " bical-line--active" : ""}` }, /* @__PURE__ */ n.createElement("span", { className: "bical-caret" }, x === u ? "❯" : ""), /* @__PURE__ */ n.createElement("span", { className: "bical-sign" }, (E = Va.find((g) => g.key === w.sign)) == null ? void 0 : E.label), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: (g) => {
          m.current[x] = g;
        },
        value: w.text,
        inputMode: "decimal",
        "aria-label": `${x + 1}번째 금액`,
        onFocus: () => o(x),
        onChange: (g) => f(x, { text: Ig(g.target.value) }),
        onKeyDown: (g) => $(g, x)
      }
    ));
  })), /* @__PURE__ */ n.createElement("div", { className: `bical-result${d.ok ? "" : " bical-error"}` }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, p))));
}
function Pg(e) {
  const t = e.toLowerCase();
  return t === "a" || e === "+" ? "+" : t === "s" || e === "-" ? "-" : t === "d" || e === "*" ? "*" : t === "f" || e === "/" ? "/" : null;
}
function Xg(e) {
  const t = [];
  let a = 0;
  for (; a < e.length; ) {
    const r = e[a];
    if (r === " " || r === "	" || r === `
`)
      a += 1;
    else if (r >= "0" && r <= "9" || r === "." || r === ",") {
      let o = a;
      for (; o < e.length && (e[o] >= "0" && e[o] <= "9" || e[o] === "." || e[o] === ","); ) o += 1;
      const s = he(e.slice(a, o));
      if (!s) return null;
      t.push({ t: "num", v: s }), a = o;
    } else if (r === "+" || r === "-" || r === "*" || r === "/")
      t.push({ t: "op", v: r }), a += 1;
    else if (r === "(")
      t.push({ t: "(" }), a += 1;
    else if (r === ")")
      t.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return t;
}
class zg {
  constructor(t) {
    this.tokens = t, this.at = 0;
  }
  parse() {
    const t = this.expr();
    return t.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : t;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let t = this.term();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return t;
      this.at += 1;
      const r = this.term();
      if (!r.ok) return r;
      t = { ok: !0, value: a.v === "+" ? cn(t.value, r.value) : ia(t.value, r.value) };
    }
  }
  term() {
    let t = this.unary();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return t;
      this.at += 1;
      const r = this.unary();
      if (!r.ok) return r;
      if (a.v === "*")
        t = { ok: !0, value: tt(t.value, r.value) };
      else {
        const o = Tt(t.value, r.value);
        if (!o) return { ok: !1, error: "divide-by-zero" };
        t = { ok: !0, value: o };
      }
    }
  }
  unary() {
    const t = this.peek();
    if (t && t.t === "op" && (t.v === "+" || t.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: t.v === "-" ? qr(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const t = this.peek();
    if (!t) return { ok: !1, error: "syntax" };
    if (t.t === "num")
      return this.at += 1, { ok: !0, value: t.v };
    if (t.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const r = this.peek();
      return !r || r.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function Fg(e) {
  const t = Xg(e);
  return !t || t.length === 0 ? { ok: !1, error: "syntax" } : new zg(t).parse();
}
const rn = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (샘플 고시)"
], Wg = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function Hg(e, t) {
  return e.replace(/오늘/g, Fe(t)).replace(/내일/g, Fe($n(t, 1))).replace(/어제/g, Fe($n(t, -1)));
}
function Kg(e) {
  const t = [];
  for (const a of e.matchAll(Wg)) {
    const r = Zn(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    r && t.push(r);
  }
  return t;
}
const Ug = /부터|까지|에서|일수|며칠|기간|차이|~/;
function Yg(e, t) {
  if (t.length < 2 || !Ug.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), r = Rr(t[0], t[1], a ? "include-first" : "exclude-first"), o = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${Fe(t[0])} ~ ${Fe(t[1])} 기간(${o})` + (r.swapped ? " · 역순 입력" : ""),
    value: `${r.days}일 (${r.y}년 ${r.m}개월 ${r.d}일)`
  };
}
const Gg = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function Vg(e, t) {
  if (t.length !== 1) return null;
  const a = Gg.exec(e);
  if (!a) return null;
  const r = Number(a[1]), o = a[3] === "전" || a[3] === "이전", s = o ? -r : r, l = t[0];
  let c;
  return a[2] === "일" ? c = $n(l, s) : a[2] === "주" ? c = $n(l, s * 7) : a[2] === "년" ? c = Ya(l, s * 12) : c = Ya(l, s), {
    ok: !0,
    explain: `${Fe(l)} 에서 ${r}${a[2]} ${o ? "전" : "후"}`,
    value: `${Fe(c)} (${ea(c)})`
  };
}
function Jg(e, t) {
  if (t.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const r = a[2] ? Xr(a[2]) : null, o = he(a[1]);
  if (!o) return null;
  const s = r ? tt(o, r) : o, l = Ga(a[3]);
  if (!l) return null;
  const i = l !== "KRW" ? "KRW" : Ga(Qg(e));
  if (!i || i === l) return null;
  const m = Pr(t, s, l, i);
  return m ? {
    ok: !0,
    explain: `${Ye(s, s.s, !0)} ${l} → ${i} · ${m.notice}`,
    value: `${Ye(m.value, 2, !0)} ${i}`
  } : null;
}
function Qg(e) {
  const t = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return t ? t[1] : "원";
}
const Zg = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function Xr(e) {
  var t;
  return (t = he(Zg[e])) != null ? t : ua(1);
}
const eE = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, tE = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function nE(e) {
  return e.replace(eE, (t) => {
    let a = he("0"), r = !1;
    for (const o of t.matchAll(tE)) {
      const s = he(o[1]);
      s && (r = !0, a = cn(a, o[2] ? tt(s, Xr(o[2])) : s));
    }
    return r ? Ye(a, a.s) : t;
  });
}
const aE = /원화|원|엔|씩|개월|개|명|건/g;
function rE(e) {
  return nE(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(aE, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const oE = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function sE(e, t, a) {
  const r = he("1"), o = Ye(tt(t, ua(100)), 0);
  if (a === "add")
    return {
      value: _t(tt(e, cn(r, t)), 0, "half"),
      explain: `消費税 ${o}% 가산(税抜 기준)`
    };
  const s = Tt(tt(e, t), cn(r, t));
  return {
    value: s ? _t(s, 0, "down") : e,
    explain: `消費税 ${o}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function lE(e, t) {
  var i;
  const a = e.trim();
  if (!a) return { ok: !1, supported: rn };
  const r = Hg(a, t.today), o = Kg(r), s = Yg(r, o);
  if (s) return s;
  const l = Vg(r, o);
  if (l) return l;
  const c = Jg(r, (i = t.rates) != null ? i : []);
  return c || cE(r, t);
}
function cE(e, t) {
  var m, u;
  const a = oE.exec(e), r = a ? e.slice(0, a.index) : e, o = rE(r);
  if (!o) return { ok: !1, supported: rn };
  const s = Fg(o);
  if (!s.ok)
    return { ok: !1, supported: rn };
  if (!a)
    return { ok: !0, explain: o, value: Ja(s.value), expr: o };
  const l = (u = (m = iE(a[2])) != null ? m : t.taxRate) != null ? u : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세율(a_fa_param)을 읽어 오면 계산합니다", ...rn]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = sE(s.value, l, c);
  return {
    ok: !0,
    explain: `${o} · ${i.explain}`,
    value: Ja(i.value),
    expr: o
  };
}
function iE(e) {
  var a;
  if (!e) return null;
  const t = he(e);
  return t && (a = Tt(t, ua(100))) != null ? a : null;
}
function Ja(e) {
  const t = _t(e, 2, "half"), a = _t(t, 0, "down");
  return ia(t, a).u === BigInt(0) ? Ye(t, 0, !0) : Ye(t, 2, !0);
}
const Ue = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function Qa(e, t) {
  const a = Ue[e].units.find((o) => o.key === t);
  if (!a) return null;
  const r = he(a.factor);
  if (!r) throw new Error(`단위 환산표가 깨졌습니다 — ${a.key}`);
  return r;
}
function uE(e, t, a, r, o = 4, s = "half") {
  const l = Qa(e, t), c = Qa(e, a);
  if (!l || !c) return null;
  const i = Tt(tt(r, l), c);
  return i ? _t(i, o, s) : null;
}
const mE = [0, 1, 2, 3, 4, 6], dE = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function _E(e) {
  const { tab: t, onTab: a, seed: r, onClose: o, history: s, onHistory: l } = e, [c, i] = S(() => r == null ? [an()] : [{ sign: "+", text: Ye(EE(r), 0, !0) }]), [m, u] = S(0), [d, p] = S(0), [f, y] = S("half"), _ = q(null);
  G(() => {
    const $ = (k) => {
      k.key === "Escape" && (k.preventDefault(), o());
    };
    return document.addEventListener("keydown", $), () => document.removeEventListener("keydown", $);
  }, [o]), G(() => {
    var $, k;
    (k = ($ = _.current) == null ? void 0 : $.querySelector("[data-autofocus]")) == null || k.focus();
  }, [t]);
  const b = ($) => {
    const k = [...c.filter((w) => w.text !== ""), { sign: "+", text: $ }, an()];
    i(k), u(k.length - 1), a("general");
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ n.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: _ }, /* @__PURE__ */ n.createElement("div", { className: "bical-head" }, /* @__PURE__ */ n.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ n.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: o }, "✕")), /* @__PURE__ */ n.createElement("div", { className: "bical-tabs", role: "tablist" }, dE.map(($) => /* @__PURE__ */ n.createElement(
    "button",
    {
      key: $.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": $.key === t,
      onClick: () => a($.key)
    },
    $.label
  ))), /* @__PURE__ */ n.createElement("div", { className: "bical-body" }, t === "text" && /* @__PURE__ */ n.createElement(yE, { history: s, onHistory: l, onPush: b }), t === "general" && /* @__PURE__ */ n.createElement(
    Og,
    {
      lines: c,
      onLines: i,
      active: m,
      onActive: u,
      digits: d,
      onDigits: p,
      mode: f,
      onMode: y
    }
  ), t === "date" && /* @__PURE__ */ n.createElement(bE, null), t === "unit" && /* @__PURE__ */ n.createElement(hE, null), t === "fx" && /* @__PURE__ */ n.createElement(gE, null)), /* @__PURE__ */ n.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: o }, "닫기"))));
}
const fE = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], pE = 20;
function yE({ history: e, onHistory: t, onPush: a }) {
  var y;
  const [r, o] = S(""), [s, l] = S(null), [c, i] = S(!1), [m, u] = S(!1), d = q(!1), p = we(ma, []), f = (_) => {
    o(_), u(!1);
    const b = lE(_, { today: p, rates: en, taxRate: null });
    l(b), _.trim() && t([_, ...e.filter(($) => $ !== _)].slice(0, pE));
  };
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "aria-label": "계산할 문장",
      "data-autofocus": !0,
      value: r,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (_) => o(_.target.value),
      onCompositionStart: () => {
        d.current = !0;
      },
      onCompositionEnd: () => {
        d.current = !1;
      },
      onKeyDown: (_) => {
        _.key === "Enter" && !_.shiftKey && !d.current && !_.nativeEvent.isComposing && (_.preventDefault(), f(r));
      }
    }
  ), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, fE.map((_) => /* @__PURE__ */ n.createElement("button", { key: _, type: "button", className: "bical-chip", onClick: () => f(_) }, _))), s && (s.ok ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, s.explain), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, s.value), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var _;
        (_ = navigator.clipboard) == null || _.writeText(s.value).then(
          () => u(!0),
          () => u(!1)
        );
      }
    },
    m ? "복사함" : "결과복사"
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(s.value) }, "일반계산에 추가"))) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ n.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((y = s.supported) != null ? y : rn).map((_) => /* @__PURE__ */ n.createElement("li", { key: _ }, _))))), e.length > 0 && /* @__PURE__ */ n.createElement("div", { className: "bical-log" }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => i((_) => !_) }, "기록 ", e.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ n.createElement("ol", null, e.map((_) => /* @__PURE__ */ n.createElement("li", { key: _ }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => f(_) }, _))))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function bE() {
  const e = we(ma, []), [t, a] = S(Fe(e)), [r, o] = S(Fe(e)), [s, l] = S("exclude-first"), c = Zn(t), i = Zn(r), m = c && i ? Rr(c, i, s) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ n.createElement("select", { "aria-label": "계산 방식", className: "bical-select", value: s, onChange: (u) => l(u.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ n.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ n.createElement("input", { "aria-label": "시작일", className: "bical-input", type: "date", "data-autofocus": !0, value: t, onChange: (u) => a(u.target.value) }), /* @__PURE__ */ n.createElement("span", null, "~"), /* @__PURE__ */ n.createElement("input", { "aria-label": "종료일", className: "bical-input", type: "date", value: r, onChange: (u) => o(u.target.value) })), m ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, Fe(c), "(", ea(c), ") ~ ", Fe(i), "(", ea(i), ")", m.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, m.days.toLocaleString(), "일"), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", m.y, "년 ", m.m, "개월 ", m.d, "일")) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function hE() {
  const [e, t] = S("area"), [a, r] = S(Ue.area.units[0].key), [o, s] = S(Ue.area.units[4].key), [l, c] = S(""), [i, m] = S(4), [u, d] = S("half"), p = (_) => {
    t(_), r(Ue[_].units[0].key), s(Ue[_].units[1].key), c("");
  }, f = he(l), y = f ? uE(e, a, o, f, i, u) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ n.createElement("select", { "aria-label": "분류", className: "bical-select", value: e, onChange: (_) => p(_.target.value) }, Object.keys(Ue).map((_) => /* @__PURE__ */ n.createElement("option", { key: _, value: _ }, Ue[_].label))), /* @__PURE__ */ n.createElement("span", { className: "bical-sub" }, "기준 ", Ue[e].base)), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "값",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (_) => c(_.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 단위", className: "bical-select", value: a, onChange: (_) => r(_.target.value) }, Ue[e].units.map((_) => /* @__PURE__ */ n.createElement("option", { key: _.key, value: _.key }, _.label))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 단위", className: "bical-select", value: o, onChange: (_) => s(_.target.value) }, Ue[e].units.map((_) => /* @__PURE__ */ n.createElement("option", { key: _.key, value: _.key }, _.label)))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "자리수", className: "bical-select", value: i, onChange: (_) => m(Number(_.target.value)) }, mE.map((_) => /* @__PURE__ */ n.createElement("option", { key: _, value: _ }, _))), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기 방법", className: "bical-select", value: u, onChange: (_) => d(_.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, Za(e, a), " → ", Za(e, o), " · 기준단위 1단계 환산"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, y ? Ye(y, i, !0) : "—")));
}
function Za(e, t) {
  var a, r;
  return (r = (a = Ue[e].units.find((o) => o.key === t)) == null ? void 0 : a.label) != null ? r : t;
}
function gE() {
  const e = we(ma, []), [t, a] = S(Fe(e)), [r, o] = S("JPY"), [s, l] = S("KRW"), [c, i] = S(""), m = he(c), u = m ? Pr(en, m, r, s) : null, d = ta(en, r);
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ n.createElement("input", { "aria-label": "기준일자", className: "bical-input", type: "date", value: t, onChange: (p) => a(p.target.value) })), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "금액",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (p) => i(p.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 통화", className: "bical-select", value: r, onChange: (p) => o(p.target.value) }, en.map((p) => /* @__PURE__ */ n.createElement("option", { key: p.code, value: p.code }, p.code, " (", p.label, ")"))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 통화", className: "bical-select", value: s, onChange: (p) => l(p.target.value) }, en.map((p) => /* @__PURE__ */ n.createElement("option", { key: p.code, value: p.code }, p.code, " (", p.label, ")")))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, d ? Or(d) : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, u ? Ye(u.value, 2, !0) : "—")), /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("b", null, "샘플 고시입니다 — 원천 미결."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function ma() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function EE(e) {
  var t;
  return _t((t = he(String(e))) != null ? t : he("0"), 0, "half");
}
const zr = Dn(null);
function ov({ children: e }) {
  const [t, a] = S(!1), [r, o] = S("text"), [s, l] = S(null), [c, i] = S([]), [m, u] = S(0), d = we(() => ({
    open: (p) => {
      var f, y;
      o((f = p == null ? void 0 : p.tab) != null ? f : "text"), l((y = p == null ? void 0 : p.seed) != null ? y : null), u((_) => _ + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ n.createElement(zr.Provider, { value: d }, e, t && /* @__PURE__ */ n.createElement(
    _E,
    {
      key: m,
      tab: r,
      onTab: o,
      seed: s,
      onClose: d.close,
      history: c,
      onHistory: i
    }
  ));
}
function sv() {
  var e;
  return (e = xn(zr)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class lv extends er {
  constructor() {
    super(...arguments), this.rootRef = Hr(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new or(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: t, children: a, ...r } = this.props;
    return /* @__PURE__ */ n.createElement("div", { ref: this.rootRef, ...r }, a);
  }
}
export {
  $p as $,
  tv as A,
  RE as B,
  _E as C,
  FE as D,
  qE as E,
  bn as F,
  Un as G,
  F0 as H,
  x0 as I,
  D0 as J,
  aa as K,
  Y0 as L,
  B0 as M,
  L0 as N,
  q0 as O,
  s0 as P,
  ca as Q,
  l0 as R,
  Jd as S,
  u0 as T,
  j0 as U,
  wE as V,
  U0 as W,
  LE as X,
  X0 as Y,
  S0 as Z,
  T0 as _,
  Lo as a,
  Vs as a$,
  M0 as a0,
  Y_ as a1,
  C0 as a2,
  J0 as a3,
  b0 as a4,
  jE as a5,
  DE as a6,
  BE as a7,
  z_ as a8,
  Tg as a9,
  I0 as aA,
  vr as aB,
  Qd as aC,
  vg as aD,
  yr as aE,
  Kt as aF,
  lv as aG,
  or as aH,
  xr as aI,
  Bd as aJ,
  zn as aK,
  lr as aL,
  Du as aM,
  V_ as aN,
  Gn as aO,
  qc as aP,
  Ic as aQ,
  ir as aR,
  w0 as aS,
  gf as aT,
  Us as aU,
  f0 as aV,
  kg as aW,
  Js as aX,
  qf as aY,
  jo as aZ,
  $E as a_,
  CE as aa,
  SE as ab,
  AE as ac,
  JE as ad,
  GE as ae,
  YE as af,
  V0 as ag,
  ME as ah,
  $0 as ai,
  m0 as aj,
  G0 as ak,
  VE as al,
  TE as am,
  rr as an,
  Z0 as ao,
  ev as ap,
  X_ as aq,
  NE as ar,
  av as as,
  h0 as at,
  Bt as au,
  KE as av,
  i0 as aw,
  OE as ax,
  _r as ay,
  R0 as az,
  c0 as b,
  sr as b0,
  K0 as b1,
  e1 as b2,
  t1 as b3,
  Nn as b4,
  Rt as b5,
  H_ as b6,
  Jt as b7,
  Cr as b8,
  K_ as b9,
  pr as bA,
  E0 as bB,
  sv as bC,
  _0 as bD,
  Zd as bE,
  g0 as bF,
  d0 as bG,
  A0 as bH,
  UE as bI,
  rv as bJ,
  xE as bK,
  nv as bL,
  HE as bM,
  Ut as bN,
  Qp as bO,
  n0 as ba,
  ac as bb,
  WE as bc,
  J_ as bd,
  Ar as be,
  $f as bf,
  Gs as bg,
  cr as bh,
  Ys as bi,
  qo as bj,
  kf as bk,
  H0 as bl,
  Fy as bm,
  zt as bn,
  Sr as bo,
  br as bp,
  r0 as bq,
  hu as br,
  Td as bs,
  t0 as bt,
  XE as bu,
  PE as bv,
  Kl as bw,
  zE as bx,
  Jl as by,
  $r as bz,
  O0 as c,
  Ft as d,
  ov as e,
  o0 as f,
  dr as g,
  Q0 as h,
  W0 as i,
  Ka as j,
  e0 as k,
  ZE as l,
  QE as m,
  N0 as n,
  Na as o,
  a0 as p,
  P0 as q,
  Dr as r,
  Ks as s,
  k0 as t,
  v0 as u,
  p0 as v,
  y0 as w,
  z0 as x,
  IE as y,
  Ko as z
};
